import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../supabase';
import SchoolSidebar from './SchoolSidebar';
import { SchoolMobileHeader } from './SchoolMobileHeader';
import { useBranchFilter } from '../../hooks/useBranchFilter';
import './SchoolDashboard.css';
import './StudentActions.css';

function Students() {
  const navigate = useNavigate();
  const [schoolData, setSchoolData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [students, setStudents] = useState([]);
  const [loadingStudents, setLoadingStudents] = useState(true);
  const [error, setError] = useState(null);
  const { selectedBranchId, handleBranchChange, refreshTrigger } = useBranchFilter();
  const [editingStudent, setEditingStudent] = useState(null);
  const [viewingStudent, setViewingStudent] = useState(null);
  const [activeTab, setActiveTab] = useState('student');
  const [viewingSiblings, setViewingSiblings] = useState([]);
  const [viewingTeachers, setViewingTeachers] = useState([]);
  const [viewingFees, setViewingFees] = useState(null);
  const [viewingParents, setViewingParents] = useState([]);
  const [editParentDocuments, setEditParentDocuments] = useState([]);
  const [loadingViewData, setLoadingViewData] = useState(false);
  const [editForm, setEditForm] = useState({
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    phone: '',
    nationality: '',
    classId: '',
    sectionId: '',
    dateOfBirth: '',
    gender: '',
    admissionDate: '',
    previousSchool: '',
      previousSchoolGrade: '',
    studentIdNo: '',
    parents: [], // Array of parent objects
      emergencyContact: '',
      emergencyPhone: '',
      address: '',
      profilePicture: null,
      // Medical Details
      medicalDetails: '',
      emergencyDocuments: null,
      emergencyDocumentsUrl: '',
      // Transport Service
      transportServiceEnabled: false,
      pickupLocationId: '',
      transportRouteType: '', // '1 Way' or '2 Way'
      routeId: '', // Selected route ID
      // Payment Method
      paymentMethod: '',
      // Documents
      documents: [], // Array of existing documents from DB
      newDocuments: [], // Array of new documents to upload
      // Password change fields
      studentPassword: '',
      studentConfirmPassword: '',
      parentPassword: '',
      parentConfirmPassword: ''
    });
  const [editErrors, setEditErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Country code states for edit form
  const [editStudentPhoneCountryCode, setEditStudentPhoneCountryCode] = useState('+254'); // Default: Kenya
  const [editParentPhoneCountryCodes, setEditParentPhoneCountryCodes] = useState([]); // Array for multiple parents
  const [editEmergencyPhoneCountryCode, setEditEmergencyPhoneCountryCode] = useState('+254'); // Default: Kenya
  
  // Helper function to extract country code from phone number
  const extractCountryCode = (phoneNumber) => {
    if (!phoneNumber) return '+254'; // Default: Kenya
    // Common country codes to check
    const countryCodes = ['+971', '+966', '+974', '+965', '+973', '+968', '+880', '+977', '+358', '+234', '+254', '+212', '+967', '+964', '+963', '+962', '+961', '+98', '+972', '+92', '+91', '+90', '+86', '+84', '+82', '+81', '+66', '+65', '+64', '+63', '+62', '+61', '+60', '+57', '+55', '+54', '+52', '+49', '+47', '+46', '+45', '+44', '+43', '+41', '+39', '+34', '+33', '+32', '+31', '+27', '+20', '+7', '+1'];
    for (const code of countryCodes) {
      if (phoneNumber.startsWith(code)) {
        return code;
      }
    }
    return '+254'; // Default: Kenya
  };
  
  // Helper function to remove country code from phone number
  const removeCountryCode = (phoneNumber) => {
    if (!phoneNumber) return '';
    const countryCodes = ['+971', '+966', '+974', '+965', '+973', '+968', '+880', '+977', '+358', '+234', '+254', '+212', '+967', '+964', '+963', '+962', '+961', '+98', '+972', '+92', '+91', '+90', '+86', '+84', '+82', '+81', '+66', '+65', '+64', '+63', '+62', '+61', '+60', '+57', '+55', '+54', '+52', '+49', '+47', '+46', '+45', '+44', '+43', '+41', '+39', '+34', '+33', '+32', '+31', '+27', '+20', '+7', '+1'];
    for (const code of countryCodes) {
      if (phoneNumber.startsWith(code)) {
        return phoneNumber.substring(code.length).trim();
      }
    }
    return phoneNumber;
  };
  const [classes, setClasses] = useState([]);
  const [loadingClasses, setLoadingClasses] = useState(true);
  const [sections, setSections] = useState([]);
  const [loadingSections, setLoadingSections] = useState(false);
  const [siblings, setSiblings] = useState([]);
  const [loadingSiblings, setLoadingSiblings] = useState(false);
  const [teachers, setTeachers] = useState([]);
  const [loadingTeachers, setLoadingTeachers] = useState(false);
  
  // Pickup locations state
  const [pickupLocations, setPickupLocations] = useState([]);
  const [loadingPickupLocations, setLoadingPickupLocations] = useState(false);
  
  // Fees state
  const [classFees, setClassFees] = useState(null);
  const [loadingFees, setLoadingFees] = useState(false);
  
  // Filter states
  const [filters, setFilters] = useState({
    searchText: '',
    classId: '',
    sectionId: '',
    status: '',
    gender: ''
  });
  const [filterSections, setFilterSections] = useState([]);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [updatedStudentName, setUpdatedStudentName] = useState('');
  const [showArchiveConfirmPopup, setShowArchiveConfirmPopup] = useState(false);
  const [studentToArchive, setStudentToArchive] = useState(null);
  const [showArchiveSuccessPopup, setShowArchiveSuccessPopup] = useState(false);
  const [archivedStudentName, setArchivedStudentName] = useState('');
  const [viewMode, setViewMode] = useState('active'); // 'active' or 'archived'
  const [showRestoreConfirmPopup, setShowRestoreConfirmPopup] = useState(false);
  const [studentToRestore, setStudentToRestore] = useState(null);
  const [showRestoreSuccessPopup, setShowRestoreSuccessPopup] = useState(false);
  const [restoredStudentName, setRestoredStudentName] = useState('');
  const [showDeleteConfirmPopup, setShowDeleteConfirmPopup] = useState(false);
  const [studentToDelete, setStudentToDelete] = useState(null);
  const [showDeleteSuccessPopup, setShowDeleteSuccessPopup] = useState(false);
  const [deletedStudentName, setDeletedStudentName] = useState('');

  useEffect(() => {
    // Get school data from localStorage
    const storedSchoolData = localStorage.getItem('schoolData');
    if (storedSchoolData) {
      setSchoolData(JSON.parse(storedSchoolData));
    }
    setLoading(false);
  }, []);

  const fetchStudents = async (branchIdOverride = null) => {
    if (!schoolData?.id) {
      console.log('No school data available');
      return;
    }
    
    // Get the current branchId - use override, then hook value, then localStorage
    const currentBranchId = branchIdOverride !== null 
      ? branchIdOverride 
      : (selectedBranchId !== undefined 
          ? selectedBranchId 
          : (() => {
              const saved = localStorage.getItem('selectedBranchId');
              return saved && saved !== 'null' ? parseInt(saved) : null;
            })());
    
    try {
      setLoadingStudents(true);
      setError(null);
      
      console.log('Fetching students for school:', schoolData.id, 'branch:', currentBranchId, 'viewMode:', viewMode);
      
      // Build query - filter by active/inactive status based on view mode
      let query = supabase
        .from('students')
        .select('*')
        .eq('school_id', schoolData.id);
      
      // Filter by active/inactive status based on view mode
      if (viewMode === 'active') {
        query = query.eq('is_active', true);
      } else {
        query = query.eq('is_active', false);
      }
      
      // Filter by branch if one is selected
      if (currentBranchId) {
        query = query.eq('branch_id', currentBranchId);
        console.log('Filtering by branch_id:', currentBranchId);
      } else {
        console.log('Showing students from all branches');
      }
      
      const { data: studentsData, error: studentsError } = await query.order('first_name');
      
      if (studentsError) {
        console.error('Error fetching students:', studentsError);
        setError(`Failed to load students: ${studentsError.message}`);
        setStudents([]);
        return;
      }
      
      console.log('Fetched students count:', studentsData?.length || 0);
      
      // Fetch classes
      const { data: classesData, error: classesError } = await supabase
        .from('classes')
        .select('id, class_name')
        .eq('school_id', schoolData.id)
        .eq('is_active', true);
      
      if (classesError) {
        console.error('Error fetching classes:', classesError);
        setError('Failed to load classes');
        return;
      }
      
      // Create a map of class_id to class_name
      const classMap = {};
      if (classesData && Array.isArray(classesData)) {
        classesData.forEach(cls => {
          classMap[cls.id] = cls.class_name;
        });
      }
      
      // Combine students with their class names
      const studentsWithClasses = (studentsData || []).map(student => {
        const className = classMap[student.class_id] || 'No Class';
        return {
          ...student,
          class_name: className
        };
      });
      
      console.log('Setting students:', studentsWithClasses.length);
      setStudents(studentsWithClasses);
      setError(null);
      
      if (studentsWithClasses.length === 0) {
        console.warn('No students found for school:', schoolData.id, 'branch:', currentBranchId);
      }
    } catch (err) {
      console.error('Error:', err);
      setError('Failed to load students');
    } finally {
      setLoadingStudents(false);
    }
  };

  // Fetch students when schoolData, branch, or viewMode changes
  useEffect(() => {
    if (schoolData?.id) {
      fetchStudents();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schoolData?.id, selectedBranchId, viewMode, refreshTrigger]);

  // Listen for branch change events - force refresh when branch changes
  useEffect(() => {
    const handleBranchChange = (event) => {
      // Get branchId from event detail
      const branchId = event?.detail?.branchId !== undefined ? event.detail.branchId : null;
      
      // Small delay to ensure state has updated, then fetch with the new branchId
      setTimeout(() => {
        if (schoolData?.id) {
          fetchStudents(branchId);
        }
      }, 50);
    };

    window.addEventListener('branchChanged', handleBranchChange);
    return () => {
      window.removeEventListener('branchChanged', handleBranchChange);
    };
  }, [schoolData?.id]);

  useEffect(() => {
    // Fetch classes for the school
    const fetchClasses = async () => {
      if (!schoolData?.id) return;
      
      try {
        setLoadingClasses(true);
        const { data, error } = await supabase
          .from('classes')
          .select('*')
          .eq('school_id', schoolData.id)
          .eq('is_active', true)
          .order('class_name');
        
        if (error) {
          console.error('Error fetching classes:', error);
          return;
        }
        
        setClasses(data || []);
      } catch (err) {
        console.error('Error:', err);
      } finally {
        setLoadingClasses(false);
      }
    };

    if (schoolData?.id) {
      fetchClasses();
    }
  }, [schoolData?.id]);

  const handleLogout = () => {
    navigate('/schoollogin');
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString();
  };

  // Export students data to Excel (CSV format)
  const handleExportData = () => {
    if (students.length === 0) {
      alert('No students data to export.');
      return;
    }

    try {
      // Prepare data for export
      const exportData = students.map((student, index) => {
        // Get class name
        const className = student.class_name || classes.find(c => c.id === student.class_id)?.class_name || 'N/A';
        
        // Format date of birth
        const dob = student.date_of_birth ? formatDate(student.date_of_birth) : 'N/A';
        
        // Format admission date
        const admissionDate = student.admission_date ? formatDate(student.admission_date) : 'N/A';
        
        return {
          'S.No': index + 1,
          'Student ID': student.student_id_no || 'N/A',
          'First Name': student.first_name || '',
          'Middle Name': student.middle_name || '',
          'Last Name': student.last_name || '',
          'Full Name': `${student.first_name || ''} ${student.middle_name || ''} ${student.last_name || ''}`.trim(),
          'Email': student.email || 'N/A',
          'Phone': student.phone || 'N/A',
          'Date of Birth': dob,
          'Gender': student.gender || 'N/A',
          'Class': className,
          'Section': student.section_id || 'N/A',
          'Admission Date': admissionDate,
          'Nationality': student.nationality || 'N/A',
          'Address': student.address || 'N/A',
          'Parent Name': student.parent_name || 'N/A',
          'Parent Email': student.parent_email || 'N/A',
          'Parent Phone': student.parent_phone || 'N/A',
          'Parent Relationship': student.parent_relationship || 'N/A',
          'Emergency Contact': student.emergency_contact || 'N/A',
          'Emergency Phone': student.emergency_phone || 'N/A',
          'Previous School': student.previous_school || 'N/A',
          'Previous School Grade': student.previous_school_grade || 'N/A',
          'Medical Details': student.medical_details || 'N/A',
          'Transport Service': student.transport_service_enabled ? 'Yes' : 'No',
          'Payment Method': student.payment_method || 'N/A',
          'Status': student.is_active ? 'Active' : 'Inactive',
          'Approved': student.is_approved ? 'Yes' : 'No'
        };
      });

      // Convert to CSV format
      const headers = Object.keys(exportData[0]);
      const csvRows = [];
      
      // Add headers
      csvRows.push(headers.join(','));
      
      // Add data rows
      exportData.forEach(row => {
        const values = headers.map(header => {
          const value = row[header];
          // Escape commas and quotes in values
          if (value === null || value === undefined) return '';
          const stringValue = String(value);
          if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
            return `"${stringValue.replace(/"/g, '""')}"`;
          }
          return stringValue;
        });
        csvRows.push(values.join(','));
      });
      
      // Create CSV content
      const csvContent = csvRows.join('\n');
      
      // Create blob and download
      const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' }); // BOM for Excel UTF-8 support
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      
      // Generate filename with current date
      const date = new Date();
      const dateStr = date.toISOString().split('T')[0];
      const filename = `students_export_${dateStr}.csv`;
      
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      console.log(`Exported ${students.length} students to ${filename}`);
    } catch (error) {
      console.error('Error exporting data:', error);
      alert('Failed to export data. Please try again.');
    }
  };

  // Helper function to get a valid URL for a file (handles both public and private buckets)
  const getValidFileUrl = async (url) => {
    if (!url) return null;
    
    try {
      let filePath = null;
      
      // Try different URL patterns to extract the file path
      // Pattern 1: Full Supabase storage URL: https://project.supabase.co/storage/v1/object/student-images/path/to/file
      const pattern1 = url.match(/\/storage\/v1\/object\/student-images\/(.+)$/);
      if (pattern1) {
        filePath = decodeURIComponent(pattern1[1]);
      }
      
      // Pattern 2: Public URL: /storage/v1/object/public/student-images/path/to/file
      const pattern2 = url.match(/\/storage\/v1\/object\/public\/student-images\/(.+)$/);
      if (pattern2) {
        filePath = decodeURIComponent(pattern2[1]);
      }
      
      // Pattern 3: Relative path: student-images/path/to/file
      const pattern3 = url.match(/student-images\/(.+)$/);
      if (pattern3) {
        filePath = decodeURIComponent(pattern3[1]);
      }
      
      // Pattern 4: Direct path (already a path, not a URL) - remove leading slash if present
      if (!filePath && !url.includes('http') && !url.includes('://')) {
        filePath = url.startsWith('/') ? url.substring(1) : url;
        // Remove 'student-images/' prefix if it exists
        if (filePath.startsWith('student-images/')) {
          filePath = filePath.substring('student-images/'.length);
        }
      }
      
      // If we found a file path, generate a signed URL
      if (filePath) {
        console.log('Extracted file path:', filePath);
        
        // Clean the file path - remove any query parameters
        const cleanPath = filePath.split('?')[0];
        
        try {
          const { data, error } = await supabase.storage
            .from('student-images')
            .createSignedUrl(cleanPath, 3600); // Valid for 1 hour
          
          if (!error && data?.signedUrl) {
            console.log('Generated signed URL successfully:', data.signedUrl);
            return data.signedUrl;
          } else {
            console.error('Error creating signed URL:', error);
            // Try public URL as fallback
            const { data: publicData } = supabase.storage
              .from('student-images')
              .getPublicUrl(cleanPath);
            if (publicData?.publicUrl) {
              console.log('Using public URL as fallback:', publicData.publicUrl);
              return publicData.publicUrl;
            }
          }
        } catch (signError) {
          console.error('Error in createSignedUrl:', signError);
          // Try public URL as fallback
          try {
            const { data: publicData } = supabase.storage
              .from('student-images')
              .getPublicUrl(cleanPath);
            if (publicData?.publicUrl) {
              return publicData.publicUrl;
            }
          } catch (publicError) {
            console.error('Error getting public URL:', publicError);
          }
        }
      }
      
      // If all else fails, return original URL
      console.log('Using original URL:', url);
      return url;
    } catch (err) {
      console.error('Error generating signed URL:', err);
      return url; // Return original URL as fallback
    }
  };

  const handleViewStudent = async (student) => {
    // Fetch full student details including documents
    if (!schoolData?.id) return;
    
    setLoadingViewData(true);
    setActiveTab('student'); // Reset to first tab
    
    try {
      // Fetch student documents (only student documents, not parent documents)
      const { data: documentsData } = await supabase
        .from('student_documents')
        .select('*')
        .eq('student_id', student.id)
        .eq('school_id', schoolData.id)
        .is('parent_id', null) // Only fetch student documents, not parent documents
        .order('uploaded_at', { ascending: false });
      
      // Generate signed URLs for documents
      const documentsWithUrls = await Promise.all(
        (documentsData || []).map(async (doc) => {
          const validUrl = await getValidFileUrl(doc.document_url);
          return {
            ...doc,
            document_url: validUrl || doc.document_url
          };
        })
      );
      
      // Generate signed URL for emergency documents if exists
      let emergencyDocumentsUrl = null;
      if (student.emergency_documents_url) {
        emergencyDocumentsUrl = await getValidFileUrl(student.emergency_documents_url);
      }
      
      // Generate signed URL for profile picture if exists
      let profilePictureUrl = null;
      if (student.profile_picture_url) {
        try {
          profilePictureUrl = await getValidFileUrl(student.profile_picture_url);
          // If getValidFileUrl returns null or the original URL, try again with better error handling
          if (!profilePictureUrl || profilePictureUrl === student.profile_picture_url) {
            console.log('Profile picture URL not properly signed, retrying...');
            profilePictureUrl = await getValidFileUrl(student.profile_picture_url);
          }
        } catch (urlError) {
          console.error('Error generating profile picture URL:', urlError);
          profilePictureUrl = student.profile_picture_url; // Fallback to original
        }
      }
      
      // Fetch pickup location details if transport is enabled
      let pickupLocationDetails = null;
      if (student.transport_service_enabled && student.pickup_location_id) {
        const { data: locationData } = await supabase
          .from('pickup_locations')
          .select('*')
          .eq('id', student.pickup_location_id)
          .single();
        
        if (locationData) {
          // Fetch route details if route_id exists
          let routeDetails = null;
          if (student.route_id) {
            const { data: routeData } = await supabase
              .from('routes')
              .select(`
                *,
                vehicle:transport_vehicles(*)
              `)
              .eq('id', student.route_id)
              .single();
            
            routeDetails = routeData;
          }
          
          pickupLocationDetails = {
            ...locationData,
            route: routeDetails
          };
        }
      }
      
      // Fetch siblings
      if (student.parent_email) {
        const { data: siblingsData } = await supabase
          .from('students')
          .select(`
            id,
            first_name,
            middle_name,
            last_name,
            email,
            class_id,
            section_id,
            date_of_birth,
            gender,
            is_active,
            classes(class_name)
          `)
          .eq('school_id', schoolData.id)
          .eq('parent_email', student.parent_email)
          .eq('is_active', true)
          .neq('id', student.id)
          .order('first_name');
        
        setViewingSiblings(siblingsData || []);
      } else {
        setViewingSiblings([]);
      }
      
      // Fetch teachers for this class and section
      if (student.class_id && student.section_id) {
        const classId = typeof student.class_id === 'string' ? parseInt(student.class_id, 10) : student.class_id;
        const sectionId = String(student.section_id).trim();
        
        const { data: allTeachers } = await supabase
          .from('teachers')
          .select(`
            id,
            first_name,
            last_name,
            email,
            phone,
            qualification,
            subjects,
            class_ids,
            class_sections,
            is_active
          `)
          .eq('school_id', schoolData.id)
          .eq('is_active', true);
        
        // Filter teachers assigned to this class and section
        const matchingTeachers = (allTeachers || []).filter(teacher => {
          const hasClass = teacher.class_ids && Array.isArray(teacher.class_ids) && teacher.class_ids.includes(classId);
          if (!hasClass) return false;
          if (teacher.class_sections && typeof teacher.class_sections === 'object') {
            const classSections = teacher.class_sections[classId.toString()] || teacher.class_sections[classId];
            if (Array.isArray(classSections)) {
              return classSections.includes(sectionId);
            }
          }
          return false;
        });
        
        setViewingTeachers(matchingTeachers || []);
      } else {
        setViewingTeachers([]);
      }
      
      // Fetch fees information
      if (student.class_id) {
        const { data: feesData } = await supabase
          .from('class_fees')
          .select('*')
          .eq('school_id', schoolData.id)
          .eq('class_id', student.class_id)
          .single();
        
        setViewingFees(feesData);
      } else {
        setViewingFees(null);
      }
      
      // Fetch parents from parents table via student_parents junction
      let parentsData = [];
      const { data: studentParents } = await supabase
        .from('student_parents')
        .select(`
          *,
          parents:parent_id (
            id,
            name,
            email,
            phone,
            relationship,
            address,
            can_pickup,
            is_emergency_contact,
            pays_fees,
            is_primary
          )
        `)
        .eq('student_id', student.id)
        .order('is_primary', { ascending: false });
      
      if (studentParents && studentParents.length > 0) {
        parentsData = studentParents
          .map(sp => ({
            ...sp.parents,
            is_primary_for_student: sp.is_primary
          }))
          .filter(p => p !== null);
        
        // Fetch documents for each parent
        const parentsWithDocuments = await Promise.all(
          parentsData.map(async (parent) => {
            if (parent.id) {
              // Fetch parent documents
              const { data: parentDocs } = await supabase
                .from('student_documents')
                .select('*')
                .eq('student_id', student.id)
                .eq('parent_id', parent.id)
                .eq('school_id', schoolData.id)
                .order('uploaded_at', { ascending: false });
              
              // Generate signed URLs for parent documents
              const parentDocsWithUrls = await Promise.all(
                (parentDocs || []).map(async (doc) => {
                  const validUrl = await getValidFileUrl(doc.document_url);
                  return {
                    ...doc,
                    document_url: validUrl || doc.document_url
                  };
                })
              );
              
              return {
                ...parent,
                documents: parentDocsWithUrls || []
              };
            }
            return {
              ...parent,
              documents: []
            };
          })
        );
        
        parentsData = parentsWithDocuments;
      }
      
      // If no parents found in parents table, fall back to student's parent fields
      if (parentsData.length === 0 && (student.parent_name || student.parent_email)) {
        parentsData = [{
          name: student.parent_name || 'N/A',
          email: student.parent_email || 'N/A',
          phone: student.parent_phone || 'N/A',
          relationship: student.parent_relationship || 'N/A',
          address: student.parent_address || student.address || 'N/A',
          is_primary_for_student: true,
          can_pickup: student.parent_can_pickup || false,
          is_emergency_contact: student.parent_is_emergency_contact || false,
          pays_fees: student.parent_pays_fees || false,
          documents: []
        }];
      }
      
      setViewingParents(parentsData);
      
      setViewingStudent({
        ...student,
        documents: documentsWithUrls,
        emergency_documents_url: emergencyDocumentsUrl || student.emergency_documents_url,
        profile_picture_url: profilePictureUrl || student.profile_picture_url,
        pickupLocation: pickupLocationDetails
      });
    } catch (err) {
      console.error('Error fetching student details:', err);
      // Even on error, try to generate signed URLs for profile picture and emergency documents
      let fallbackProfileUrl = student.profile_picture_url;
      let fallbackEmergencyUrl = student.emergency_documents_url;
      
      if (student.profile_picture_url) {
        try {
          fallbackProfileUrl = await getValidFileUrl(student.profile_picture_url);
        } catch (urlErr) {
          console.error('Error generating profile picture URL:', urlErr);
        }
      }
      
      if (student.emergency_documents_url) {
        try {
          fallbackEmergencyUrl = await getValidFileUrl(student.emergency_documents_url);
        } catch (urlErr) {
          console.error('Error generating emergency documents URL:', urlErr);
        }
      }
      
      setViewingStudent({
        ...student,
        profile_picture_url: fallbackProfileUrl,
        emergency_documents_url: fallbackEmergencyUrl
      });
      setViewingSiblings([]);
      setViewingTeachers([]);
      setViewingFees(null);
      setViewingParents([]);
    } finally {
      setLoadingViewData(false);
    }
  };

  // Helper function to get parent label based on relationship
  const getParentLabel = (parent, parentIndex, allParents) => {
    const relationship = (parent.relationship || '').trim();
    
    if (relationship === 'Mother') {
      return 'Mother';
    } else if (relationship === 'Father') {
      return 'Father';
    } else if (relationship === 'Guardian' || relationship.toLowerCase().includes('guardian')) {
      // Count guardians up to and including this parent
      let guardianNumber = 0;
      for (let i = 0; i <= parentIndex; i++) {
        const p = allParents[i];
        const rel = (p.relationship || '').trim().toLowerCase();
        if (rel === 'guardian' || rel.includes('guardian')) {
          guardianNumber++;
        }
      }
      return `Guardian ${guardianNumber}`;
    } else {
      // Fallback: if no relationship set, use Parent X
      return `Parent ${parentIndex + 1}`;
    }
  };

  const handleEditStudent = async (student) => {
    setEditingStudent(student);
    
    // Generate signed URLs for profile picture and emergency documents
    let profilePictureUrl = student.profile_picture_url || '';
    let emergencyDocumentsUrl = student.emergency_documents_url || '';
    
    if (student.profile_picture_url) {
      try {
        profilePictureUrl = await getValidFileUrl(student.profile_picture_url) || student.profile_picture_url;
      } catch (err) {
        console.error('Error generating profile picture URL for edit:', err);
      }
    }
    
    if (student.emergency_documents_url) {
      try {
        emergencyDocumentsUrl = await getValidFileUrl(student.emergency_documents_url) || student.emergency_documents_url;
      } catch (err) {
        console.error('Error generating emergency documents URL for edit:', err);
      }
    }
    
    // Extract country codes from phone numbers
    const studentPhoneCode = extractCountryCode(student.phone || '');
    const emergencyPhoneCode = extractCountryCode(student.emergency_phone || '');
    
    setEditStudentPhoneCountryCode(studentPhoneCode);
    setEditEmergencyPhoneCountryCode(emergencyPhoneCode);
    
    // Fetch all parents for this student
    let parentsArray = [];
    let parentPhoneCodes = [];
    
    try {
      const { data: studentParents } = await supabase
        .from('student_parents')
        .select(`
          *,
          parents:parent_id (
            id,
            name,
            email,
            phone,
            relationship,
            address,
            can_pickup,
            is_emergency_contact,
            pays_fees
          )
        `)
        .eq('student_id', student.id)
        .order('is_primary', { ascending: false });
      
      if (studentParents && studentParents.length > 0) {
        parentsArray = studentParents
          .filter(sp => sp.parents !== null)
          .map((sp) => {
            const parent = sp.parents;
            const parentPhone = parent.phone || '';
            const phoneCode = extractCountryCode(parentPhone);
            parentPhoneCodes.push(phoneCode);
            
            return {
              parentId: parent.id,
              name: parent.name || '',
              email: parent.email || '',
              phone: removeCountryCode(parentPhone),
              relationship: parent.relationship || sp.relationship || '',
              primaryContact: sp.is_primary ? 'primary' : 'secondary',
              address: parent.address || sp.address || '',
              canPickup: parent.can_pickup !== undefined ? parent.can_pickup : (sp.can_pickup || false),
              isEmergencyContact: parent.is_emergency_contact !== undefined ? parent.is_emergency_contact : (sp.is_emergency_contact || false),
              paysFees: parent.pays_fees !== undefined ? parent.pays_fees : (sp.pays_fees || false),
              documents: []
            };
          });
      } else if (student.parent_email) {
        // Fallback: use student's parent fields if no parent records found
        const parentPhone = student.parent_phone || '';
        const phoneCode = extractCountryCode(parentPhone);
        parentPhoneCodes.push(phoneCode);
        
        parentsArray = [{
          parentId: null,
          name: student.parent_name || '',
          email: student.parent_email || '',
          phone: removeCountryCode(parentPhone),
          relationship: student.parent_relationship || '',
          primaryContact: student.parent_is_primary ? 'primary' : 'secondary',
          address: student.parent_address || '',
          canPickup: student.parent_can_pickup || false,
          isEmergencyContact: student.parent_is_emergency_contact || false,
          paysFees: student.parent_pays_fees || false,
          documents: []
        }];
      }
    } catch (err) {
      console.error('Error fetching parents for edit:', err);
      // Fallback to single parent from student record
      if (student.parent_email) {
        const parentPhone = student.parent_phone || '';
        const phoneCode = extractCountryCode(parentPhone);
        parentPhoneCodes.push(phoneCode);
        
        parentsArray = [{
          parentId: null,
          name: student.parent_name || '',
          email: student.parent_email || '',
          phone: removeCountryCode(parentPhone),
          relationship: student.parent_relationship || '',
          primaryContact: student.parent_is_primary ? 'primary' : 'secondary',
          address: student.parent_address || '',
          canPickup: student.parent_can_pickup || false,
          isEmergencyContact: student.parent_is_emergency_contact || false,
          paysFees: student.parent_pays_fees || false,
          documents: []
        }];
      }
    }
    
    setEditParentPhoneCountryCodes(parentPhoneCodes);
    
    setEditForm({
      firstName: student.first_name || '',
      middleName: student.middle_name || '',
      lastName: student.last_name || '',
      email: student.email || '',
      phone: removeCountryCode(student.phone || ''),
      nationality: student.nationality || '',
      classId: student.class_id ? student.class_id.toString() : '',
      sectionId: student.section_id || '',
      dateOfBirth: student.date_of_birth || '',
      gender: student.gender || '',
      admissionDate: student.admission_date || '',
      previousSchool: student.previous_school || '',
      previousSchoolGrade: student.previous_school_grade || '',
      studentIdNo: student.student_id_no || '',
      parents: parentsArray,
      emergencyContact: student.emergency_contact || '',
      emergencyPhone: removeCountryCode(student.emergency_phone || ''),
      address: student.address || '',
      profilePicture: null,
      // Medical Details
      medicalDetails: student.medical_details || '',
      emergencyDocuments: null,
      emergencyDocumentsUrl: emergencyDocumentsUrl,
      // Transport Service
      transportServiceEnabled: student.transport_service_enabled || false,
      pickupLocationId: student.pickup_location_id ? student.pickup_location_id.toString() : '',
      transportRouteType: student.transport_route_type || '',
      routeId: student.route_id ? student.route_id.toString() : '',
      // Payment Method
      paymentMethod: student.payment_method || '',
      // Documents - will be fetched separately
      documents: [],
      newDocuments: [],
      // Password fields - leave empty for security
      studentPassword: '',
      studentConfirmPassword: '',
      parentPassword: '',
      parentConfirmPassword: ''
    });
    
    // Update editingStudent with signed URLs for display
    setEditingStudent({
      ...student,
      profile_picture_url: profilePictureUrl,
      emergency_documents_url: emergencyDocumentsUrl
    });
    
    setEditErrors({});
    
    // Fetch sections for the selected class
    if (student.class_id) {
      fetchSectionsForClass(student.class_id);
    }
    
    // Fetch siblings (students with same parent_email)
    if (student.parent_email) {
      fetchSiblings(student.id, student.parent_email);
    }
    
    // Fetch teachers for this class and section
    if (student.class_id && student.section_id) {
      fetchTeachersForClassSection(student.class_id, student.section_id);
    }
    
    // Fetch student documents
    fetchStudentDocuments(student.id);
    
    // Fetch parent documents
    try {
      // Fetch parents from parents table via student_parents junction
      const { data: studentParents } = await supabase
        .from('student_parents')
        .select(`
          *,
          parents:parent_id (
            id,
            name,
            email
          )
        `)
        .eq('student_id', student.id)
        .order('is_primary', { ascending: false });
      
      let parentDocumentsList = [];
      
      if (studentParents && studentParents.length > 0) {
        // Fetch documents for each parent
        const parentsWithDocs = await Promise.all(
          studentParents
            .filter(sp => sp.parents !== null)
            .map(async (sp) => {
              const parent = sp.parents;
              if (parent.id) {
                // Fetch parent documents
                const { data: parentDocs } = await supabase
                  .from('student_documents')
                  .select('*')
                  .eq('student_id', student.id)
                  .eq('parent_id', parent.id)
                  .eq('school_id', schoolData.id)
                  .order('uploaded_at', { ascending: false });
                
                // Generate signed URLs for parent documents
                const parentDocsWithUrls = await Promise.all(
                  (parentDocs || []).map(async (doc) => {
                    const validUrl = await getValidFileUrl(doc.document_url);
                    return {
                      ...doc,
                      document_url: validUrl || doc.document_url,
                      parent_name: parent.name,
                      parent_email: parent.email
                    };
                  })
                );
                
                return {
                  parent_id: parent.id,
                  parent_name: parent.name,
                  parent_email: parent.email,
                  documents: parentDocsWithUrls || []
                };
              }
              return null;
            })
        );
        
        parentDocumentsList = parentsWithDocs.filter(p => p !== null);
      } else if (student.parent_email) {
        // Fallback: try to find documents by parent email if no parent_id
        const { data: fallbackDocs } = await supabase
          .from('student_documents')
          .select('*')
          .eq('student_id', student.id)
          .eq('school_id', schoolData.id)
          .not('parent_id', 'is', null)
          .order('uploaded_at', { ascending: false });
        
        if (fallbackDocs && fallbackDocs.length > 0) {
          const fallbackDocsWithUrls = await Promise.all(
            fallbackDocs.map(async (doc) => {
              const validUrl = await getValidFileUrl(doc.document_url);
              return {
                ...doc,
                document_url: validUrl || doc.document_url,
                parent_name: student.parent_name || 'N/A',
                parent_email: student.parent_email || 'N/A'
              };
            })
          );
          
          parentDocumentsList = [{
            parent_id: null,
            parent_name: student.parent_name || 'N/A',
            parent_email: student.parent_email || 'N/A',
            documents: fallbackDocsWithUrls
          }];
        }
      }
      
      setEditParentDocuments(parentDocumentsList);
    } catch (err) {
      console.error('Error fetching parent documents for edit:', err);
      setEditParentDocuments([]);
    }
    
    // Fetch pickup locations
    fetchPickupLocations();
    
    // Fetch class fees if class is selected
    if (student.class_id) {
      fetchClassFees(student.class_id);
    }
  };
  
  const fetchPickupLocations = async () => {
    if (!schoolData?.id) return;
    
    try {
      setLoadingPickupLocations(true);
      // Fetch pickup locations with their routes and vehicles
      const { data: locationsData, error: locationsError } = await supabase
        .from('pickup_locations')
        .select('*')
        .eq('school_id', schoolData.id)
        .eq('is_active', true)
        .order('location_name');
      
      if (locationsError) {
        console.error('Error fetching pickup locations:', locationsError);
        setPickupLocations([]);
        return;
      }
      
      // Fetch routes for each location
      const locationsWithRoutes = await Promise.all(
        (locationsData || []).map(async (location) => {
          // Get routes that include this pickup location
          const { data: routeLocationData, error: routeError } = await supabase
            .from('route_pickup_locations')
            .select('route_id')
            .eq('pickup_location_id', location.id);
          
          if (routeError || !routeLocationData || routeLocationData.length === 0) {
            return { ...location, routes: [] };
          }
          
          const routeIds = routeLocationData.map(rl => rl.route_id);
          
          // Fetch route details with vehicle information
          const { data: routesData, error: routesError } = await supabase
            .from('routes')
            .select(`
              *,
              vehicle:transport_vehicles(*)
            `)
            .in('id', routeIds)
            .eq('is_active', true);
          
          if (routesError) {
            console.error('Error fetching routes:', routesError);
            return { ...location, routes: [] };
          }
          
          return { ...location, routes: routesData || [] };
        })
      );
      
      setPickupLocations(locationsWithRoutes);
    } catch (err) {
      console.error('Error fetching pickup locations:', err);
      setPickupLocations([]);
    } finally {
      setLoadingPickupLocations(false);
    }
  };
  
  // Auto-select route when pickup location or route type changes in edit form
  useEffect(() => {
    if (editingStudent && editForm.pickupLocationId && pickupLocations.length > 0) {
      const selectedLocation = pickupLocations.find(loc => loc.id.toString() === editForm.pickupLocationId);
      if (selectedLocation && selectedLocation.routes && selectedLocation.routes.length > 0) {
        // If routeId is already set, keep it (don't override user selection)
        if (editForm.routeId) {
          // Verify the route still exists and matches
          const existingRoute = selectedLocation.routes.find(r => r.id.toString() === editForm.routeId);
          if (!existingRoute) {
            // Route no longer exists, auto-select first matching route
            let routeToSelect = null;
            if (editForm.transportRouteType) {
              const matchingRoutes = selectedLocation.routes.filter(route => {
                if (editForm.transportRouteType === '1 Way') {
                  return route.route_type === '1 Way Morning' || route.route_type === '1 Way Evening';
                } else if (editForm.transportRouteType === '2 Way') {
                  return route.route_type === '2 Way';
                }
                return false;
              });
              if (matchingRoutes.length > 0) {
                routeToSelect = matchingRoutes[0].id.toString();
              }
            } else {
              routeToSelect = selectedLocation.routes[0].id.toString();
            }
            if (routeToSelect) {
              handleEditInputChange('routeId', routeToSelect);
            }
          }
        } else {
          // No route selected, auto-select based on route type
          let routeToSelect = null;
          if (editForm.transportRouteType) {
            const matchingRoutes = selectedLocation.routes.filter(route => {
              if (editForm.transportRouteType === '1 Way') {
                return route.route_type === '1 Way Morning' || route.route_type === '1 Way Evening';
              } else if (editForm.transportRouteType === '2 Way') {
                return route.route_type === '2 Way';
              }
              return false;
            });
            if (matchingRoutes.length > 0) {
              routeToSelect = matchingRoutes[0].id.toString();
            }
          } else {
            routeToSelect = selectedLocation.routes[0].id.toString();
          }
          if (routeToSelect) {
            handleEditInputChange('routeId', routeToSelect);
          }
        }
      }
    }
  }, [editForm.pickupLocationId, editForm.transportRouteType, pickupLocations, editingStudent]);
  
  const fetchClassFees = async (classId) => {
    if (!schoolData?.id || !classId) return;
    
    try {
      setLoadingFees(true);
      const { data, error } = await supabase
        .from('class_fees')
        .select('*')
        .eq('school_id', schoolData.id)
        .eq('class_id', classId)
        .eq('is_active', true)
        .order('created_at', { ascending: false });
      
      if (error) {
        console.error('Error fetching class fees:', error);
        setClassFees(null);
        return;
      }
      
      setClassFees(data && data.length > 0 ? data : null);
    } catch (err) {
      console.error('Error fetching class fees:', err);
      setClassFees(null);
    } finally {
      setLoadingFees(false);
    }
  };
  
  const fetchStudentDocuments = async (studentId) => {
    if (!schoolData?.id || !studentId) return;
    
    try {
      const { data, error } = await supabase
        .from('student_documents')
        .select('*')
        .eq('student_id', studentId)
        .eq('school_id', schoolData.id)
        .order('uploaded_at', { ascending: false });
      
      if (error) {
        console.error('Error fetching documents:', error);
        setEditForm(prev => ({ ...prev, documents: [] }));
      } else {
        // Generate signed URLs for all documents
        const documentsWithUrls = await Promise.all(
          (data || []).map(async (doc) => {
            const validUrl = await getValidFileUrl(doc.document_url);
            return {
              ...doc,
              document_url: validUrl || doc.document_url
            };
          })
        );
        setEditForm(prev => ({ ...prev, documents: documentsWithUrls }));
      }
    } catch (err) {
      console.error('Exception fetching documents:', err);
      setEditForm(prev => ({ ...prev, documents: [] }));
    }
  };

  const fetchSiblings = async (currentStudentId, parentEmail) => {
    if (!schoolData?.id || !parentEmail) return;
    
    try {
      setLoadingSiblings(true);
      const { data, error } = await supabase
        .from('students')
        .select(`
          id,
          first_name,
          middle_name,
          last_name,
          email,
          class_id,
          section_id,
          date_of_birth,
          gender,
          is_active,
          classes(class_name)
        `)
        .eq('school_id', schoolData.id)
        .eq('parent_email', parentEmail)
        .eq('is_active', true)
        .neq('id', currentStudentId)
        .order('first_name');
      
      if (error) {
        console.error('Error fetching siblings:', error);
        setSiblings([]);
      } else {
        setSiblings(data || []);
      }
    } catch (err) {
      console.error('Error:', err);
      setSiblings([]);
    } finally {
      setLoadingSiblings(false);
    }
  };

  const fetchTeachersForClassSection = async (classId, sectionId) => {
    if (!schoolData?.id || !classId || !sectionId) return;
    
    try {
      setLoadingTeachers(true);
      // Fetch all teachers for this school
      const { data: allTeachers, error } = await supabase
        .from('teachers')
        .select(`
          id,
          first_name,
          last_name,
          email,
          phone,
          qualification,
          subjects,
          class_ids,
          class_sections,
          is_active
        `)
        .eq('school_id', schoolData.id)
        .eq('is_active', true);
      
      if (error) {
        console.error('Error fetching teachers:', error);
        setTeachers([]);
        return;
      }
      
      // Filter teachers who are assigned to this class and section
      const matchingTeachers = (allTeachers || []).filter(teacher => {
        // Check if teacher has this class in their class_ids array
        const hasClass = teacher.class_ids && Array.isArray(teacher.class_ids) && teacher.class_ids.includes(classId);
        
        if (!hasClass) return false;
        
        // Check if teacher has this section for this class in class_sections
        if (teacher.class_sections && typeof teacher.class_sections === 'object') {
          const classSections = teacher.class_sections[classId.toString()];
          if (Array.isArray(classSections)) {
            return classSections.includes(sectionId);
          }
        }
        
        return false;
      });
      
      setTeachers(matchingTeachers);
    } catch (err) {
      console.error('Error:', err);
      setTeachers([]);
    } finally {
      setLoadingTeachers(false);
    }
  };

  const handleEditInputChange = (field, value) => {
    // Update the form state immediately - ensure we always return a new object
    setEditForm(prev => {
      // Create a new object to ensure React detects the change
      const updated = {
        ...prev,
        [field]: value
      };
      
      // If class is changed, also clear sectionId
      if (field === 'classId') {
        updated.sectionId = '';
      }
      
      return updated;
    });
    
    // Clear errors when user starts typing
    if (editErrors[field]) {
      setEditErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
    
    // If class is changed, fetch sections for that class
    if (field === 'classId') {
      if (value) {
        fetchSectionsForClass(value);
      } else {
        setSections([]);
      }
      // Clear teachers when class changes (will be refetched when section is selected)
      setTeachers([]);
    }
  };

  const handleEditParentChange = (parentIndex, field, value) => {
    setEditForm(prev => {
      const updatedParents = [...prev.parents];
      if (updatedParents[parentIndex]) {
        updatedParents[parentIndex] = {
          ...updatedParents[parentIndex],
          [field]: value
        };
      }
      return {
        ...prev,
        parents: updatedParents
      };
    });
    
    // Clear errors when user starts typing
    const errorKey = `parents.${parentIndex}.${field}`;
    if (editErrors[errorKey]) {
      setEditErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[errorKey];
        return newErrors;
      });
    }
  };

  const handleAddParent = () => {
    setEditForm(prev => {
      const currentParents = prev.parents || [];
      const newParentIndex = currentParents.length;
      
      // Clear any errors related to the new parent
      setEditErrors(prevErrors => {
        const newErrors = { ...prevErrors };
        Object.keys(newErrors).forEach(key => {
          if (key.startsWith(`parents.${newParentIndex}.`)) {
            delete newErrors[key];
          }
        });
        return newErrors;
      });
      
      return {
        ...prev,
        parents: [
          ...currentParents,
          {
            parentId: null,
            name: '',
            email: '',
            phone: '',
            relationship: '',
            primaryContact: 'secondary',
            address: '',
            canPickup: false,
            isEmergencyContact: false,
            paysFees: false,
            documents: []
          }
        ]
      };
    });
    setEditParentPhoneCountryCodes(prev => [...(prev || []), '+254']); // Default: Kenya
  };

  const handleRemoveParent = (parentIndex) => {
    if (editForm.parents.length <= 1) {
      alert('At least one parent is required.');
      return;
    }
    
    setEditForm(prev => ({
      ...prev,
      parents: prev.parents.filter((_, i) => i !== parentIndex)
    }));
    
    setEditParentPhoneCountryCodes(prev => prev.filter((_, i) => i !== parentIndex));
    
    // Clear errors for removed parent
    setEditErrors(prev => {
      const newErrors = { ...prev };
      Object.keys(newErrors).forEach(key => {
        if (key.startsWith(`parents.${parentIndex}.`)) {
          delete newErrors[key];
        }
        // Shift errors for parents after the removed one
        const match = key.match(/^parents\.(\d+)\.(.+)$/);
        if (match) {
          const index = parseInt(match[1]);
          if (index > parentIndex) {
            const newKey = `parents.${index - 1}.${match[2]}`;
            newErrors[newKey] = newErrors[key];
            delete newErrors[key];
          }
        }
      });
      return newErrors;
    });
  };

  const fetchFilterSections = async (classId) => {
    if (!classId) {
      setFilterSections([]);
      return;
    }

    try {
      // Get sections from the classes table (sections stored as JSON array)
      const { data: classData, error: classError } = await supabase
        .from('classes')
        .select('sections')
        .eq('id', classId)
        .single();

      if (classError) {
        console.error('Error fetching class sections:', classError);
        // Fallback: Get sections from students
        const { data: studentsData } = await supabase
          .from('students')
          .select('section_id')
          .eq('school_id', schoolData.id)
          .eq('class_id', classId)
          .not('section_id', 'is', null);

        if (studentsData && studentsData.length > 0) {
          const uniqueSectionIds = [...new Set(studentsData.map(s => s.section_id))].sort();
          const sectionObjects = uniqueSectionIds.map((sectionId) => ({
            id: sectionId,
            section_name: typeof sectionId === 'string' ? sectionId : `Section ${sectionId}`,
            class_id: classId
          }));
          setFilterSections(sectionObjects);
        } else {
          setFilterSections([]);
        }
        return;
      }

      if (classData && classData.sections && Array.isArray(classData.sections)) {
        const sectionObjects = classData.sections
          .filter(section => section && section.trim() !== '')
          .map((section) => ({
            id: section,
            section_name: section,
            class_id: classId
          }));
        setFilterSections(sectionObjects);
      } else {
        // If no sections in class, try getting from students
        const { data: studentsData } = await supabase
          .from('students')
          .select('section_id')
          .eq('school_id', schoolData.id)
          .eq('class_id', classId)
          .not('section_id', 'is', null);

        if (studentsData && studentsData.length > 0) {
          const uniqueSectionIds = [...new Set(studentsData.map(s => s.section_id))].sort();
          const sectionObjects = uniqueSectionIds.map((sectionId) => ({
            id: sectionId,
            section_name: typeof sectionId === 'string' ? sectionId : `Section ${sectionId}`,
            class_id: classId
          }));
          setFilterSections(sectionObjects);
        } else {
          setFilterSections([]);
        }
      }
    } catch (err) {
      console.error('Error fetching filter sections:', err);
      setFilterSections([]);
    }
  };

  const fetchSectionsForClass = async (classId) => {
    try {
      setLoadingSections(true);
      const { data, error } = await supabase
        .from('classes')
        .select('sections')
        .eq('id', classId)
        .single();
      
      if (error) {
        console.error('Error fetching sections:', error);
        setSections([]);
        return;
      }
      
      if (data && data.sections && Array.isArray(data.sections)) {
        setSections(data.sections.filter(section => section.trim() !== ''));
      } else {
        setSections([]);
      }
    } catch (err) {
      console.error('Error:', err);
      setSections([]);
    } finally {
      setLoadingSections(false);
    }
  };

  const handleEditFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        setEditErrors(prev => ({
          ...prev,
          profilePicture: 'Please select a valid image file'
        }));
        return;
      }
      
      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        setEditErrors(prev => ({
          ...prev,
          profilePicture: 'File size must be less than 5MB'
        }));
        return;
      }
      
      setEditForm(prev => ({
        ...prev,
        profilePicture: file
      }));
      
      // Clear error
      if (editErrors.profilePicture) {
        setEditErrors(prev => ({
          ...prev,
          profilePicture: ''
        }));
      }
    }
  };

  const handleEditEmergencyDocumentsChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file size (max 10MB for documents)
      if (file.size > 10 * 1024 * 1024) {
        setEditErrors(prev => ({
          ...prev,
          emergencyDocuments: 'File size must be less than 10MB'
        }));
        return;
      }
      
      setEditForm(prev => ({
        ...prev,
        emergencyDocuments: file
      }));
      
      // Clear error
      if (editErrors.emergencyDocuments) {
        setEditErrors(prev => ({
          ...prev,
          emergencyDocuments: ''
        }));
      }
    }
  };

  const handleEditDocumentAdd = (documentType, file) => {
    if (!file || !documentType) return;
    
    // Validate file size (max 10MB per document)
    if (file.size > 10 * 1024 * 1024) {
      alert(`File size must be less than 10MB for ${documentType}`);
      return;
    }
    
    setEditForm(prev => ({
      ...prev,
      newDocuments: [...prev.newDocuments, { type: documentType, file: file }]
    }));
  };

  const handleEditDocumentRemove = (index, isNew = false) => {
    if (isNew) {
      setEditForm(prev => ({
        ...prev,
        newDocuments: prev.newDocuments.filter((_, i) => i !== index)
      }));
    } else {
      // Remove from existing documents
      setEditForm(prev => ({
        ...prev,
        documents: prev.documents.filter((_, i) => i !== index)
      }));
    }
  };

  const handleEditDocumentTypeChange = (index, newType, isNew = false) => {
    if (isNew) {
      setEditForm(prev => ({
        ...prev,
        newDocuments: prev.newDocuments.map((doc, i) => 
          i === index ? { ...doc, type: newType } : doc
        )
      }));
    }
  };

  const validateEditForm = () => {
    const errors = {};
    
    if (!editForm.firstName.trim()) {
      errors.firstName = 'First name is required';
    }
    
    if (!editForm.lastName.trim()) {
      errors.lastName = 'Last name is required';
    }
    
    if (!editForm.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(editForm.email)) {
      errors.email = 'Email is invalid';
    }
    
    // Class and Section are now optional - no validation needed
    
    if (!editForm.dateOfBirth) {
      errors.dateOfBirth = 'Date of birth is required';
    }
    
    if (!editForm.gender.trim()) {
      errors.gender = 'Gender is required';
    }
    
    if (!editForm.nationality.trim()) {
      errors.nationality = 'Nationality is required';
    }
    
    if (!editForm.phone.trim()) {
      errors.phone = 'Student phone is required';
    }
    
    if (!editForm.admissionDate) {
      errors.admissionDate = 'Admission date is required';
    }
    
    // Validate parents array
    if (!editForm.parents || editForm.parents.length === 0) {
      errors.parents = 'At least one parent is required';
    } else {
      editForm.parents.forEach((parent, index) => {
        if (!parent.name || !parent.name.trim()) {
          errors[`parents.${index}.name`] = 'Parent name is required';
        }
        
        if (!parent.relationship || !parent.relationship.trim()) {
          errors[`parents.${index}.relationship`] = 'Relationship is required';
        }
        
        if (!parent.email || !parent.email.trim()) {
          errors[`parents.${index}.email`] = 'Parent email is required';
        } else if (!/\S+@\S+\.\S+/.test(parent.email)) {
          errors[`parents.${index}.email`] = 'Parent email is invalid';
        }
        
        if (!parent.phone || !parent.phone.trim()) {
          errors[`parents.${index}.phone`] = 'Parent phone is required';
        }
      });
    }
    
    if (!editForm.emergencyContact.trim()) {
      errors.emergencyContact = 'Emergency contact is required';
    }
    
    if (!editForm.emergencyPhone.trim()) {
      errors.emergencyPhone = 'Emergency phone is required';
    }
    
    if (!editForm.address.trim()) {
      errors.address = 'Address is required';
    }
    
    // Password validation (only if passwords are provided)
    if (editForm.studentPassword && editForm.studentPassword !== editForm.studentConfirmPassword) {
      errors.studentConfirmPassword = 'Student passwords do not match';
    }
    
    if (editForm.parentPassword && editForm.parentPassword !== editForm.parentConfirmPassword) {
      errors.parentConfirmPassword = 'Parent passwords do not match';
    }
    
    // Transport service validation
    if (editForm.transportServiceEnabled) {
      if (!editForm.pickupLocationId) {
        errors.pickupLocationId = 'Pickup location is required when transport service is enabled';
      }
      
      if (editForm.pickupLocationId && !editForm.transportRouteType) {
        errors.transportRouteType = 'Route type is required when transport service is enabled';
      }
      
      if (editForm.pickupLocationId && editForm.transportRouteType && !editForm.routeId) {
        errors.routeId = 'Please select a route';
      }
    }
    
    setEditErrors(errors);
    return { isValid: Object.keys(errors).length === 0, errors };
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    console.log('Edit form submitted', { editForm, editingStudent });
    
    // Validate form and show errors if validation fails
    const validation = validateEditForm();
    console.log('Validation result:', validation);
    if (!validation.isValid) {
      // Scroll to first error field
      const firstErrorField = Object.keys(validation.errors)[0];
      if (firstErrorField) {
        // Try to find the input field by name or id
        let errorElement = document.querySelector(`[name="${firstErrorField}"]`);
        if (!errorElement) {
          // Try with edit prefix and capitalized first letter
          const fieldId = `edit${firstErrorField.charAt(0).toUpperCase() + firstErrorField.slice(1)}`;
          errorElement = document.getElementById(fieldId);
        }
        if (errorElement) {
          setTimeout(() => {
            errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            errorElement.focus();
          }, 100);
        }
      }
      // Show alert with validation errors (limit to first 5 errors to avoid overwhelming)
      const errorMessages = Object.values(validation.errors).filter(msg => msg).slice(0, 5);
      if (errorMessages.length > 0) {
        const errorText = errorMessages.length > 5 
          ? errorMessages.join('\n') + '\n\n...and more errors. Please check all fields.'
          : errorMessages.join('\n');
        alert('Please fix the following errors:\n\n' + errorText);
      }
      return;
    }
    
    setIsSubmitting(true);
    console.log('Starting student update...');
    
    try {
      let profilePictureUrl = editingStudent.profile_picture_url; // Keep existing URL by default
      let emergencyDocumentsUrl = editForm.emergencyDocumentsUrl; // Keep existing URL by default
      
      // Upload new emergency documents if provided
      if (editForm.emergencyDocuments) {
        try {
          const fileExt = editForm.emergencyDocuments.name.split('.').pop();
          const fileName = `emergency_docs_${Date.now()}_${Math.random().toString(36).substring(2)}.${fileExt}`;
          const filePath = `emergency-documents/${schoolData.id}/${fileName}`;
          
          const { data: uploadData, error: uploadError } = await supabase.storage
            .from('student-images')
            .upload(filePath, editForm.emergencyDocuments, {
              cacheControl: '3600',
              upsert: false
            });
          
          if (uploadError) {
            console.error('Emergency documents upload error:', uploadError);
            alert('Failed to upload emergency documents. Please try again.');
            setIsSubmitting(false);
            return;
          }
          
          const { data: { publicUrl } } = supabase.storage
            .from('student-images')
            .getPublicUrl(filePath);
          
          emergencyDocumentsUrl = publicUrl;
        } catch (uploadErr) {
          console.error('Emergency documents upload exception:', uploadErr);
          alert('Failed to upload emergency documents. Please try again.');
          setIsSubmitting(false);
          return;
        }
      }
      
      // Upload new profile picture if provided
      if (editForm.profilePicture) {
        try {
          const fileExt = editForm.profilePicture.name.split('.').pop();
          const fileName = `${Date.now()}_${Math.random().toString(36).substring(2)}.${fileExt}`;
          const filePath = `student-profiles/${schoolData.id}/${fileName}`;
          
          console.log('Uploading file:', {
            fileName,
            filePath,
            fileSize: editForm.profilePicture.size,
            fileType: editForm.profilePicture.type
          });
          
          const { data: uploadData, error: uploadError } = await supabase.storage
            .from('student-images')
            .upload(filePath, editForm.profilePicture, {
              cacheControl: '3600',
              upsert: false
            });
          
          if (uploadError) {
            console.error('Upload error details:', uploadError);
            console.error('Upload error message:', uploadError.message);
            console.error('Upload error status:', uploadError.statusCode);
            
            // Check if it's a bucket issue
            if (uploadError.message.includes('bucket') || uploadError.message.includes('not found')) {
              alert('Storage bucket not found. Please contact administrator to set up the student-images bucket.');
            } else if (uploadError.message.includes('permission') || uploadError.message.includes('unauthorized')) {
              alert('Permission denied. Please contact administrator to check storage permissions.');
            } else {
              alert(`Failed to upload profile picture: ${uploadError.message}`);
            }
            setIsSubmitting(false);
            return;
          }
          
          console.log('Upload successful:', uploadData);
          
          // Get public URL
          const { data: { publicUrl } } = supabase.storage
            .from('student-images')
            .getPublicUrl(filePath);
          
          profilePictureUrl = publicUrl;
          console.log('Public URL generated:', publicUrl);
          
        } catch (uploadErr) {
          console.error('Upload exception:', uploadErr);
          alert('Failed to upload profile picture. Please try again.');
          setIsSubmitting(false);
          return;
        }
      }
      
      const updateData = {
        branch_id: selectedBranchId || null, // Update branch_id if a branch is selected
        first_name: editForm.firstName.trim(),
        middle_name: editForm.middleName.trim() || null,
        last_name: editForm.lastName.trim(),
        email: editForm.email.trim(),
        phone: editForm.phone.trim() ? `${editStudentPhoneCountryCode} ${editForm.phone.trim()}` : '',
        nationality: editForm.nationality.trim() || null,
        class_id: editForm.classId || null,
        section_id: editForm.sectionId.trim() || null,
        date_of_birth: editForm.dateOfBirth,
        gender: editForm.gender.trim(),
        admission_date: editForm.admissionDate,
        previous_school: editForm.previousSchool.trim() || null,
    previous_school_grade: editForm.previousSchoolGrade.trim() || null,
        student_id_no: editForm.studentIdNo.trim() || null,
        // Legacy parent fields - use first parent's data for backward compatibility
        parent_name: editForm.parents && editForm.parents.length > 0 ? editForm.parents[0].name.trim() : '',
        parent_email: editForm.parents && editForm.parents.length > 0 ? editForm.parents[0].email.trim() : '',
        parent_phone: editForm.parents && editForm.parents.length > 0 && editForm.parents[0].phone.trim() 
          ? `${(editParentPhoneCountryCodes && editParentPhoneCountryCodes[0]) || '+254'} ${editForm.parents[0].phone.trim()}` : '',
        parent_relationship: editForm.parents && editForm.parents.length > 0 ? editForm.parents[0].relationship.trim() || null : null,
        parent_is_primary: editForm.parents && editForm.parents.length > 0 ? editForm.parents[0].primaryContact === 'primary' : false,
        parent_address: editForm.parents && editForm.parents.length > 0 ? editForm.parents[0].address.trim() || null : null,
        parent_can_pickup: editForm.parents && editForm.parents.length > 0 ? !!editForm.parents[0].canPickup : false,
        parent_is_emergency_contact: editForm.parents && editForm.parents.length > 0 ? !!editForm.parents[0].isEmergencyContact : false,
        parent_pays_fees: editForm.parents && editForm.parents.length > 0 ? !!editForm.parents[0].paysFees : false,
        emergency_contact: editForm.emergencyContact.trim(),
        emergency_phone: editForm.emergencyPhone.trim() ? `${editEmergencyPhoneCountryCode} ${editForm.emergencyPhone.trim()}` : '',
        address: editForm.address.trim(),
        profile_picture_url: profilePictureUrl,
        // Medical Details
        medical_details: editForm.medicalDetails.trim() || null,
        emergency_documents_url: emergencyDocumentsUrl,
        // Transport Service
        transport_service_enabled: !!editForm.transportServiceEnabled,
        pickup_location_id: editForm.transportServiceEnabled && editForm.pickupLocationId ? parseInt(editForm.pickupLocationId) : null,
        transport_route_type: editForm.transportServiceEnabled && editForm.transportRouteType ? editForm.transportRouteType : null,
        route_id: editForm.transportServiceEnabled && editForm.routeId ? parseInt(editForm.routeId) : null,
        transport_price: editForm.transportServiceEnabled && editForm.pickupLocationId && editForm.transportRouteType ? (() => {
          const selectedLocation = pickupLocations.find(loc => loc.id.toString() === editForm.pickupLocationId);
          if (selectedLocation) {
            if (editForm.transportRouteType === '1 Way' && selectedLocation.price_one_way) {
              return parseFloat(selectedLocation.price_one_way);
            } else if (editForm.transportRouteType === '2 Way' && selectedLocation.price_two_way) {
              return parseFloat(selectedLocation.price_two_way);
            }
          }
          return null;
        })() : null,
        // Payment Method
        payment_method: editForm.paymentMethod.trim() || null,
        updated_at: new Date().toISOString()
      };
      
      console.log('Updating student data:', updateData);
      
      const { error } = await supabase
        .from('students')
        .update(updateData)
        .eq('id', editingStudent.id);
      
      if (error) {
        console.error('Error updating student:', error);
        alert('Failed to update student: ' + (error.message || 'Please try again.'));
        setIsSubmitting(false);
        return;
      }
      
      // Update parents in parents table and student_parents junction table
      if (editForm.parents && editForm.parents.length > 0) {
        try {
          // First, remove all existing parent relationships for this student
          await supabase
            .from('student_parents')
            .delete()
            .eq('student_id', editingStudent.id);
          
          // Process each parent
          for (let i = 0; i < editForm.parents.length; i++) {
            const parent = editForm.parents[i];
            const phoneCode = (editParentPhoneCountryCodes && editParentPhoneCountryCodes[i]) || '+254'; // Default: Kenya
            const fullPhone = parent.phone.trim() ? `${phoneCode} ${parent.phone.trim()}`.trim() : null;
            
            // Check if parent already exists
            let parentId = parent.parentId;
            
            if (!parentId) {
              // Check if parent exists by email
              const { data: existingParent } = await supabase
                .from('parents')
                .select('id')
                .eq('email', parent.email.trim())
                .eq('school_id', schoolData.id)
                .single();
              
              if (existingParent) {
                parentId = existingParent.id;
                // Update existing parent
                await supabase
                  .from('parents')
                  .update({
                    name: parent.name.trim(),
                    phone: fullPhone,
                    relationship: parent.relationship.trim() || null,
                    address: parent.address.trim() || null,
                    can_pickup: !!parent.canPickup,
                    is_emergency_contact: !!parent.isEmergencyContact,
                    pays_fees: !!parent.paysFees,
                    branch_id: selectedBranchId || null
                  })
                  .eq('id', parentId);
              } else {
                // Create new parent (without auth user for now - can be added later if needed)
                const { data: newParent, error: parentError } = await supabase
                  .from('parents')
                  .insert({
                    school_id: schoolData.id,
                    name: parent.name.trim(),
                    email: parent.email.trim(),
                    phone: fullPhone,
                    relationship: parent.relationship.trim() || null,
                    address: parent.address.trim() || null,
                    can_pickup: !!parent.canPickup,
                    is_emergency_contact: !!parent.isEmergencyContact,
                    pays_fees: !!parent.paysFees,
                    branch_id: selectedBranchId || null
                  })
                  .select('id')
                  .single();
                
                if (parentError) {
                  console.error(`Error creating parent ${i + 1}:`, parentError);
                } else {
                  parentId = newParent.id;
                }
              }
            } else {
              // Update existing parent
              await supabase
                .from('parents')
                .update({
                  name: parent.name.trim(),
                  phone: fullPhone,
                  relationship: parent.relationship.trim() || null,
                  address: parent.address.trim() || null,
                  can_pickup: !!parent.canPickup,
                  is_emergency_contact: !!parent.isEmergencyContact,
                  pays_fees: !!parent.paysFees,
                  branch_id: selectedBranchId || null
                })
                .eq('id', parentId);
            }
            
            // Create/update student_parents relationship
            if (parentId) {
              await supabase
                .from('student_parents')
                .insert({
                  student_id: editingStudent.id,
                  parent_id: parentId,
                  is_primary: parent.primaryContact === 'primary',
                  can_pickup: !!parent.canPickup,
                  is_emergency_contact: !!parent.isEmergencyContact,
                  pays_fees: !!parent.paysFees
                });
            }
          }
        } catch (parentErr) {
          console.error('Error updating parents:', parentErr);
          // Don't fail the whole update if parent update fails
        }
      }
      
      // Upload new documents if any
      if (editForm.newDocuments && editForm.newDocuments.length > 0) {
        try {
          const documentRecords = [];
          for (const doc of editForm.newDocuments) {
            if (doc.file) {
              const fileExt = doc.file.name.split('.').pop();
              const fileName = `${doc.type.replace(/\s+/g, '_')}_${Date.now()}_${Math.random().toString(36).substring(2)}.${fileExt}`;
              const filePath = `student-documents/${schoolData.id}/${fileName}`;
              
              const { error: uploadError } = await supabase.storage
                .from('student-images')
                .upload(filePath, doc.file);
              
              if (uploadError) {
                console.error('Document upload error:', uploadError);
                console.error('File path:', filePath);
                console.error('File name:', doc.file.name);
                console.error('File size:', doc.file.size);
                console.error('Bucket:', 'student-images');
                alert(`Failed to upload ${doc.type}. Error: ${uploadError.message || JSON.stringify(uploadError)}. Please check console for details.`);
                setIsSubmitting(false);
                return;
              }
              
              // Get public URL
              const { data: { publicUrl } } = supabase.storage
                .from('student-images')
                .getPublicUrl(filePath);
              
              documentRecords.push({
                student_id: editingStudent.id,
                school_id: schoolData.id,
                document_type: doc.type,
                document_url: publicUrl,
                file_name: doc.file.name,
                file_size: doc.file.size
              });
            }
          }
          
          if (documentRecords.length > 0) {
            const { error: docError } = await supabase
              .from('student_documents')
              .insert(documentRecords);
            
            if (docError) {
              console.error('Error saving new documents:', docError);
            } else {
              console.log('New documents saved successfully');
            }
          }
        } catch (docErr) {
          console.error('Exception saving new documents:', docErr);
        }
      }
      
      // Update student password if provided (using direct database update with Base64 encoding)
      if (editForm.studentPassword && editForm.studentPassword.trim() !== '') {
        try {
          console.log('Updating student password...');
          
          // Validate password confirmation
          if (editForm.studentPassword !== editForm.studentConfirmPassword) {
            alert('Password and confirm password do not match.');
            setIsSubmitting(false);
            return;
          }
          
          // Hash password using Base64 encoding (same as teachers)
          const hashedPassword = btoa(editForm.studentPassword.trim());
          
          // Update password_hash directly in students table
          const { error: passwordError } = await supabase
            .from('students')
            .update({ password_hash: hashedPassword })
            .eq('id', editingStudent.id);
          
          if (passwordError) {
            console.error('Failed to update student password:', passwordError);
            console.error('Error details:', {
              code: passwordError.code,
              message: passwordError.message,
              details: passwordError.details,
              hint: passwordError.hint
            });
            alert(`Failed to update student password: ${passwordError.message || 'Please check if password_hash column exists in students table.'}`);
          } else {
            console.log('Student password updated successfully');
          }
        } catch (passwordErr) {
          console.error('Error updating student password:', passwordErr);
          alert(`Failed to update student password: ${passwordErr.message || 'Please try again.'}`);
        }
      }
      
      // Note: Parent password update would need to be handled per parent if needed
      // For now, keeping the single parent password field for backward compatibility
      // This can be enhanced later to support per-parent passwords
      
      console.log('Student updated successfully');
      
      // Update the students list with the new updated_at timestamp
      const updatedStudentData = { ...updateData, updated_at: updateData.updated_at };
      setStudents(prev => prev.map(student => 
        student.id === editingStudent.id 
          ? { ...student, ...updatedStudentData }
          : student
      ));
      
      // Update editingStudent with new timestamp before closing (for immediate display if needed)
      setEditingStudent(prev => prev ? { ...prev, ...updatedStudentData } : null);
      
      // Close popup
      setEditingStudent(null);
      setEditForm({
        firstName: '',
        lastName: '',
        email: '',
        classId: '',
        sectionId: '',
        dateOfBirth: '',
        gender: '',
        admissionDate: '',
        parents: [],
        emergencyContact: '',
        emergencyPhone: '',
        address: '',
        profilePicture: null,
        studentPassword: '',
        studentConfirmPassword: '',
        parentPassword: '',
        parentConfirmPassword: ''
      });
      setEditParentPhoneCountryCodes([]);
      setSections([]);
      setEditErrors({});
      
      // Show beautiful success popup
      const studentFullName = `${editForm.firstName} ${editForm.middleName ? editForm.middleName + ' ' : ''}${editForm.lastName}`.trim();
      setUpdatedStudentName(studentFullName);
      setShowSuccessPopup(true);
      
      // Auto close after 3 seconds
      setTimeout(() => {
        setShowSuccessPopup(false);
      }, 3000);
      
    } catch (err) {
      console.error('Error:', err);
      alert('Failed to update student. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const [activeEditTab, setActiveEditTab] = useState('personal');
  
  const closeEditPopup = () => {
    setEditingStudent(null);
    setActiveEditTab('personal'); // Reset to first tab when closing
    setEditParentDocuments([]);
    setSiblings([]);
    setTeachers([]);
    setEditForm(prev => ({ ...prev, documents: [], newDocuments: [] }));
    setEditForm({
      firstName: '',
      lastName: '',
      email: '',
      parents: [],
      classId: '',
      sectionId: '',
      dateOfBirth: '',
      gender: '',
      admissionDate: '',
      emergencyContact: '',
      emergencyPhone: '',
      address: '',
      profilePicture: null
    });
    setEditParentPhoneCountryCodes([]);
    setSections([]);
    setEditErrors({});
  };

  const handleDeleteStudent = (student) => {
    setStudentToDelete(student);
    setShowDeleteConfirmPopup(true);
  };

  const confirmDeleteStudent = async () => {
    if (!studentToDelete) return;

    setIsSubmitting(true);
    try {
      console.log('Permanently deleting student:', studentToDelete.id);
      
      // First, delete the auth user if it exists
      if (studentToDelete.auth_user_id) {
        try {
          console.log('Deleting auth user:', studentToDelete.auth_user_id);
          const { error: authError } = await supabase.auth.admin.deleteUser(studentToDelete.auth_user_id);
          if (authError) {
            console.warn('Could not delete auth user (may not exist):', authError);
          } else {
            console.log('Auth user deleted successfully');
          }
        } catch (authErr) {
          console.warn('Error deleting auth user:', authErr);
          // Continue with student deletion even if auth user deletion fails
        }
      }
      
      // Delete the student record completely from the database
      const { error } = await supabase
        .from('students')
        .delete()
        .eq('id', studentToDelete.id);
      
      if (error) {
        console.error('Error deleting student:', error);
        alert('Failed to delete student. Please try again.');
        setIsSubmitting(false);
        setShowDeleteConfirmPopup(false);
        setStudentToDelete(null);
        return;
      }
      
      console.log('Student permanently deleted from database');
      
      // Store deleted student name for success popup
      const deletedName = `${studentToDelete.first_name} ${studentToDelete.last_name}`;
      
      // Remove from the students list
      setStudents(prev => prev.filter(s => s.id !== studentToDelete.id));
      setShowDeleteConfirmPopup(false);
      setStudentToDelete(null);
      
      // Show success popup
      setDeletedStudentName(deletedName);
      setShowDeleteSuccessPopup(true);
    } catch (err) {
      console.error('Error:', err);
      alert('Failed to delete student. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const cancelDeleteStudent = () => {
    setShowDeleteConfirmPopup(false);
    setStudentToDelete(null);
  };

  const handleArchiveStudent = (student) => {
    setStudentToArchive(student);
    setShowArchiveConfirmPopup(true);
  };

  const confirmArchiveStudent = async () => {
    if (!studentToArchive) return;

    setIsSubmitting(true);
    try {
      const { error } = await supabase
        .from('students')
        .update({ is_active: false, updated_at: new Date().toISOString() })
        .eq('id', studentToArchive.id);

      if (error) {
        console.error('Error archiving student:', error);
        alert('Failed to archive student. Please try again.');
        setIsSubmitting(false);
        setShowArchiveConfirmPopup(false);
        setStudentToArchive(null);
        return;
      }

      // Store archived student name for success popup
      const archivedName = `${studentToArchive.first_name} ${studentToArchive.last_name}`;
      
      // Update the students list
      setStudents(prev => prev.filter(s => s.id !== studentToArchive.id));
      setShowArchiveConfirmPopup(false);
      setStudentToArchive(null);
      
      // Show success popup
      setArchivedStudentName(archivedName);
      setShowArchiveSuccessPopup(true);
    } catch (err) {
      console.error('Error archiving student:', err);
      alert('Failed to archive student. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const cancelArchiveStudent = () => {
    setShowArchiveConfirmPopup(false);
    setStudentToArchive(null);
  };

  const handleRestoreStudent = (student) => {
    setStudentToRestore(student);
    setShowRestoreConfirmPopup(true);
  };

  const confirmRestoreStudent = async () => {
    if (!studentToRestore) return;

    setIsSubmitting(true);
    try {
      const { error } = await supabase
        .from('students')
        .update({ is_active: true, updated_at: new Date().toISOString() })
        .eq('id', studentToRestore.id);

      if (error) {
        console.error('Error restoring student:', error);
        alert('Failed to restore student. Please try again.');
        setIsSubmitting(false);
        setShowRestoreConfirmPopup(false);
        setStudentToRestore(null);
        return;
      }

      // Store restored student name for success popup
      const restoredName = `${studentToRestore.first_name} ${studentToRestore.last_name}`;
      
      // Update the students list
      setStudents(prev => prev.filter(s => s.id !== studentToRestore.id));
      setShowRestoreConfirmPopup(false);
      setStudentToRestore(null);
      
      // Show success popup
      setRestoredStudentName(restoredName);
      setShowRestoreSuccessPopup(true);
    } catch (err) {
      console.error('Error restoring student:', err);
      alert('Failed to restore student. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const cancelRestoreStudent = () => {
    setShowRestoreConfirmPopup(false);
    setStudentToRestore(null);
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">⏳</div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!schoolData) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">❌</div>
        <p>School data not found. Please login again.</p>
        <button onClick={() => navigate('/schoollogin')} className="submit-btn">
          Go to Login
        </button>
      </div>
    );
  }

  return (
    <div className="school-dashboard">
      <SchoolMobileHeader 
        schoolData={schoolData} 
        mobileMenuOpen={mobileMenuOpen} 
        setMobileMenuOpen={setMobileMenuOpen} 
        handleLogout={handleLogout} 
      />
      
      {/* Sidebar */}
      <SchoolSidebar schoolData={schoolData} onLogout={handleLogout} />

      {/* Main Content */}
      <div className="main-content">
        <div className="students-content">
          <div className="students-header">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
              <div>
                <h1>Students Management</h1>
                <p>View and manage all students in your school</p>
              </div>
            </div>
          </div>

          <div className="students-stats" style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(3, 1fr)', 
            gap: '1.5rem',
            marginBottom: '2rem',
            padding: '1.5rem',
            background: '#FFFFFF',
            borderRadius: '8px',
            border: '1px solid #e9ecef'
          }}>
            <div className="stat-item" style={{ textAlign: 'center', width: 'auto' }}>
              <span className="stat-number">{students.length}</span>
              <span className="stat-label">Total Students</span>
            </div>
            <div className="stat-item" style={{ textAlign: 'center', width: 'auto' }}>
              <span className="stat-number">
                {students.filter(student => student.gender === 'Male').length}
              </span>
              <span className="stat-label">Male Students</span>
            </div>
            <div className="stat-item" style={{ textAlign: 'center', width: 'auto' }}>
              <span className="stat-number">
                {students.filter(student => student.gender === 'Female').length}
              </span>
              <span className="stat-label">Female Students</span>
            </div>
          </div>

          <div className="students-actions" style={{ display: 'flex', gap: '1rem', alignItems: 'center', flexWrap: 'wrap' }}>
            <button 
              className="add-student-btn"
              onClick={() => navigate('/school/add-student')}
            >
              ➕ Add New Student
            </button>
            <button 
              className="export-data-btn"
              onClick={handleExportData}
              disabled={students.length === 0}
              style={{
                padding: '0.875rem 1.5rem',
                background: students.length === 0 ? '#D1D5DB' : '#10B981',
                color: '#FFFFFF',
                border: 'none',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: students.length === 0 ? 'not-allowed' : 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: students.length === 0 ? 'none' : '0 2px 4px rgba(16, 185, 129, 0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem'
              }}
              onMouseEnter={(e) => {
                if (students.length > 0) {
                  e.currentTarget.style.background = '#059669';
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = '0 4px 8px rgba(16, 185, 129, 0.3)';
                }
              }}
              onMouseLeave={(e) => {
                if (students.length > 0) {
                  e.currentTarget.style.background = '#10B981';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 4px rgba(16, 185, 129, 0.2)';
                }
              }}
            >
              📊 Export Data
            </button>
          </div>

          {/* Filter Section */}
          <div className="students-filter-section" style={{
            background: '#FFFFFF',
            border: '1px solid #E5E7EB',
            borderRadius: '8px',
            padding: '1.5rem',
            marginBottom: '1.5rem',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
          }}>
            <h3 style={{ marginBottom: '1rem', color: '#1F2937', fontSize: '1.1rem', fontWeight: '600' }}>
              🔍 Filter Students
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem', width: '100%', boxSizing: 'border-box' }}>
              {/* Search Text */}
              <div style={{ width: '100%', boxSizing: 'border-box' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem', fontWeight: '500', color: '#374151' }}>
                  Search (Name/Email)
                </label>
                <input
                  type="text"
                  placeholder="Search by name or email..."
                  value={filters.searchText}
                  onChange={(e) => setFilters({ ...filters, searchText: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #D1D5DB',
                    borderRadius: '6px',
                    fontSize: '0.9rem',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              {/* Class Filter */}
              <div style={{ width: '100%', boxSizing: 'border-box' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem', fontWeight: '500', color: '#374151' }}>
                  Class
                </label>
                <select
                  value={filters.classId}
                  onChange={(e) => {
                    setFilters({ ...filters, classId: e.target.value, sectionId: '' });
                    if (e.target.value) {
                      fetchFilterSections(e.target.value);
                    } else {
                      setFilterSections([]);
                    }
                  }}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #D1D5DB',
                    borderRadius: '6px',
                    fontSize: '0.9rem',
                    backgroundColor: '#FFFFFF',
                    boxSizing: 'border-box'
                  }}
                >
                  <option value="">All Classes</option>
                  {classes.map((cls) => (
                    <option key={cls.id} value={cls.id}>
                      {cls.class_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Section Filter */}
              <div style={{ width: '100%', boxSizing: 'border-box' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem', fontWeight: '500', color: '#374151' }}>
                  Section
                </label>
                <select
                  value={filters.sectionId}
                  onChange={(e) => setFilters({ ...filters, sectionId: e.target.value })}
                  disabled={!filters.classId}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #D1D5DB',
                    borderRadius: '6px',
                    fontSize: '0.9rem',
                    backgroundColor: filters.classId ? '#FFFFFF' : '#F9FAFB',
                    cursor: filters.classId ? 'pointer' : 'not-allowed',
                    boxSizing: 'border-box'
                  }}
                >
                  <option value="">All Sections</option>
                  {filterSections.map((section) => (
                    <option key={section.id || section} value={section.id || section}>
                      {section.section_name || section}
                    </option>
                  ))}
                </select>
              </div>

              {/* Status Filter */}
              <div style={{ width: '100%', boxSizing: 'border-box' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem', fontWeight: '500', color: '#374151' }}>
                  Status
                </label>
                <select
                  value={filters.status}
                  onChange={(e) => setFilters({ ...filters, status: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #D1D5DB',
                    borderRadius: '6px',
                    fontSize: '0.9rem',
                    backgroundColor: '#FFFFFF',
                    boxSizing: 'border-box'
                  }}
                >
                  <option value="">All Status</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>

              {/* Gender Filter */}
              <div style={{ width: '100%', boxSizing: 'border-box' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem', fontWeight: '500', color: '#374151' }}>
                  Gender
                </label>
                <select
                  value={filters.gender}
                  onChange={(e) => setFilters({ ...filters, gender: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #D1D5DB',
                    borderRadius: '6px',
                    fontSize: '0.9rem',
                    backgroundColor: '#FFFFFF',
                    boxSizing: 'border-box'
                  }}
                >
                  <option value="">All Genders</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              {/* Clear Filters Button */}
              <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                <button
                  onClick={() => {
                    setFilters({
                      searchText: '',
                      classId: '',
                      sectionId: '',
                      status: '',
                      gender: ''
                    });
                    setFilterSections([]);
                  }}
                  style={{
                    width: '100%',
                    padding: '0.75rem 1.5rem',
                    background: '#F3F4F6',
                    color: '#374151',
                    border: '1px solid #D1D5DB',
                    borderRadius: '6px',
                    fontSize: '0.9rem',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#E5E7EB';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = '#F3F4F6';
                  }}
                >
                  Clear Filters
                </button>
              </div>
            </div>
            
            {/* View Mode Toggle */}
            <div style={{ marginTop: '1.5rem', display: 'flex', gap: '0.5rem', background: '#F3F4F6', borderRadius: '8px', padding: '0.25rem', width: 'fit-content' }}>
              <button
                onClick={() => setViewMode('active')}
                style={{
                  padding: '0.5rem 1rem',
                  borderRadius: '6px',
                  border: 'none',
                  background: viewMode === 'active' ? '#FFFFFF' : 'transparent',
                  color: viewMode === 'active' ? '#1F2937' : '#6B7280',
                  fontWeight: viewMode === 'active' ? '600' : '400',
                  cursor: 'pointer',
                  boxShadow: viewMode === 'active' ? '0 2px 4px rgba(0,0,0,0.1)' : 'none',
                  transition: 'all 0.2s'
                }}
              >
                👥 Active Students
              </button>
              <button
                onClick={() => setViewMode('archived')}
                style={{
                  padding: '0.5rem 1rem',
                  borderRadius: '6px',
                  border: 'none',
                  background: viewMode === 'archived' ? '#FFFFFF' : 'transparent',
                  color: viewMode === 'archived' ? '#1F2937' : '#6B7280',
                  fontWeight: viewMode === 'archived' ? '600' : '400',
                  cursor: 'pointer',
                  boxShadow: viewMode === 'archived' ? '0 2px 4px rgba(0,0,0,0.1)' : 'none',
                  transition: 'all 0.2s'
                }}
              >
                📦 Archived Students
              </button>
            </div>
          </div>

          {loadingStudents ? (
            <div className="loading-container">
              <div className="loading-spinner">⏳</div>
              <p>Loading students...</p>
            </div>
          ) : error ? (
            <div className="error-container">
              <div className="error-icon">❌</div>
              <p>{error}</p>
              <button 
                className="retry-btn"
                onClick={() => window.location.reload()}
              >
                Retry
              </button>
            </div>
          ) : students.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">👨‍🎓</div>
              <h3>No {viewMode === 'active' ? 'Active' : 'Archived'} Students Found</h3>
              <p>
                {viewMode === 'active' 
                  ? "You haven't added any active students yet. Start by adding your first student!"
                  : "You don't have any archived students yet."}
              </p>
              {viewMode === 'active' && (
                <button 
                  className="add-first-student-btn"
                  onClick={() => navigate('/school/add-student')}
                >
                  ➕ Add Your First Student
                </button>
              )}
            </div>
          ) : (
            <div className="students-table-container">
              <table className="students-table">
                <thead>
                  <tr>
                    <th>Student Name</th>
                    <th>Email</th>
                    <th>Class</th>
                    <th>Date of Birth</th>
                    <th>Parent Name</th>
                    <th>Status</th>
                    <th className="actions-header">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    // Apply filters
                    let filteredStudents = students;

                    // Search filter (name or email)
                    if (filters.searchText) {
                      const searchLower = filters.searchText.toLowerCase();
                      filteredStudents = filteredStudents.filter(student => 
                        (student.first_name && student.first_name.toLowerCase().includes(searchLower)) ||
                        (student.last_name && student.last_name.toLowerCase().includes(searchLower)) ||
                        (student.email && student.email.toLowerCase().includes(searchLower))
                      );
                    }

                    // Class filter
                    if (filters.classId) {
                      filteredStudents = filteredStudents.filter(student => 
                        student.class_id === parseInt(filters.classId)
                      );
                    }

                    // Section filter
                    if (filters.sectionId) {
                      filteredStudents = filteredStudents.filter(student => 
                        student.section_id === filters.sectionId
                      );
                    }

                    // Status filter
                    if (filters.status) {
                      const isActive = filters.status === 'active';
                      filteredStudents = filteredStudents.filter(student => 
                        student.is_active === isActive
                      );
                    }

                    // Gender filter
                    if (filters.gender) {
                      filteredStudents = filteredStudents.filter(student => 
                        student.gender === filters.gender
                      );
                    }

                    return filteredStudents.length === 0 ? (
                      <tr>
                        <td colSpan="7" style={{ textAlign: 'center', padding: '2rem', color: '#6B7280' }}>
                          No students found matching the selected filters.
                        </td>
                      </tr>
                    ) : (
                      filteredStudents.map((student) => (
                        <tr key={student.id}>
                      <td className="student-name">
                        {student.first_name} {student.last_name}
                      </td>
                      <td className="email-cell">
                        <a href={`mailto:${student.email}`} className="email-link">
                          {student.email}
                        </a>
                      </td>
                      <td className="class-cell">
                        <span className="class-name">
                          {student.class_name || 'No Class'}
                        </span>
                      </td>
                      <td className="dob-cell">
                        {formatDate(student.date_of_birth)}
                      </td>
                      <td className="parent-cell">
                        {student.parent_name || 'N/A'}
                      </td>
                      <td className="status-cell">
                        <span className={`status-badge ${student.is_active ? 'active' : 'inactive'}`}>
                          {student.is_active ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td className="actions-cell students-actions-container">
                        <div className="action-buttons students-action-buttons">
                          <button 
                            className="students-action-btn view-btn"
                            title="View Student Details"
                            onClick={() => handleViewStudent(student)}
                          >
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                              <circle cx="12" cy="12" r="3"></circle>
                            </svg>
                            <span>View</span>
                          </button>
                          <button 
                            className="students-action-btn edit-btn"
                            title="Edit Student"
                            onClick={() => handleEditStudent(student)}
                          >
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                            </svg>
                            <span>Edit</span>
                          </button>
                          {viewMode === 'active' ? (
                            <button 
                              className="students-action-btn archive-btn"
                              title="Archive Student"
                              onClick={() => handleArchiveStudent(student)}
                              disabled={isSubmitting}
                            >
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                                <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                                <line x1="12" y1="22.08" x2="12" y2="12"></line>
                              </svg>
                              <span>Archive</span>
                            </button>
                          ) : (
                            <button 
                              className="students-action-btn restore-btn"
                              title="Restore Student"
                              onClick={() => handleRestoreStudent(student)}
                              disabled={isSubmitting}
                            >
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                <polyline points="9 22 9 12 15 12 15 22"></polyline>
                              </svg>
                              <span>Restore</span>
                            </button>
                          )}
                          <button 
                            className="students-action-btn delete-btn"
                            title="Delete Student"
                            onClick={() => handleDeleteStudent(student)}
                          >
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <polyline points="3 6 5 6 21 6"></polyline>
                              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                              <line x1="10" y1="11" x2="10" y2="17"></line>
                              <line x1="14" y1="11" x2="14" y2="17"></line>
                            </svg>
                            <span>Delete</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                      ))
                    );
                  })()}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* View Student Details Popup */}
      {viewingStudent && (
        <div className="popup-overlay" onClick={() => setViewingStudent(null)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '1000px', maxHeight: '90vh', overflowY: 'auto', paddingBottom: '1rem' }}>
            <div className="popup-header" style={{ backgroundColor: '#FF8C42', borderRadius: '8px 8px 0 0', padding: '1rem 1.5rem' }}>
              <h3 style={{ color: '#FFFFFF', margin: 0 }}>Student Details: {viewingStudent.first_name} {viewingStudent.last_name}</h3>
              <button className="close-btn" onClick={() => setViewingStudent(null)} style={{ color: '#FFFFFF' }}>
                ×
              </button>
            </div>
            
            {/* Tabs Navigation */}
            <div style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(5, 1fr)',
              borderBottom: '2px solid #E5E7EB',
              backgroundColor: '#F9FAFB'
            }}>
              {[
                { id: 'student', label: 'Student Details' },
                { id: 'parents', label: 'Parents Details' },
                { id: 'siblings', label: 'Siblings Details' },
                { id: 'teachers', label: 'Teachers Details' },
                { id: 'medical', label: 'Medical Records' },
                { id: 'academic', label: 'Academic Details' },
                { id: 'transport', label: 'School Transport' },
                { id: 'fees', label: 'Fees Payments' },
                { id: 'documents', label: 'Documents' }
              ].map(tab => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  style={{
                    padding: '1rem 0.75rem',
                    border: 'none',
                    backgroundColor: 'transparent',
                    color: activeTab === tab.id ? '#FF8C42' : '#6B7280',
                    fontWeight: activeTab === tab.id ? '600' : '400',
                    fontSize: '0.85rem',
                    cursor: 'pointer',
                    borderBottom: activeTab === tab.id ? '3px solid #FF8C42' : '3px solid transparent',
                    transition: 'all 0.2s ease',
                    whiteSpace: 'nowrap',
                    textAlign: 'center',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}
                  onMouseEnter={(e) => {
                    if (activeTab !== tab.id) {
                      e.target.style.color = '#374151';
                      e.target.style.backgroundColor = '#F3F4F6';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (activeTab !== tab.id) {
                      e.target.style.color = '#6B7280';
                      e.target.style.backgroundColor = 'transparent';
                    }
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </div>
            
            <div className="view-student-details" style={{ padding: '2rem 2rem 3rem 2rem', minHeight: '400px' }}>
              {loadingViewData && (
                <div style={{ textAlign: 'center', padding: '2rem' }}>
                  <div className="loading-spinner">⏳</div>
                  <p>Loading...</p>
                </div>
              )}
              
              {!loadingViewData && (
                <>
                  {/* Student Details Tab */}
                  {activeTab === 'student' && (
                    <div>
                      {/* Profile Picture Section */}
              <div className="detail-section" style={{ marginBottom: '2rem', textAlign: 'center' }}>
                <h4 style={{ color: '#FF8C42', marginBottom: '1.5rem', fontSize: '1.2rem', borderBottom: '2px solid #FF8C42', paddingBottom: '0.5rem' }}>
                  Profile Picture
                </h4>
                <div style={{
                  padding: '2rem',
                  background: '#FFFFFF',
                  borderRadius: '12px',
                  border: '2px solid #E5E7EB',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                  position: 'relative',
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}>
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '4px',
                    background: 'linear-gradient(90deg, #FF8C42 0%, #FFA366 100%)'
                  }}></div>
                  
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '0.5rem' }}>
                    {viewingStudent.profile_picture_url ? (
                      <img 
                        src={viewingStudent.profile_picture_url} 
                        alt={`${viewingStudent.first_name} ${viewingStudent.last_name}`}
                        style={{
                          width: '200px',
                          height: '200px',
                          objectFit: 'cover',
                          borderRadius: '50%',
                          border: '4px solid #FF8C42',
                          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                        }}
                        onLoad={async (e) => {
                          // If image loads successfully, verify it's a valid signed URL
                          // If not, regenerate it
                          if (viewingStudent.profile_picture_url && !viewingStudent.profile_picture_url.includes('token=')) {
                            const newUrl = await getValidFileUrl(viewingStudent.profile_picture_url);
                            if (newUrl && newUrl !== viewingStudent.profile_picture_url) {
                              e.target.src = newUrl;
                            }
                          }
                        }}
                        onError={async (e) => {
                          console.error('Profile picture load error, attempting to regenerate URL');
                          const originalUrl = viewingStudent.profile_picture_url;
                          const newUrl = await getValidFileUrl(originalUrl);
                          if (newUrl && newUrl !== originalUrl) {
                            e.target.src = newUrl;
                          } else {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                          }
                        }}
                      />
                    ) : null}
                    <div 
                      style={{ 
                        display: viewingStudent.profile_picture_url ? 'none' : 'flex',
                        width: '200px',
                        height: '200px',
                        borderRadius: '50%',
                        background: '#F3F4F6',
                        border: '4px solid #D1D5DB',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '4rem',
                        color: '#9CA3AF'
                      }}
                    >
                      👤
                    </div>
                  </div>
                  {viewingStudent.profile_picture_url && (
                    <div style={{ marginTop: '1rem' }}>
                      <a 
                        href={viewingStudent.profile_picture_url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        onClick={async (e) => {
                          e.preventDefault();
                          const newUrl = await getValidFileUrl(viewingStudent.profile_picture_url);
                          if (newUrl) {
                            window.open(newUrl, '_blank');
                          } else {
                            alert('Unable to access profile picture. Please try again.');
                          }
                        }}
                        style={{ 
                          color: '#1F2937', 
                          textDecoration: 'none',
                          fontSize: '0.9rem',
                          fontWeight: '500',
                          padding: '0.5rem 1rem',
                          background: '#F3F4F6',
                          borderRadius: '8px',
                          display: 'inline-block',
                          cursor: 'pointer'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.textDecoration = 'underline';
                          e.target.style.background = '#E5E7EB';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.textDecoration = 'none';
                          e.target.style.background = '#F3F4F6';
                        }}
                      >
                        View Full Size →
                      </a>
                    </div>
                  )}
                </div>
              </div>
              
              {/* Personal Information */}
              <div className="detail-section" style={{ marginBottom: '2rem' }}>
                <h4 style={{ color: '#FF8C42', marginBottom: '1.5rem', fontSize: '1.2rem', borderBottom: '2px solid #FF8C42', paddingBottom: '0.5rem' }}>
                  Personal Information
                </h4>
                <div style={{
                  padding: '1.5rem',
                  background: '#FFFFFF',
                  borderRadius: '12px',
                  border: '2px solid #E5E7EB',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                  position: 'relative',
                  overflow: 'hidden'
                }}>
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '4px',
                    background: 'linear-gradient(90deg, #FF8C42 0%, #FFA366 100%)'
                  }}></div>
                  
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem', marginTop: '0.5rem' }}>
                  <div>
                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Name</span>
                      <div style={{ color: '#1F2937', fontSize: '1rem', fontWeight: '600', marginTop: '0.25rem' }}>
                        {viewingStudent.first_name} {viewingStudent.middle_name} {viewingStudent.last_name}
                      </div>
                  </div>
                  <div>
                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Email</span>
                      <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                        {viewingStudent.email || 'N/A'}
                      </div>
                  </div>
                  <div>
                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Phone</span>
                      <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                        {viewingStudent.phone || 'N/A'}
                      </div>
                  </div>
                  <div>
                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Date of Birth</span>
                      <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                        {viewingStudent.date_of_birth ? new Date(viewingStudent.date_of_birth).toLocaleDateString() : 'N/A'}
                      </div>
                  </div>
                  <div>
                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Gender</span>
                      <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                        {viewingStudent.gender || 'N/A'}
                      </div>
                  </div>
                  <div>
                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Nationality</span>
                      <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                        {viewingStudent.nationality || 'N/A'}
                      </div>
                  </div>
                  <div>
                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Student ID</span>
                      <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                        {viewingStudent.student_id_no || 'N/A'}
                      </div>
                  </div>
                  <div>
                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Admission Date</span>
                      <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                        {viewingStudent.admission_date ? new Date(viewingStudent.admission_date).toLocaleDateString() : 'N/A'}
                      </div>
                  </div>
                  <div>
                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Previous School</span>
                      <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                        {viewingStudent.previous_school || 'N/A'}
                  </div>
                    </div>
                    {viewingStudent.previous_school_grade && (
                  <div>
                        <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Previous School Grade/Percentage</span>
                        <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                          {viewingStudent.previous_school_grade}
                        </div>
                      </div>
                    )}
                    <div>
                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Address</span>
                      <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                        {viewingStudent.address || 'N/A'}
                      </div>
                    </div>
                    {viewingStudent.date_of_birth && (
                      <div>
                        <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Age</span>
                        <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                          {(() => {
                            const dob = new Date(viewingStudent.date_of_birth);
                            const today = new Date();
                            let age = today.getFullYear() - dob.getFullYear();
                            const monthDiff = today.getMonth() - dob.getMonth();
                            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
                              age--;
                            }
                            return `${age} years`;
                          })()}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Academic Information */}
              <div className="detail-section" style={{ marginBottom: '2rem' }}>
                <h4 style={{ color: '#FF8C42', marginBottom: '1.5rem', fontSize: '1.2rem', borderBottom: '2px solid #FF8C42', paddingBottom: '0.5rem' }}>
                  Academic Information
                </h4>
                <div style={{
                  padding: '1.5rem',
                  background: '#FFFFFF',
                  borderRadius: '12px',
                  border: '2px solid #E5E7EB',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                  position: 'relative',
                  overflow: 'hidden'
                }}>
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '4px',
                    background: 'linear-gradient(90deg, #FF8C42 0%, #FFA366 100%)'
                  }}></div>
                  
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem', marginTop: '0.5rem' }}>
                  <div>
                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Class</span>
                      <div style={{ color: '#1F2937', fontSize: '1rem', fontWeight: '600', marginTop: '0.25rem' }}>
                        {viewingStudent.class_name || 'N/A'}
                      </div>
                  </div>
                  <div>
                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Section</span>
                      <div style={{ color: '#1F2937', fontSize: '1rem', fontWeight: '600', marginTop: '0.25rem' }}>
                        {viewingStudent.section_id || 'N/A'}
                      </div>
                  </div>
                  <div>
                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Status</span>
                      <div style={{ marginTop: '0.25rem' }}>
                        <span className={`status-badge ${viewingStudent.is_active ? 'active' : 'inactive'}`} style={{ 
                          marginLeft: 0,
                          padding: '0.35rem 0.75rem',
                          borderRadius: '20px',
                          fontSize: '0.85rem',
                          fontWeight: '600'
                        }}>
                      {viewingStudent.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                </div>
              </div>
                    </div>
                    </div>

                </div>
              )}

                  {/* Parents Details Tab */}
                  {activeTab === 'parents' && (
                    <div>
                      <div className="detail-section" style={{ marginBottom: '2rem' }}>
                        <h4 style={{ color: '#FF8C42', marginBottom: '1.5rem', fontSize: '1.2rem', borderBottom: '2px solid #FF8C42', paddingBottom: '0.5rem' }}>
                          B) Parent/Guardian Information
                        </h4>
                        {viewingParents && viewingParents.length > 0 ? (
                          <div style={{ display: 'grid', gap: '1.25rem' }}>
                            {viewingParents.map((parent, parentIndex) => (
                              <div 
                                key={parent.id || parentIndex} 
                                style={{
                                  padding: '1.5rem',
                                  background: '#FFFFFF',
                                  borderRadius: '12px',
                                  border: '2px solid #E5E7EB',
                                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                                  transition: 'all 0.3s ease',
                                  position: 'relative',
                                  overflow: 'hidden'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.borderColor = '#FF8C42';
                                  e.currentTarget.style.boxShadow = '0 4px 8px rgba(255, 140, 66, 0.15)';
                                  e.currentTarget.style.transform = 'translateY(-2px)';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.borderColor = '#E5E7EB';
                                  e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.05)';
                                  e.currentTarget.style.transform = 'translateY(0)';
                                }}
                              >
                                <div style={{
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  height: '4px',
                                  background: 'linear-gradient(90deg, #FF8C42 0%, #FFA366 100%)'
                                }}></div>
                                
                                {/* Parent Number Label */}
                                <div style={{
                                  marginBottom: '1rem',
                                  paddingBottom: '0.75rem',
                                  borderBottom: '2px solid #E5E7EB'
                                }}>
                                  <h5 style={{
                                    color: '#FF8C42',
                                    fontSize: '1.1rem',
                                    fontWeight: '700',
                                    margin: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem'
                                  }}>
                                    {getParentLabel(parent, parentIndex, viewingParents)}
                                    {parent.is_primary_for_student && (
                                      <span style={{
                                        padding: '0.25rem 0.75rem',
                                        backgroundColor: '#FF8C42',
                                        color: 'white',
                                        borderRadius: '20px',
                                        fontSize: '0.75rem',
                                        fontWeight: '600',
                                        marginLeft: 'auto'
                                      }}>
                                        Primary
                                      </span>
                                    )}
                                  </h5>
                                </div>
                                
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem', marginTop: '0.5rem' }}>
                                  <div>
                                    <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Parent Name</span>
                                    <div style={{ color: '#1F2937', fontSize: '1rem', fontWeight: '600', marginTop: '0.25rem' }}>
                                      {parent.name || 'N/A'}
                                    </div>
                                  </div>
                                  <div>
                                    <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Parent Email</span>
                                    <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                      {parent.email && parent.email !== 'N/A' ? (
                                        <a href={`mailto:${parent.email}`} style={{ color: '#1F2937', textDecoration: 'none' }} onMouseEnter={(e) => e.target.style.textDecoration = 'underline'} onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>
                                          {parent.email}
                                        </a>
                                      ) : 'N/A'}
                                    </div>
                                  </div>
                                  <div>
                                    <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Parent Phone</span>
                                    <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                      {parent.phone && parent.phone !== 'N/A' ? (
                                        <a href={`tel:${parent.phone}`} style={{ color: '#1F2937', textDecoration: 'none' }} onMouseEnter={(e) => e.target.style.textDecoration = 'underline'} onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>
                                          {parent.phone}
                                        </a>
                                      ) : 'N/A'}
                                    </div>
                                  </div>
                                  <div>
                                    <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Relationship</span>
                                    <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                      {parent.relationship || 'N/A'}
                                    </div>
                                  </div>
                                  <div>
                                    <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Parent Address</span>
                                    <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                      {parent.address || 'N/A'}
                                    </div>
                                  </div>
                                  <div>
                                    <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Additional Info</span>
                                    <div style={{ color: '#1F2937', fontSize: '0.85rem', marginTop: '0.25rem', display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                                      {parent.can_pickup && <span style={{ padding: '0.2rem 0.5rem', backgroundColor: '#E0F2FE', color: '#0369A1', borderRadius: '4px', fontSize: '0.75rem' }}>Can Pickup</span>}
                                      {parent.is_emergency_contact && <span style={{ padding: '0.2rem 0.5rem', backgroundColor: '#FEE2E2', color: '#991B1B', borderRadius: '4px', fontSize: '0.75rem' }}>Emergency Contact</span>}
                                      {parent.pays_fees && <span style={{ padding: '0.2rem 0.5rem', backgroundColor: '#D1FAE5', color: '#065F46', borderRadius: '4px', fontSize: '0.75rem' }}>Pays Fees</span>}
                                    </div>
                                  </div>
                                </div>
                                
                                {/* Parent Documents - Always Show */}
                                <div style={{ marginTop: '1.5rem' }}>
                                  <h5 style={{ color: '#FF8C42', marginBottom: '0.75rem', fontSize: '0.95rem', fontWeight: '600', borderBottom: '1px solid #E5E7EB', paddingBottom: '0.5rem' }}>
                                    📄 Parent Documents
                                  </h5>
                                  {parent.documents && parent.documents.length > 0 ? (
                                    <div style={{ display: 'grid', gap: '0.75rem' }}>
                                      {parent.documents.map((doc, docIndex) => (
                                        <div 
                                          key={doc.id || docIndex}
                                          style={{
                                            padding: '0.75rem',
                                            background: '#F9FAFB',
                                            borderRadius: '8px',
                                            border: '1px solid #E5E7EB',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            transition: 'all 0.2s ease'
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.borderColor = '#FF8C42';
                                            e.currentTarget.style.background = '#FFF7ED';
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.borderColor = '#E5E7EB';
                                            e.currentTarget.style.background = '#F9FAFB';
                                          }}
                                        >
                                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flex: 1 }}>
                                            <div style={{
                                              width: '36px',
                                              height: '36px',
                                              borderRadius: '6px',
                                              background: '#EFF6FF',
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                              fontSize: '1.25rem'
                                            }}>
                                              {doc.document_type?.toLowerCase().includes('national') || doc.document_type?.toLowerCase().includes('id') ? '🆔' :
                                               doc.document_type?.toLowerCase().includes('passport') ? '📘' :
                                               '📄'}
                                            </div>
                                            <div>
                                              <div style={{ fontWeight: '600', color: '#1F2937', fontSize: '0.9rem' }}>
                                                {doc.document_type || 'Document'}
                                              </div>
                                              <a 
                                                href={doc.document_url} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                onClick={async (e) => {
                                                  e.preventDefault();
                                                  e.stopPropagation();
                                                  const newUrl = await getValidFileUrl(doc.document_url);
                                                  if (newUrl) {
                                                    window.open(newUrl, '_blank');
                                                  } else {
                                                    alert('Unable to access document. Please try again or contact support.');
                                                  }
                                                }}
                                                style={{ 
                                                  color: '#1F2937', 
                                                  textDecoration: 'none',
                                                  fontSize: '0.85rem',
                                                  fontWeight: '500'
                                                }}
                                                onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                                                onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                                              >
                                                {doc.file_name || 'View Document'} →
                                              </a>
                                            </div>
                                          </div>
                                          {doc.file_size && (
                                            <span style={{ 
                                              color: '#6B7280', 
                                              fontSize: '0.75rem',
                                              padding: '0.25rem 0.5rem',
                                              background: '#F3F4F6',
                                              borderRadius: '4px'
                                            }}>
                                              {(doc.file_size / 1024 / 1024).toFixed(2)} MB
                                            </span>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  ) : (
                                    <div style={{
                                      padding: '1rem',
                                      background: '#F9FAFB',
                                      borderRadius: '8px',
                                      border: '1px dashed #D1D5DB',
                                      textAlign: 'center',
                                      color: '#6B7280',
                                      fontSize: '0.85rem',
                                      fontStyle: 'italic'
                                    }}>
                                      No documents uploaded for this parent (National ID, Passport, etc.)
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div style={{
                            padding: '1.5rem',
                            background: '#FFFFFF',
                            borderRadius: '12px',
                            border: '2px solid #E5E7EB',
                            textAlign: 'center',
                            color: '#6B7280'
                          }}>
                            No parent information available
                          </div>
                        )}
                      </div>

                      {/* Emergency Contact Section */}
                      <div className="detail-section" style={{ marginBottom: '2rem' }}>
                        <h4 style={{ color: '#FF8C42', marginBottom: '1.5rem', fontSize: '1.2rem', borderBottom: '2px solid #FF8C42', paddingBottom: '0.5rem' }}>
                          C) Emergency Contact Information
                        </h4>
                        <div style={{
                          padding: '1.5rem',
                          background: '#FFFFFF',
                          borderRadius: '12px',
                          border: '2px solid #E5E7EB',
                          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                          position: 'relative',
                          overflow: 'hidden'
                        }}>
                          <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: '4px',
                            background: 'linear-gradient(90deg, #FF8C42 0%, #FFA366 100%)'
                          }}></div>
                          
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem', marginTop: '0.5rem' }}>
                            <div>
                              <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Emergency Contact *</span>
                              <div style={{ color: '#1F2937', fontSize: '1rem', fontWeight: '600', marginTop: '0.25rem' }}>
                                {viewingStudent.emergency_contact || 'N/A'}
                              </div>
                            </div>
                            <div>
                              <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Emergency Phone *</span>
                              <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                {viewingStudent.emergency_phone && viewingStudent.emergency_phone !== 'N/A' ? (
                                  <a href={`tel:${viewingStudent.emergency_phone}`} style={{ color: '#1F2937', textDecoration: 'none' }} onMouseEnter={(e) => e.target.style.textDecoration = 'underline'} onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>
                                    {viewingStudent.emergency_phone}
                                  </a>
                                ) : 'N/A'}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Siblings Details Tab */}
                  {activeTab === 'siblings' && (
                    <div>
              <div className="detail-section" style={{ marginBottom: '2rem' }}>
                        <h4 style={{ color: '#FF8C42', marginBottom: '1.5rem', fontSize: '1.2rem', borderBottom: '2px solid #FF8C42', paddingBottom: '0.5rem' }}>
                          Siblings
                </h4>
                        {viewingSiblings && viewingSiblings.length > 0 ? (
                          <div style={{ display: 'grid', gap: '1.25rem' }}>
                            {viewingSiblings.map((sibling, index) => (
                              <div 
                                key={sibling.id} 
                                style={{
                                  padding: '1.5rem',
                                  background: '#FFFFFF',
                                  borderRadius: '12px',
                                  border: '2px solid #E5E7EB',
                                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                                  transition: 'all 0.3s ease',
                                  position: 'relative',
                                  overflow: 'hidden'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.borderColor = '#FF8C42';
                                  e.currentTarget.style.boxShadow = '0 4px 8px rgba(255, 140, 66, 0.15)';
                                  e.currentTarget.style.transform = 'translateY(-2px)';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.borderColor = '#E5E7EB';
                                  e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.05)';
                                  e.currentTarget.style.transform = 'translateY(0)';
                                }}
                              >
                                {/* Decorative accent bar */}
                                <div style={{
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  height: '4px',
                                  background: 'linear-gradient(90deg, #FF8C42 0%, #FFA366 100%)'
                                }}></div>
                                
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.25rem', marginTop: '0.5rem' }}>
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  <div>
                                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Name</span>
                                      <div style={{ color: '#1F2937', fontSize: '1rem', fontWeight: '600', marginTop: '0.25rem' }}>
                                        {sibling.first_name} {sibling.middle_name} {sibling.last_name}
                                      </div>
                                    </div>
                                    <div>
                                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Class</span>
                                      <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                        {sibling.classes?.class_name || 'N/A'} - {sibling.section_id || 'N/A'}
                                      </div>
                                    </div>
                                    {sibling.date_of_birth && (
                                      <div>
                                        <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Date of Birth</span>
                                        <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                          {new Date(sibling.date_of_birth).toLocaleDateString()}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                    <div>
                                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Email</span>
                                      <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                        {sibling.email || 'N/A'}
                                      </div>
                                    </div>
                                    <div>
                                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Gender</span>
                                      <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                        {sibling.gender || 'N/A'}
                                      </div>
                                    </div>
                                    <div>
                                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Status</span>
                                      <div style={{ marginTop: '0.25rem' }}>
                                        <span className={`status-badge ${sibling.is_active ? 'active' : 'inactive'}`} style={{ 
                                          marginLeft: 0,
                                          padding: '0.35rem 0.75rem',
                                          borderRadius: '20px',
                                          fontSize: '0.85rem',
                                          fontWeight: '600'
                                        }}>
                                          {sibling.is_active ? 'Active' : 'Inactive'}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div style={{ 
                            padding: '3rem 2rem', 
                            textAlign: 'center', 
                            color: '#6B7280', 
                            fontStyle: 'italic',
                            background: '#F9FAFB',
                            borderRadius: '12px',
                            border: '2px dashed #D1D5DB'
                          }}>
                            👨‍👩‍👧‍👦 No siblings found.
                          </div>
                    )}
                  </div>
                    </div>
                  )}

                  {/* Teachers Details Tab */}
                  {activeTab === 'teachers' && (
                    <div>
                      <div className="detail-section" style={{ marginBottom: '2rem' }}>
                        <h4 style={{ color: '#FF8C42', marginBottom: '1.5rem', fontSize: '1.2rem', borderBottom: '2px solid #FF8C42', paddingBottom: '0.5rem' }}>
                          Teachers
                        </h4>
                        {viewingTeachers && viewingTeachers.length > 0 ? (
                          <div style={{ display: 'grid', gap: '1.25rem' }}>
                            {viewingTeachers.map((teacher) => (
                              <div 
                                key={teacher.id} 
                                style={{
                                  padding: '1.5rem',
                                  background: '#FFFFFF',
                                  borderRadius: '12px',
                                  border: '2px solid #E5E7EB',
                                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                                  transition: 'all 0.3s ease',
                                  position: 'relative',
                                  overflow: 'hidden'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.borderColor = '#FF8C42';
                                  e.currentTarget.style.boxShadow = '0 4px 8px rgba(255, 140, 66, 0.15)';
                                  e.currentTarget.style.transform = 'translateY(-2px)';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.borderColor = '#E5E7EB';
                                  e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.05)';
                                  e.currentTarget.style.transform = 'translateY(0)';
                                }}
                              >
                                {/* Decorative accent bar */}
                                <div style={{
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  height: '4px',
                                  background: 'linear-gradient(90deg, #FF8C42 0%, #FFA366 100%)'
                                }}></div>
                                
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.25rem', marginTop: '0.5rem' }}>
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                                    <div>
                                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Name</span>
                                      <div style={{ color: '#1F2937', fontSize: '1rem', fontWeight: '600', marginTop: '0.25rem' }}>
                                        {teacher.first_name} {teacher.last_name}
                                      </div>
                                    </div>
                                    {teacher.email && (
                                      <div>
                                        <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Email</span>
                                        <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                          <a href={`mailto:${teacher.email}`} style={{ color: '#1F2937', textDecoration: 'none' }} onMouseEnter={(e) => e.target.style.textDecoration = 'underline'} onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>
                                            {teacher.email}
                                          </a>
                                        </div>
                                      </div>
                                    )}
                                    {teacher.phone && (
                                      <div>
                                        <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Phone</span>
                                        <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                          <a href={`tel:${teacher.phone}`} style={{ color: '#1F2937', textDecoration: 'none' }} onMouseEnter={(e) => e.target.style.textDecoration = 'underline'} onMouseLeave={(e) => e.target.style.textDecoration = 'none'}>
                                            {teacher.phone}
                                          </a>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                                    {teacher.qualification && (
                                      <div>
                                        <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Qualification</span>
                                        <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                          {teacher.qualification}
                                        </div>
                                      </div>
                                    )}
                                    {teacher.subjects && Array.isArray(teacher.subjects) && teacher.subjects.length > 0 && (
                                      <div>
                                        <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Subjects</span>
                                        <div style={{ 
                                          color: '#1F2937', 
                                          fontSize: '0.95rem', 
                                          marginTop: '0.25rem',
                                          display: 'flex',
                                          flexWrap: 'wrap',
                                          gap: '0.5rem'
                                        }}>
                                          {teacher.subjects.map((subject, idx) => (
                                            <span 
                                              key={idx}
                                              style={{
                                                padding: '0.35rem 0.75rem',
                                                background: '#EFF6FF',
                                                color: '#1E40AF',
                                                borderRadius: '6px',
                                                fontSize: '0.85rem',
                                                fontWeight: '500'
                                              }}
                                            >
                                              {subject}
                                            </span>
                                          ))}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div style={{ 
                            padding: '3rem 2rem', 
                            textAlign: 'center', 
                            color: '#6B7280', 
                            fontStyle: 'italic',
                            background: '#F9FAFB',
                            borderRadius: '12px',
                            border: '2px dashed #D1D5DB'
                          }}>
                            👨‍🏫 No teachers assigned to this class and section.
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Medical Records Tab */}
                  {activeTab === 'medical' && (
                    <div>
                      <div className="detail-section" style={{ marginBottom: '2rem' }}>
                        <h4 style={{ color: '#FF8C42', marginBottom: '1.5rem', fontSize: '1.2rem', borderBottom: '2px solid #FF8C42', paddingBottom: '0.5rem' }}>
                          Medical Records
                        </h4>
                        
                        {/* Medical Details Card */}
                        <div style={{
                          padding: '1.5rem',
                          background: '#FFFFFF',
                          borderRadius: '12px',
                          border: '2px solid #E5E7EB',
                          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                          marginBottom: '1.5rem',
                          position: 'relative',
                          overflow: 'hidden'
                        }}>
                          <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: '4px',
                            background: 'linear-gradient(90deg, #FF8C42 0%, #FFA366 100%)'
                          }}></div>
                          
                          <div style={{ marginTop: '0.5rem' }}>
                            <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Medical Details</span>
                            <div style={{ 
                              marginTop: '0.75rem', 
                              padding: '1.25rem', 
                              background: '#F9FAFB', 
                              borderRadius: '8px',
                              whiteSpace: 'pre-wrap',
                              minHeight: '120px',
                              color: '#1F2937',
                              fontSize: '0.95rem',
                              lineHeight: '1.6'
                            }}>
                              {viewingStudent.medical_details || 'No medical records provided.'}
                            </div>
                          </div>
                        </div>

                        {/* Emergency Documents Card */}
                        {viewingStudent.emergency_documents_url ? (
                          <div style={{
                            padding: '1.5rem',
                            background: '#FFFFFF',
                            borderRadius: '12px',
                            border: '2px solid #F59E0B',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                            position: 'relative',
                            overflow: 'hidden'
                          }}>
                            <div style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              height: '4px',
                              background: 'linear-gradient(90deg, #F59E0B 0%, #FBBF24 100%)'
                            }}></div>
                            
                            <div style={{ marginTop: '0.5rem' }}>
                              <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Emergency Documents</span>
                              <div style={{
                                marginTop: '0.75rem',
                                padding: '1rem',
                                background: '#FEF3C7',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.75rem'
                              }}>
                                <span style={{ fontSize: '1.5rem' }}>📄</span>
                                <a 
                                  href={viewingStudent.emergency_documents_url} 
                                  target="_blank" 
                                  rel="noopener noreferrer"
                                  onClick={async (e) => {
                                    if (!viewingStudent.emergency_documents_url || viewingStudent.emergency_documents_url.includes('404')) {
                                      e.preventDefault();
                                      const newUrl = await getValidFileUrl(viewingStudent.emergency_documents_url);
                                      if (newUrl) {
                                        window.open(newUrl, '_blank');
                                      } else {
                                        alert('Unable to access emergency documents. Please try again or contact support.');
                                      }
                                    }
                                  }}
                                  style={{ 
                                    color: '#1F2937', 
                                    textDecoration: 'none',
                                    fontWeight: '500',
                                    fontSize: '1rem'
                                  }}
                                  onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                                  onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                                >
                                  View Emergency Documents
                                </a>
                                <span style={{ color: '#6B7280', fontSize: '0.85rem', marginLeft: 'auto' }}>
                                  (Opens in new tab)
                                </span>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div style={{
                            padding: '2rem',
                            textAlign: 'center',
                            color: '#6B7280',
                            fontStyle: 'italic',
                            background: '#F9FAFB',
                            borderRadius: '12px',
                            border: '2px dashed #D1D5DB'
                          }}>
                            📄 No emergency documents uploaded.
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Academic Details Tab */}
                  {activeTab === 'academic' && (
                    <div>
                      {/* Academic Information Card */}
                      <div className="detail-section" style={{ marginBottom: '2rem' }}>
                        <h4 style={{ color: '#FF8C42', marginBottom: '1.5rem', fontSize: '1.2rem', borderBottom: '2px solid #FF8C42', paddingBottom: '0.5rem' }}>
                          Academic Information
                        </h4>
                        <div style={{
                          padding: '1.5rem',
                          background: '#FFFFFF',
                          borderRadius: '12px',
                          border: '2px solid #E5E7EB',
                          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                          position: 'relative',
                          overflow: 'hidden'
                        }}>
                          <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: '4px',
                            background: 'linear-gradient(90deg, #FF8C42 0%, #FFA366 100%)'
                          }}></div>
                          
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem', marginTop: '0.5rem' }}>
                            <div>
                              <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Class</span>
                              <div style={{ color: '#1F2937', fontSize: '1rem', fontWeight: '600', marginTop: '0.25rem' }}>
                                {viewingStudent.class_name || 'N/A'}
                              </div>
                            </div>
                            <div>
                              <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Section</span>
                              <div style={{ color: '#1F2937', fontSize: '1rem', fontWeight: '600', marginTop: '0.25rem' }}>
                                {viewingStudent.section_id || 'N/A'}
                              </div>
                            </div>
                            <div>
                              <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Status</span>
                              <div style={{ marginTop: '0.25rem' }}>
                                <span className={`status-badge ${viewingStudent.is_active ? 'active' : 'inactive'}`} style={{ 
                                  marginLeft: 0,
                                  padding: '0.35rem 0.75rem',
                                  borderRadius: '20px',
                                  fontSize: '0.85rem',
                                  fontWeight: '600'
                                }}>
                                  {viewingStudent.is_active ? 'Active' : 'Inactive'}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Academic History Card */}
                      {(viewingStudent.previous_school || viewingStudent.previous_school_grade) && (
                        <div className="detail-section" style={{ marginBottom: '2rem' }}>
                          <h4 style={{ color: '#FF8C42', marginBottom: '1.5rem', fontSize: '1.2rem', borderBottom: '2px solid #FF8C42', paddingBottom: '0.5rem' }}>
                            Academic History
                          </h4>
                          <div style={{
                            padding: '1.5rem',
                            background: '#FFFFFF',
                            borderRadius: '12px',
                            border: '2px solid #E5E7EB',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                            position: 'relative',
                            overflow: 'hidden'
                          }}>
                            <div style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              height: '4px',
                              background: 'linear-gradient(90deg, #FF8C42 0%, #FFA366 100%)'
                            }}></div>
                            
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem', marginTop: '0.5rem' }}>
                              {viewingStudent.previous_school && (
                                <div>
                                  <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Previous School(s)</span>
                                  <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                    {viewingStudent.previous_school}
                                  </div>
                                </div>
                              )}
                              {viewingStudent.previous_school_grade && (
                                <div>
                                  <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Grade/Percentage from Previous School</span>
                                  <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                    {viewingStudent.previous_school_grade}
                                  </div>
                                </div>
                              )}
                              <div>
                                <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Current Class Assigned</span>
                                <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                  {viewingStudent.class_name || 'N/A'}{viewingStudent.section_id ? ` - Section ${viewingStudent.section_id}` : ''}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {/* School Transport Tab */}
                  {activeTab === 'transport' && (
                    <div>
                      <div className="detail-section" style={{ marginBottom: '2rem' }}>
                        <h4 style={{ color: '#FF8C42', marginBottom: '1.5rem', fontSize: '1.2rem', borderBottom: '2px solid #FF8C42', paddingBottom: '0.5rem' }}>
                          School Transport Service
                        </h4>
                        
                        {viewingStudent.transport_service_enabled ? (
                          <div style={{
                            padding: '1.5rem',
                            background: '#FFFFFF',
                            borderRadius: '12px',
                            border: '2px solid #E5E7EB',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                            position: 'relative',
                            overflow: 'hidden'
                          }}>
                            <div style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              height: '4px',
                              background: 'linear-gradient(90deg, #FF8C42 0%, #FFA366 100%)'
                            }}></div>
                            
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem', marginTop: '0.5rem' }}>
                              <div>
                                <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Transport Service</span>
                                <div style={{ marginTop: '0.25rem' }}>
                                  <span style={{ 
                                    color: '#059669', 
                                    fontWeight: '600',
                                    padding: '0.35rem 0.75rem',
                                    background: '#D1FAE5',
                                    borderRadius: '20px',
                                    fontSize: '0.85rem',
                                    display: 'inline-block'
                                  }}>
                                    ✓ Enabled
                                  </span>
                                </div>
                              </div>
                              
                      {viewingStudent.pickupLocation && (
                        <>
                          <div>
                                    <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Pickup Location</span>
                                    <div style={{ color: '#1F2937', fontSize: '1rem', fontWeight: '600', marginTop: '0.25rem' }}>
                                      {viewingStudent.pickupLocation.location_name || 'N/A'}
                                    </div>
                          </div>
                          <div>
                                    <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Location Address</span>
                                    <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                      {viewingStudent.pickupLocation.address || 'N/A'}
                                    </div>
                          </div>
                          {(viewingStudent.pickupLocation.price_one_way || viewingStudent.pickupLocation.price_two_way) && (
                            <div>
                                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Pricing</span>
                                      <div style={{ marginTop: '0.5rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                {viewingStudent.pickupLocation.price_one_way && (
                                          <div style={{ 
                                            padding: '0.5rem',
                                            background: '#F0FDF4',
                                            borderRadius: '6px',
                                            color: '#059669',
                                            fontWeight: '500'
                                          }}>
                                            1 Way: {viewingStudent.pickupLocation.currency || 'PKR'} {parseFloat(viewingStudent.pickupLocation.price_one_way).toLocaleString()}
                                          </div>
                                )}
                                {viewingStudent.pickupLocation.price_two_way && (
                                          <div style={{ 
                                            padding: '0.5rem',
                                            background: '#F0FDF4',
                                            borderRadius: '6px',
                                            color: '#059669',
                                            fontWeight: '500'
                                          }}>
                                            2 Way: {viewingStudent.pickupLocation.currency || 'PKR'} {parseFloat(viewingStudent.pickupLocation.price_two_way).toLocaleString()}
                                          </div>
                                )}
                              </div>
                            </div>
                      )}
                      <div>
                                    <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Route Type</span>
                                    <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                      {viewingStudent.transport_route_type || 'N/A'}
                      </div>
                                  </div>
                                  {viewingStudent.transport_price && (
                      <div>
                                      <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Transport Price</span>
                                      <div style={{ 
                                        color: '#059669', 
                                        fontWeight: '600',
                                        fontSize: '1.1rem',
                                        marginTop: '0.25rem'
                                      }}>
                            {viewingStudent.pickupLocation?.currency || 'PKR'} {parseFloat(viewingStudent.transport_price).toLocaleString()}
                      </div>
                                    </div>
                                  )}
                      {viewingStudent.pickupLocation?.route && (
                        <>
                          <div>
                                        <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Route Name</span>
                                        <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                          {viewingStudent.pickupLocation.route.route_name || `Route #${viewingStudent.pickupLocation.route.id}`}
                                        </div>
                          </div>
                          <div>
                                        <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Route Type</span>
                                        <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                          {viewingStudent.pickupLocation.route.route_type || 'N/A'}
                                        </div>
                          </div>
                          {viewingStudent.pickupLocation.route.vehicle && (
                            <>
                              <div>
                                            <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Vehicle Number</span>
                                            <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                              {viewingStudent.pickupLocation.route.vehicle.bus_number || 'N/A'}
                                            </div>
                              </div>
                              {viewingStudent.pickupLocation.route.vehicle.driver_name && (
                                <div>
                                              <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Driver Name</span>
                                              <div style={{ color: '#1F2937', fontSize: '0.95rem', marginTop: '0.25rem' }}>
                                                {viewingStudent.pickupLocation.route.vehicle.driver_name}
                                              </div>
                                </div>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
                        ) : (
                          <div style={{
                            padding: '2rem',
                            textAlign: 'center',
                            color: '#6B7280',
                            fontStyle: 'italic',
                            background: '#F9FAFB',
                            borderRadius: '12px',
                            border: '2px dashed #D1D5DB'
                          }}>
                            🚌 Transport service is disabled for this student.
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Fees Payments Tab */}
                  {activeTab === 'fees' && (
                    <div>
              <div className="detail-section" style={{ marginBottom: '2rem' }}>
                        <h4 style={{ color: '#FF8C42', marginBottom: '1.5rem', fontSize: '1.2rem', borderBottom: '2px solid #FF8C42', paddingBottom: '0.5rem' }}>
                          Fees & Payment Information
                </h4>
                        
                        {/* Payment Method Card */}
                  <div style={{ 
                          padding: '1.5rem',
                          background: '#FFFFFF',
                          borderRadius: '12px',
                          border: '2px solid #E5E7EB',
                          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                          marginBottom: '1.5rem',
                          position: 'relative',
                          overflow: 'hidden'
                        }}>
                          <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            height: '4px',
                            background: 'linear-gradient(90deg, #FF8C42 0%, #FFA366 100%)'
                          }}></div>
                          
                          <div style={{ marginTop: '0.5rem' }}>
                            <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Payment Method</span>
                            <div style={{ color: '#1F2937', fontSize: '1rem', fontWeight: '600', marginTop: '0.25rem' }}>
                              {viewingStudent.payment_method || 'Not specified'}
                            </div>
                          </div>
                        </div>

                        {/* Monthly Fee Breakdown Card */}
                        {(viewingStudent.total_monthly_fee || viewingStudent.monthly_tuition_fee || viewingStudent.transport_fee) ? (
                          <>
                            {/* Total Monthly Fee Card */}
                            <div style={{
                              padding: '1.5rem',
                              background: '#FFFFFF',
                              borderRadius: '12px',
                              border: '2px solid #E5E7EB',
                              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                              marginBottom: '1.5rem',
                              position: 'relative',
                              overflow: 'hidden'
                            }}>
                              <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                height: '4px',
                                background: 'linear-gradient(90deg, #FF8C42 0%, #FFA366 100%)'
                              }}></div>
                              
                              <div style={{ marginTop: '0.5rem', textAlign: 'center' }}>
                                <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>MONTHLY FEE</span>
                                <div style={{ 
                                  color: '#1F2937', 
                                  fontSize: '1.5rem', 
                                  fontWeight: '700',
                    padding: '1rem', 
                    background: '#F9FAFB', 
                                  borderRadius: '8px'
                  }}>
                                  {viewingStudent.fee_currency || 'PKR'} {viewingStudent.total_monthly_fee ? parseFloat(viewingStudent.total_monthly_fee).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}
                  </div>
                </div>
                            </div>

                            {/* Fee Breakdown Card */}
                            <div style={{
                              padding: '1.5rem',
                              background: '#FFFFFF',
                              borderRadius: '12px',
                              border: '2px solid #E5E7EB',
                              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                              marginBottom: '1.5rem',
                              position: 'relative',
                              overflow: 'hidden'
                            }}>
                              <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                height: '4px',
                                background: 'linear-gradient(90deg, #FF8C42 0%, #FFA366 100%)'
                              }}></div>
                              
                    <div style={{ marginTop: '0.5rem' }}>
                                <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500', marginBottom: '1rem', display: 'block' }}>Monthly Breakdown</span>
                                
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                                  {/* Monthly Tuition */}
                                  {viewingStudent.monthly_tuition_fee && (
                                    <div style={{
                                      padding: '1rem',
                                      background: '#EFF6FF',
                                      borderRadius: '8px',
                                      border: '1px solid #BFDBFE',
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center'
                                    }}>
                                      <span style={{ color: '#1E40AF', fontSize: '0.9rem', fontWeight: '500' }}>Monthly Tuition:</span>
                                      <span style={{ color: '#1E40AF', fontSize: '1rem', fontWeight: '600' }}>
                                        {viewingStudent.fee_currency || 'PKR'} {parseFloat(viewingStudent.monthly_tuition_fee).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                      </span>
                    </div>
                                  )}

                                  {/* Transport Fee */}
                                  {viewingStudent.transport_fee && (
                                    <div style={{
                                      padding: '1rem',
                                      background: '#F0FDF4',
                                      borderRadius: '8px',
                                      border: '1px solid #BBF7D0',
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center'
                                    }}>
                                      <span style={{ color: '#059669', fontSize: '0.9rem', fontWeight: '500' }}>Transportation (Monthly):</span>
                                      <span style={{ color: '#059669', fontSize: '1rem', fontWeight: '600' }}>
                                        {viewingStudent.fee_currency || 'PKR'} {parseFloat(viewingStudent.transport_fee).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                      </span>
                  </div>
                )}

                                  {/* Monthly Additional Fees */}
                                  {viewingStudent.monthly_additional_fees && parseFloat(viewingStudent.monthly_additional_fees) > 0 && (
                                    <div style={{
                                      padding: '1rem',
                                      background: '#FEF3C7',
                                      borderRadius: '8px',
                                      border: '1px solid #FDE68A',
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center'
                                    }}>
                                      <span style={{ color: '#D97706', fontSize: '0.9rem', fontWeight: '500' }}>Additional Monthly Fees:</span>
                                      <span style={{ color: '#D97706', fontSize: '1rem', fontWeight: '600' }}>
                                        {viewingStudent.fee_currency || 'PKR'} {parseFloat(viewingStudent.monthly_additional_fees).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                      </span>
              </div>
                                  )}

                                  {/* One-Time Fees */}
                                  {viewingStudent.one_time_fees && parseFloat(viewingStudent.one_time_fees) > 0 && (
                                    <div style={{
                                      padding: '1rem',
                                      background: '#F3E8FF',
                                      borderRadius: '8px',
                                      border: '1px solid #E9D5FF',
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center'
                                    }}>
                                      <span style={{ color: '#7C3AED', fontSize: '0.9rem', fontWeight: '500' }}>One-Time Fees:</span>
                                      <span style={{ color: '#7C3AED', fontSize: '1rem', fontWeight: '600' }}>
                                        {viewingStudent.fee_currency || 'PKR'} {parseFloat(viewingStudent.one_time_fees).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                      </span>
                                    </div>
                                  )}

                                  {/* Total Monthly Fee (Summary) */}
                                  {viewingStudent.total_monthly_fee && (
                                    <div style={{
                                      padding: '1.25rem',
                                      background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                                      borderRadius: '8px',
                                      border: 'none',
                                      marginTop: '0.5rem',
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center'
                                    }}>
                                      <span style={{ color: '#FFFFFF', fontSize: '1rem', fontWeight: '700' }}>Total Monthly Fee:</span>
                                      <span style={{ color: '#FFFFFF', fontSize: '1.25rem', fontWeight: '700' }}>
                                        {viewingStudent.fee_currency || 'PKR'} {parseFloat(viewingStudent.total_monthly_fee).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* Base Fee Information Card */}
                            {(viewingStudent.base_fee_type || viewingStudent.base_fee_amount) && (
                              <div style={{
                                padding: '1.5rem',
                                background: '#FFFFFF',
                                borderRadius: '12px',
                                border: '2px solid #E5E7EB',
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                                position: 'relative',
                                overflow: 'hidden'
                              }}>
                                <div style={{
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  height: '4px',
                                  background: 'linear-gradient(90deg, #FF8C42 0%, #FFA366 100%)'
                                }}></div>
                                
                                <div style={{ marginTop: '0.5rem' }}>
                                  <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500', marginBottom: '1rem', display: 'block' }}>Base Fee Information</span>
                                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.25rem' }}>
                                    {viewingStudent.base_fee_type && (
                <div>
                                        <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Fee Type</span>
                                        <div style={{ color: '#1F2937', fontSize: '0.95rem', fontWeight: '600', marginTop: '0.25rem', textTransform: 'capitalize' }}>
                                          {viewingStudent.base_fee_type}
                </div>
              </div>
                                    )}
                                    {viewingStudent.base_fee_amount && (
                                      <div>
                                        <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Base Fee Amount</span>
                                        <div style={{ color: '#1F2937', fontSize: '0.95rem', fontWeight: '600', marginTop: '0.25rem' }}>
                                          {viewingStudent.fee_currency || 'PKR'} {parseFloat(viewingStudent.base_fee_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </div>
                                      </div>
                                    )}
                                    {viewingStudent.fee_currency && (
                                      <div>
                                        <span style={{ color: '#6B7280', fontSize: '0.85rem', fontWeight: '500' }}>Currency</span>
                                        <div style={{ color: '#1F2937', fontSize: '0.95rem', fontWeight: '600', marginTop: '0.25rem' }}>
                                          {viewingStudent.fee_currency}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        ) : (
                          <div style={{
                            padding: '2rem',
                            textAlign: 'center',
                            color: '#6B7280',
                            fontStyle: 'italic',
                            background: '#F9FAFB',
                            borderRadius: '12px',
                            border: '2px dashed #D1D5DB'
                          }}>
                            💰 No fee information available for this student.
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Documents Tab */}
                  {activeTab === 'documents' && (
                    <div>
              <div className="detail-section" style={{ marginBottom: '2rem' }}>
                        <h4 style={{ color: '#FF8C42', marginBottom: '1.5rem', fontSize: '1.2rem', borderBottom: '2px solid #FF8C42', paddingBottom: '0.5rem' }}>
                          Student Documents
                </h4>
                <div>
                  {viewingStudent.documents && viewingStudent.documents.length > 0 ? (
                            <div style={{ display: 'grid', gap: '1rem' }}>
                      {viewingStudent.documents.map((doc, index) => (
                                <div 
                                  key={doc.id || index} 
                                  style={{
                                    padding: '1.25rem',
                                    background: '#FFFFFF',
                                    borderRadius: '12px',
                                    border: '2px solid #E5E7EB',
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                          display: 'flex',
                          justifyContent: 'space-between',
                                    alignItems: 'center',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer',
                                    position: 'relative',
                                    overflow: 'hidden'
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = '#FF8C42';
                                    e.currentTarget.style.boxShadow = '0 4px 8px rgba(255, 140, 66, 0.15)';
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = '#E5E7EB';
                                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.05)';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                  }}
                                >
                                  <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    height: '3px',
                                    background: 'linear-gradient(90deg, #FF8C42 0%, #FFA366 100%)'
                                  }}></div>
                                  
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flex: 1, marginTop: '0.5rem' }}>
                                    <div style={{
                                      width: '48px',
                                      height: '48px',
                                      borderRadius: '8px',
                                      background: '#EFF6FF',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      fontSize: '1.75rem'
                                    }}>
                                      {doc.document_type?.toLowerCase().includes('birth') ? '🎂' :
                                       doc.document_type?.toLowerCase().includes('certificate') ? '📜' :
                                       doc.document_type?.toLowerCase().includes('id') ? '🆔' :
                                       doc.document_type?.toLowerCase().includes('medical') ? '🏥' :
                                       '📄'}
                                    </div>
                                    <div style={{ flex: 1 }}>
                                      <div style={{ fontWeight: '600', color: '#1F2937', fontSize: '1rem', marginBottom: '0.35rem' }}>
                                        {doc.document_type || 'Document'}
                                      </div>
                            <a 
                              href={doc.document_url} 
                              target="_blank" 
                              rel="noopener noreferrer"
                                        onClick={async (e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          console.log('Document URL before processing:', doc.document_url);
                                          const newUrl = await getValidFileUrl(doc.document_url);
                                          console.log('Document URL after processing:', newUrl);
                                          if (newUrl) {
                                            window.open(newUrl, '_blank');
                                          } else {
                                            alert('Unable to access document. Please try again or contact support.');
                                          }
                                        }}
                              style={{ 
                                          color: '#1F2937', 
                                          textDecoration: 'none',
                                          fontSize: '0.9rem',
                                          fontWeight: '500'
                                        }}
                                        onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                                        onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                            >
                                        {doc.file_name || 'View Document'} →
                            </a>
                          </div>
                                  </div>
                                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '0.35rem', marginTop: '0.5rem' }}>
                          {doc.file_size && (
                                      <span style={{ 
                                        color: '#6B7280', 
                                        fontSize: '0.85rem',
                                        padding: '0.25rem 0.5rem',
                                        background: '#F3F4F6',
                                        borderRadius: '6px'
                                      }}>
                              {(doc.file_size / 1024 / 1024).toFixed(2)} MB
                            </span>
                          )}
                                    {doc.uploaded_at && (
                                      <span style={{ 
                                        color: '#9CA3AF', 
                                        fontSize: '0.75rem'
                                      }}>
                                        {new Date(doc.uploaded_at).toLocaleDateString()}
                            </span>
                          )}
                                  </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                            <div style={{ 
                              padding: '3rem 2rem', 
                              textAlign: 'center',
                              color: '#6B7280', 
                              fontStyle: 'italic',
                              background: '#F9FAFB',
                              borderRadius: '12px',
                              border: '2px dashed #D1D5DB'
                            }}>
                              📄 No documents uploaded yet.
                    </div>
                  )}
                </div>
              </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Edit Student Popup */}
      {editingStudent && (
        <div className="popup-overlay">
          <div className="popup-content" style={{ maxWidth: '1400px', width: '95%' }}>
            <div className="popup-header edit-student-header" style={{ backgroundColor: '#FF8C42', borderRadius: '8px 8px 0 0', padding: '1rem 1.5rem' }}>
              <div style={{ flex: 1 }}>
                <h3 style={{ color: '#FFFFFF', margin: 0, fontWeight: '600' }}>Edit Student</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem', marginTop: '0.25rem' }}>
                  {editingStudent?.created_at && (
                    <p style={{ 
                      color: '#FFFFFF', 
                      margin: 0, 
                      fontSize: '0.8rem', 
                      opacity: 0.85,
                      fontWeight: '400'
                    }}>
                      Created: {new Date(editingStudent.created_at).toLocaleString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                      })}
                    </p>
                  )}
                  {editingStudent?.updated_at && (
                    <p style={{ 
                      color: '#FFFFFF', 
                      margin: 0, 
                      fontSize: '0.8rem', 
                      opacity: 0.85,
                      fontWeight: '400'
                    }}>
                      Last Updated: {new Date(editingStudent.updated_at).toLocaleString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                      })}
                    </p>
                  )}
                  <p style={{ 
                    color: '#FFFFFF', 
                    margin: '0.2rem 0 0 0', 
                    fontSize: '0.75rem', 
                    opacity: 0.75,
                    fontStyle: 'italic',
                    fontWeight: '300'
                  }}>
                    Changes will be saved with current date and time
                  </p>
                </div>
              </div>
              <button 
                className="close-btn edit-student-close" 
                onClick={closeEditPopup} 
                style={{ 
                  color: '#FFFFFF',
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  padding: '0.25rem',
                  borderRadius: '4px',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'none';
                }}
              >
                ×
              </button>
            </div>
            
            <form onSubmit={handleEditSubmit} className="edit-student-form" key={editingStudent?.id || 'edit-form'}>
              {/* Tab Navigation */}
              <div className="edit-student-tabs" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(5, 1fr)',
                borderBottom: '2px solid #E5E7EB',
                backgroundColor: '#F9FAFB',
                marginBottom: '1.5rem'
                }}>
                  {[
                    { id: 'personal', label: 'Student Details' },
                    { id: 'parents', label: 'Parents Details' },
                    { id: 'siblings', label: 'Siblings Details' },
                    { id: 'teachers', label: 'Teachers Details' },
                  { id: 'medical', label: 'Medical Records' },
                    { id: 'academic', label: 'Academic Details' },
                    { id: 'transport', label: 'School Transport' },
                    { id: 'fees', label: 'Fees Payments' },
                    { id: 'documents', label: 'Documents' }
                  ].map(tab => (
                    <button
                      key={tab.id}
                      type="button"
                      onClick={() => setActiveEditTab(tab.id)}
                      style={{
                      padding: '1rem 0.75rem',
                        border: 'none',
                      backgroundColor: 'transparent',
                      color: activeEditTab === tab.id ? '#FF8C42' : '#6B7280',
                        fontWeight: activeEditTab === tab.id ? '600' : '400',
                      fontSize: '0.85rem',
                      cursor: 'pointer',
                      borderBottom: activeEditTab === tab.id ? '3px solid #FF8C42' : '3px solid transparent',
                        transition: 'all 0.2s ease',
                        whiteSpace: 'nowrap',
                      textAlign: 'center',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                      }}
                      onMouseEnter={(e) => {
                        if (activeEditTab !== tab.id) {
                        e.target.style.color = '#374151';
                        e.target.style.backgroundColor = '#F3F4F6';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (activeEditTab !== tab.id) {
                        e.target.style.color = '#6B7280';
                        e.target.style.backgroundColor = 'transparent';
                        }
                      }}
                    >
                      {tab.label}
                    </button>
                  ))}
              </div>

              {/* Personal Info Tab */}
              {activeEditTab === 'personal' && (
              <div className="form-section">
                <h4>A) Student Information</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="editFirstName">First Name *</label>
                    <input
                      type="text"
                      id="editFirstName"
                      name="firstName"
                      value={editForm.firstName || ''}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        handleEditInputChange('firstName', newValue);
                      }}
                      className={editErrors.firstName ? 'error' : ''}
                      placeholder="Enter first name"
                      autoComplete="off"
                    />
                    {editErrors.firstName && (
                      <span className="error-text">{editErrors.firstName}</span>
                    )}
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="editMiddleName">Middle Name</label>
                    <input
                      type="text"
                      id="editMiddleName"
                      name="middleName"
                      value={editForm.middleName || ''}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        handleEditInputChange('middleName', newValue);
                      }}
                      placeholder="Enter middle name (optional)"
                      autoComplete="off"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="editLastName">Last Name *</label>
                    <input
                      type="text"
                      id="editLastName"
                      name="lastName"
                      value={editForm.lastName || ''}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        handleEditInputChange('lastName', newValue);
                      }}
                      className={editErrors.lastName ? 'error' : ''}
                      placeholder="Enter last name"
                      autoComplete="off"
                    />
                    {editErrors.lastName && (
                      <span className="error-text">{editErrors.lastName}</span>
                    )}
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="editEmail">Email *</label>
                    <input
                      type="email"
                      id="editEmail"
                      value={editForm.email}
                      onChange={(e) => handleEditInputChange('email', e.target.value)}
                      className={editErrors.email ? 'error' : ''}
                      placeholder="Enter email"
                    />
                    {editErrors.email && (
                      <span className="error-text">{editErrors.email}</span>
                    )}
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="editPhone">Student Phone *</label>
                    <div className="phone-input-wrapper">
                      <select
                        className="country-code-select"
                        value={editStudentPhoneCountryCode}
                        onChange={(e) => setEditStudentPhoneCountryCode(e.target.value)}
                      >
                        <option value="+1">🇺🇸 +1 (US/CA)</option>
                        <option value="+44">🇬🇧 +44 (UK)</option>
                        <option value="+91">🇮🇳 +91 (India)</option>
                        <option value="+92">🇵🇰 +92 (Pakistan)</option>
                        <option value="+971">🇦🇪 +971 (UAE)</option>
                        <option value="+966">🇸🇦 +966 (Saudi Arabia)</option>
                        <option value="+974">🇶🇦 +974 (Qatar)</option>
                        <option value="+965">🇰🇼 +965 (Kuwait)</option>
                        <option value="+973">🇧🇭 +973 (Bahrain)</option>
                        <option value="+968">🇴🇲 +968 (Oman)</option>
                        <option value="+961">🇱🇧 +961 (Lebanon)</option>
                        <option value="+962">🇯🇴 +962 (Jordan)</option>
                        <option value="+20">🇪🇬 +20 (Egypt)</option>
                        <option value="+27">🇿🇦 +27 (South Africa)</option>
                        <option value="+61">🇦🇺 +61 (Australia)</option>
                        <option value="+64">🇳🇿 +64 (New Zealand)</option>
                        <option value="+86">🇨🇳 +86 (China)</option>
                        <option value="+81">🇯🇵 +81 (Japan)</option>
                        <option value="+82">🇰🇷 +82 (South Korea)</option>
                        <option value="+65">🇸🇬 +65 (Singapore)</option>
                        <option value="+60">🇲🇾 +60 (Malaysia)</option>
                        <option value="+66">🇹🇭 +66 (Thailand)</option>
                        <option value="+62">🇮🇩 +62 (Indonesia)</option>
                        <option value="+63">🇵🇭 +63 (Philippines)</option>
                        <option value="+84">🇻🇳 +84 (Vietnam)</option>
                        <option value="+880">🇧🇩 +880 (Bangladesh)</option>
                        <option value="+94">🇱🇰 +94 (Sri Lanka)</option>
                        <option value="+977">🇳🇵 +977 (Nepal)</option>
                        <option value="+33">🇫🇷 +33 (France)</option>
                        <option value="+49">🇩🇪 +49 (Germany)</option>
                        <option value="+39">🇮🇹 +39 (Italy)</option>
                        <option value="+34">🇪🇸 +34 (Spain)</option>
                        <option value="+31">🇳🇱 +31 (Netherlands)</option>
                        <option value="+32">🇧🇪 +32 (Belgium)</option>
                        <option value="+41">🇨🇭 +41 (Switzerland)</option>
                        <option value="+43">🇦🇹 +43 (Austria)</option>
                        <option value="+46">🇸🇪 +46 (Sweden)</option>
                        <option value="+47">🇳🇴 +47 (Norway)</option>
                        <option value="+45">🇩🇰 +45 (Denmark)</option>
                        <option value="+358">🇫🇮 +358 (Finland)</option>
                        <option value="+7">🇷🇺 +7 (Russia)</option>
                        <option value="+90">🇹🇷 +90 (Turkey)</option>
                        <option value="+52">🇲🇽 +52 (Mexico)</option>
                        <option value="+55">🇧🇷 +55 (Brazil)</option>
                        <option value="+54">🇦🇷 +54 (Argentina)</option>
                        <option value="+57">🇨🇴 +57 (Colombia)</option>
                        <option value="+234">🇳🇬 +234 (Nigeria)</option>
                        <option value="+254">🇰🇪 +254 (Kenya)</option>
                        <option value="+212">🇲🇦 +212 (Morocco)</option>
                        <option value="+972">🇮🇱 +972 (Israel)</option>
                        <option value="+98">🇮🇷 +98 (Iran)</option>
                        <option value="+964">🇮🇶 +964 (Iraq)</option>
                        <option value="+967">🇾🇪 +967 (Yemen)</option>
                        <option value="+963">🇸🇾 +963 (Syria)</option>
                      </select>
                      <input
                        type="tel"
                        id="editPhone"
                        value={editForm.phone}
                        onChange={(e) => handleEditInputChange('phone', e.target.value)}
                        className={editErrors.phone ? 'error' : ''}
                        placeholder="e.g. 300 1234567"
                      />
                    </div>
                    {editErrors.phone && (
                      <span className="error-text">{editErrors.phone}</span>
                    )}
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="editAddress">Address *</label>
                    <input
                      type="text"
                      id="editAddress"
                      value={editForm.address}
                      onChange={(e) => handleEditInputChange('address', e.target.value)}
                      className={editErrors.address ? 'error' : ''}
                      placeholder="Enter address"
                    />
                    {editErrors.address && (
                      <span className="error-text">{editErrors.address}</span>
                    )}
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="editProfilePicture">Profile Picture</label>
                    <input
                      type="file"
                      id="editProfilePicture"
                      name="editProfilePicture"
                      onChange={handleEditFileChange}
                      accept="image/*"
                      className={editErrors.profilePicture ? 'error' : ''}
                    />
                    {editErrors.profilePicture && (
                      <span className="error-text">{editErrors.profilePicture}</span>
                    )}
                    <small className="form-help">
                      Upload a new profile picture (JPG, PNG, GIF - Max 5MB)
                    </small>
                    {editingStudent?.profile_picture_url && (
                      <div className="current-picture" style={{ marginTop: '1rem' }}>
                        <p style={{ marginBottom: '0.5rem', fontSize: '0.9rem', color: '#6B7280' }}>Current picture:</p>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <img 
                          src={editingStudent.profile_picture_url} 
                          alt="Current profile" 
                            style={{ 
                              width: '100px', 
                              height: '100px', 
                              objectFit: 'cover', 
                              borderRadius: '50%',
                              border: '3px solid #FF8C42',
                              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                            }}
                            onError={async (e) => {
                              console.error('Profile picture load error in edit, attempting to regenerate URL');
                              const originalUrl = editingStudent.profile_picture_url;
                              const newUrl = await getValidFileUrl(originalUrl);
                              if (newUrl && newUrl !== originalUrl) {
                                e.target.src = newUrl;
                                // Update editingStudent with new URL
                                setEditingStudent(prev => ({
                                  ...prev,
                                  profile_picture_url: newUrl
                                }));
                              } else {
                                e.target.style.display = 'none';
                              }
                            }}
                          />
                          <a 
                            href={editingStudent.profile_picture_url} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            onClick={async (e) => {
                              e.preventDefault();
                              const newUrl = await getValidFileUrl(editingStudent.profile_picture_url);
                              if (newUrl) {
                                window.open(newUrl, '_blank');
                              } else {
                                alert('Unable to access profile picture. Please try again.');
                              }
                            }}
                            style={{ 
                              color: '#1F2937', 
                              textDecoration: 'none',
                              fontSize: '0.85rem',
                              fontWeight: '500',
                              padding: '0.5rem 1rem',
                              background: '#F3F4F6',
                              borderRadius: '6px',
                              display: 'inline-block'
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.textDecoration = 'underline';
                              e.target.style.background = '#E5E7EB';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.textDecoration = 'none';
                              e.target.style.background = '#F3F4F6';
                            }}
                          >
                            View Full Size →
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              )}

              {/* Academic Details Tab */}
              {activeEditTab === 'academic' && (
              <div className="form-section">
                <h4>Academic Details</h4>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="editClassId">Class</label>
                    <select
                      id="editClassId"
                      value={editForm.classId}
                      onChange={(e) => handleEditInputChange('classId', e.target.value)}
                      className={editErrors.classId ? 'error' : ''}
                    >
                      <option value="">
                        {loadingClasses ? 'Loading classes...' : 'Select Class'}
                      </option>
                      {classes.map((cls) => (
                        <option key={cls.id} value={cls.id}>
                          {cls.class_name}
                        </option>
                      ))}
                    </select>
                    {editErrors.classId && (
                      <span className="error-text">{editErrors.classId}</span>
                    )}
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="editSectionId">Section</label>
                    <select
                      id="editSectionId"
                      value={editForm.sectionId}
                      onChange={(e) => handleEditInputChange('sectionId', e.target.value)}
                      className={editErrors.sectionId ? 'error' : ''}
                      disabled={!editForm.classId || loadingSections}
                    >
                      <option value="">
                        {!editForm.classId 
                          ? 'Select Class First' 
                          : loadingSections 
                            ? 'Loading sections...' 
                            : 'Select Section'
                        }
                      </option>
                      {sections.map((section, index) => (
                        <option key={index} value={section}>
                          {section}
                        </option>
                      ))}
                    </select>
                    {editErrors.sectionId && (
                      <span className="error-text">{editErrors.sectionId}</span>
                    )}
                    {editForm.classId && sections.length === 0 && !loadingSections && (
                      <span className="error-text">No sections available for this class.</span>
                    )}
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="editDateOfBirth">Date of Birth *</label>
                    <input
                      type="date"
                      id="editDateOfBirth"
                      value={editForm.dateOfBirth}
                      onChange={(e) => handleEditInputChange('dateOfBirth', e.target.value)}
                      className={editErrors.dateOfBirth ? 'error' : ''}
                    />
                    {editErrors.dateOfBirth && (
                      <span className="error-text">{editErrors.dateOfBirth}</span>
                    )}
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="editGender">Gender *</label>
                    <select
                      id="editGender"
                      value={editForm.gender}
                      onChange={(e) => handleEditInputChange('gender', e.target.value)}
                      className={editErrors.gender ? 'error' : ''}
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                    {editErrors.gender && (
                      <span className="error-text">{editErrors.gender}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="editNationality">Nationality *</label>
                    <input
                      type="text"
                      id="editNationality"
                      value={editForm.nationality}
                      onChange={(e) => handleEditInputChange('nationality', e.target.value)}
                      className={editErrors.nationality ? 'error' : ''}
                      placeholder="Enter nationality"
                    />
                    {editErrors.nationality && (
                      <span className="error-text">{editErrors.nationality}</span>
                    )}
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="editAdmissionDate">Admission Date *</label>
                    <input
                      type="date"
                      id="editAdmissionDate"
                      value={editForm.admissionDate}
                      onChange={(e) => handleEditInputChange('admissionDate', e.target.value)}
                      className={editErrors.admissionDate ? 'error' : ''}
                    />
                    {editErrors.admissionDate && (
                      <span className="error-text">{editErrors.admissionDate}</span>
                    )}
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="editPreviousSchool">Previous School (optional)</label>
                    <input
                      type="text"
                      id="editPreviousSchool"
                      value={editForm.previousSchool}
                      onChange={(e) => handleEditInputChange('previousSchool', e.target.value)}
                      placeholder="Enter previous school (if applicable)"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="editPreviousSchoolGrade">Previous School Grade/Percentage (optional)</label>
                    <input
                      type="text"
                      id="editPreviousSchoolGrade"
                      value={editForm.previousSchoolGrade}
                      onChange={(e) => handleEditInputChange('previousSchoolGrade', e.target.value)}
                      placeholder="Enter grade or percentage from previous school"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="editStudentIdNo">Student ID No.</label>
                    <input
                      type="text"
                      id="editStudentIdNo"
                      value={editForm.studentIdNo}
                      onChange={(e) => handleEditInputChange('studentIdNo', e.target.value)}
                      placeholder="Student ID number"
                    />
                  </div>
                </div>

                {/* Password Change Section */}
                <div style={{ marginTop: '2rem', padding: '1.5rem', background: '#F9FAFB', borderRadius: '8px', border: '1px solid #E5E7EB' }}>
                  <h4 style={{ marginTop: 0, marginBottom: '1rem', color: '#2c3e50', fontSize: '1rem', fontWeight: '600' }}>Change Student Password</h4>
                  <div className="password-change-info" style={{ marginBottom: '1rem', padding: '0.75rem', background: '#E3F2FD', borderRadius: '6px', border: '1px solid #BBDEFB' }}>
                    <p style={{ margin: 0, color: '#0c5460', fontSize: '0.85rem', fontStyle: 'italic' }}>
                      Leave blank if you don't want to change the password
                    </p>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="editStudentPassword">New Password</label>
                      <div className="password-input-wrapper">
                        <input
                          type="password"
                          id="editStudentPassword"
                          name="studentPassword"
                          value={editForm.studentPassword || ''}
                          onChange={(e) => handleEditInputChange('studentPassword', e.target.value)}
                          placeholder="Enter new password"
                          className={editErrors.studentPassword ? 'error' : ''}
                        />
                      </div>
                      {editErrors.studentPassword && (
                        <span className="error-text">{editErrors.studentPassword}</span>
                      )}
                    </div>
                    
                    <div className="form-group">
                      <label htmlFor="editStudentConfirmPassword">Confirm Password</label>
                      <div className="password-input-wrapper">
                        <input
                          type="password"
                          id="editStudentConfirmPassword"
                          name="studentConfirmPassword"
                          value={editForm.studentConfirmPassword || ''}
                          onChange={(e) => handleEditInputChange('studentConfirmPassword', e.target.value)}
                          placeholder="Confirm new password"
                          className={editErrors.studentConfirmPassword ? 'error' : ''}
                        />
                      </div>
                      {editErrors.studentConfirmPassword && (
                        <span className="error-text">{editErrors.studentConfirmPassword}</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              )}

              {/* Parents Tab */}
              {activeEditTab === 'parents' && (
              <div className="form-section">
                <h4>Parent/Guardian Information</h4>
                {editForm.parents && Array.isArray(editForm.parents) && editForm.parents.length > 0 ? (
                  editForm.parents.map((parent, parentIndex) => (
                    <div key={parentIndex} style={{ 
                      marginBottom: '2rem', 
                      padding: '1.5rem', 
                      border: '1px solid #E5E7EB', 
                      borderRadius: '12px',
                      backgroundColor: '#FAFAFA',
                      position: 'relative'
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                        <h4 style={{ margin: 0, color: '#1F2937', fontSize: '1.1rem', fontWeight: '600' }}>
                          {getParentLabel(parent, parentIndex, editForm.parents)}
                        </h4>
                        {editForm.parents.length > 1 && (
                          <button
                            type="button"
                            onClick={() => handleRemoveParent(parentIndex)}
                            style={{
                              padding: '0.5rem 1rem',
                              background: '#EF4444',
                              color: '#FFFFFF',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              fontSize: '0.875rem',
                              fontWeight: '500',
                              transition: 'all 0.2s ease',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '0.5rem'
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.background = '#DC2626';
                              e.target.style.transform = 'translateY(-1px)';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.background = '#EF4444';
                              e.target.style.transform = 'translateY(0)';
                            }}
                          >
                            <span>🗑️</span>
                            Remove Parent
                          </button>
                        )}
                      </div>
                      
                      <div className="form-row">
                        <div className="form-group">
                          <label htmlFor={`editParentName-${parentIndex}`}>Parent Name *</label>
                          <input
                            type="text"
                            id={`editParentName-${parentIndex}`}
                            value={parent.name || ''}
                            onChange={(e) => handleEditParentChange(parentIndex, 'name', e.target.value)}
                            className={editErrors[`parents.${parentIndex}.name`] ? 'error' : ''}
                            placeholder="Enter parent name"
                          />
                          {editErrors[`parents.${parentIndex}.name`] && (
                            <span className="error-text">{editErrors[`parents.${parentIndex}.name`]}</span>
                          )}
                        </div>
                        
                        <div className="form-group">
                          <label htmlFor={`editParentEmail-${parentIndex}`}>Parent Email *</label>
                          <input
                            type="email"
                            id={`editParentEmail-${parentIndex}`}
                            value={parent.email || ''}
                            onChange={(e) => handleEditParentChange(parentIndex, 'email', e.target.value)}
                            className={editErrors[`parents.${parentIndex}.email`] ? 'error' : ''}
                            placeholder="Enter parent email"
                          />
                          {editErrors[`parents.${parentIndex}.email`] && (
                            <span className="error-text">{editErrors[`parents.${parentIndex}.email`]}</span>
                          )}
                        </div>
                      </div>
                      
                      <div className="form-row">
                        <div className="form-group">
                          <label htmlFor={`editParentPhone-${parentIndex}`}>Parent Phone *</label>
                          <div className="phone-input-wrapper">
                            <select
                              className="country-code-select"
                              value={(editParentPhoneCountryCodes && editParentPhoneCountryCodes[parentIndex]) || '+254'}
                              onChange={(e) => {
                                const currentCodes = [...(editParentPhoneCountryCodes || [])];
                                while (currentCodes.length <= parentIndex) {
                                  currentCodes.push('+254'); // Default: Kenya
                                }
                                currentCodes[parentIndex] = e.target.value;
                                setEditParentPhoneCountryCodes(currentCodes);
                              }}
                            >
                              <option value="+1">🇺🇸 +1 (US/CA)</option>
                              <option value="+44">🇬🇧 +44 (UK)</option>
                              <option value="+91">🇮🇳 +91 (India)</option>
                              <option value="+92">🇵🇰 +92 (Pakistan)</option>
                              <option value="+971">🇦🇪 +971 (UAE)</option>
                              <option value="+966">🇸🇦 +966 (Saudi Arabia)</option>
                              <option value="+974">🇶🇦 +974 (Qatar)</option>
                              <option value="+965">🇰🇼 +965 (Kuwait)</option>
                              <option value="+973">🇧🇭 +973 (Bahrain)</option>
                              <option value="+968">🇴🇲 +968 (Oman)</option>
                              <option value="+961">🇱🇧 +961 (Lebanon)</option>
                              <option value="+962">🇯🇴 +962 (Jordan)</option>
                              <option value="+20">🇪🇬 +20 (Egypt)</option>
                              <option value="+27">🇿🇦 +27 (South Africa)</option>
                              <option value="+61">🇦🇺 +61 (Australia)</option>
                              <option value="+64">🇳🇿 +64 (New Zealand)</option>
                              <option value="+86">🇨🇳 +86 (China)</option>
                              <option value="+81">🇯🇵 +81 (Japan)</option>
                              <option value="+82">🇰🇷 +82 (South Korea)</option>
                              <option value="+65">🇸🇬 +65 (Singapore)</option>
                              <option value="+60">🇲🇾 +60 (Malaysia)</option>
                              <option value="+66">🇹🇭 +66 (Thailand)</option>
                              <option value="+62">🇮🇩 +62 (Indonesia)</option>
                              <option value="+63">🇵🇭 +63 (Philippines)</option>
                              <option value="+84">🇻🇳 +84 (Vietnam)</option>
                              <option value="+880">🇧🇩 +880 (Bangladesh)</option>
                              <option value="+94">🇱🇰 +94 (Sri Lanka)</option>
                              <option value="+977">🇳🇵 +977 (Nepal)</option>
                              <option value="+33">🇫🇷 +33 (France)</option>
                              <option value="+49">🇩🇪 +49 (Germany)</option>
                              <option value="+39">🇮🇹 +39 (Italy)</option>
                              <option value="+34">🇪🇸 +34 (Spain)</option>
                              <option value="+31">🇳🇱 +31 (Netherlands)</option>
                              <option value="+32">🇧🇪 +32 (Belgium)</option>
                              <option value="+41">🇨🇭 +41 (Switzerland)</option>
                              <option value="+43">🇦🇹 +43 (Austria)</option>
                              <option value="+46">🇸🇪 +46 (Sweden)</option>
                              <option value="+47">🇳🇴 +47 (Norway)</option>
                              <option value="+45">🇩🇰 +45 (Denmark)</option>
                              <option value="+358">🇫🇮 +358 (Finland)</option>
                              <option value="+7">🇷🇺 +7 (Russia)</option>
                              <option value="+90">🇹🇷 +90 (Turkey)</option>
                              <option value="+52">🇲🇽 +52 (Mexico)</option>
                              <option value="+55">🇧🇷 +55 (Brazil)</option>
                              <option value="+54">🇦🇷 +54 (Argentina)</option>
                              <option value="+57">🇨🇴 +57 (Colombia)</option>
                              <option value="+234">🇳🇬 +234 (Nigeria)</option>
                              <option value="+254">🇰🇪 +254 (Kenya)</option>
                              <option value="+212">🇲🇦 +212 (Morocco)</option>
                              <option value="+972">🇮🇱 +972 (Israel)</option>
                              <option value="+98">🇮🇷 +98 (Iran)</option>
                              <option value="+964">🇮🇶 +964 (Iraq)</option>
                              <option value="+967">🇾🇪 +967 (Yemen)</option>
                              <option value="+963">🇸🇾 +963 (Syria)</option>
                            </select>
                            <input
                              type="tel"
                              id={`editParentPhone-${parentIndex}`}
                              value={parent.phone || ''}
                              onChange={(e) => handleEditParentChange(parentIndex, 'phone', e.target.value)}
                              className={editErrors[`parents.${parentIndex}.phone`] ? 'error' : ''}
                              placeholder="e.g. 300 1234567"
                            />
                          </div>
                          {editErrors[`parents.${parentIndex}.phone`] && (
                            <span className="error-text">{editErrors[`parents.${parentIndex}.phone`]}</span>
                          )}
                        </div>

                        <div className="form-group">
                          <label>Relationship *</label>
                          <div className="parent-selection-toggle">
                            <button
                              type="button"
                              className={`toggle-btn ${parent.relationship === 'Mother' ? 'active' : ''}`}
                              onClick={() => handleEditParentChange(parentIndex, 'relationship', 'Mother')}
                            >
                              Mother
                            </button>
                            <button
                              type="button"
                              className={`toggle-btn ${parent.relationship === 'Father' ? 'active' : ''}`}
                              onClick={() => handleEditParentChange(parentIndex, 'relationship', 'Father')}
                            >
                              Father
                            </button>
                            <button
                              type="button"
                              className={`toggle-btn ${parent.relationship === 'Guardian' ? 'active' : ''}`}
                              onClick={() => handleEditParentChange(parentIndex, 'relationship', 'Guardian')}
                            >
                              Guardian
                            </button>
                          </div>
                          {editErrors[`parents.${parentIndex}.relationship`] && (
                            <span className="error-text">{editErrors[`parents.${parentIndex}.relationship`]}</span>
                          )}
                        </div>
                      </div>

                      <div className="form-row">
                        <div className="form-group">
                          <label htmlFor={`editParentPrimaryContact-${parentIndex}`}>Contact Priority</label>
                          <select
                            id={`editParentPrimaryContact-${parentIndex}`}
                            value={parent.primaryContact || 'primary'}
                            onChange={(e) => handleEditParentChange(parentIndex, 'primaryContact', e.target.value)}
                          >
                            <option value="primary">Primary</option>
                            <option value="secondary">Secondary</option>
                          </select>
                        </div>

                        <div className="form-group">
                          <label htmlFor={`editParentAddress-${parentIndex}`}>Parent Address (optional)</label>
                          <input
                            type="text"
                            id={`editParentAddress-${parentIndex}`}
                            value={parent.address || ''}
                            onChange={(e) => handleEditParentChange(parentIndex, 'address', e.target.value)}
                            placeholder="If different from student's address"
                          />
                        </div>
                      </div>

                      <div className="form-row">
                        <div className="form-group" style={{ width: '100%' }}>
                          <label style={{ marginBottom: '0.75rem', display: 'block', fontWeight: '500' }}>
                            Permissions
                          </label>
                          <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                            gap: '0.75rem',
                            padding: '1rem',
                            background: '#FFFFFF',
                            border: '1px solid #E5E7EB',
                            borderRadius: '12px',
                            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
                          }}>
                            {[
                              { field: 'canPickup', label: 'Can pick from school' },
                              { field: 'isEmergencyContact', label: 'Emergency contact' },
                              { field: 'paysFees', label: 'Pays fees' }
                            ].map((permission) => {
                              const isChecked = parent[permission.field] || false;
                              return (
                                <div
                                  key={permission.field}
                                  onClick={() => {
                                    handleEditParentChange(parentIndex, permission.field, !isChecked);
                                  }}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '1rem',
                                    cursor: 'pointer',
                                    borderRadius: '10px',
                                    background: isChecked ? '#FF8C42' : '#FFFFFF',
                                    border: isChecked ? '2px solid #E67E22' : '1px solid #E5E7EB',
                                    transition: 'all 0.2s ease',
                                    position: 'relative'
                                  }}
                                  onMouseEnter={(e) => {
                                    if (!isChecked) {
                                      e.currentTarget.style.background = '#FFF4ED';
                                      e.currentTarget.style.borderColor = '#FFD4B3';
                                    }
                                  }}
                                  onMouseLeave={(e) => {
                                    if (!isChecked) {
                                      e.currentTarget.style.background = '#FFFFFF';
                                      e.currentTarget.style.borderColor = '#E5E7EB';
                                    }
                                  }}
                                >
                                  <div style={{
                                    width: '24px',
                                    height: '24px',
                                    minWidth: '24px',
                                    marginRight: '0.75rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: isChecked ? '#FFFFFF' : '#FFFFFF',
                                    border: isChecked ? '2px solid #FFFFFF' : '2px solid #D1D5DB',
                                    borderRadius: '6px',
                                    transition: 'all 0.2s ease',
                                    flexShrink: 0
                                  }}>
                                    {isChecked && (
                                      <svg
                                        width="14"
                                        height="14"
                                        viewBox="0 0 14 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M11.6667 3.5L5.25 9.91667L2.33334 7"
                                          stroke="#FF8C42"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    )}
                                  </div>
                                  <span style={{
                                    fontSize: '0.95rem',
                                    fontWeight: '500',
                                    color: isChecked ? '#FFFFFF' : '#374151',
                                    userSelect: 'none'
                                  }}>
                                    {permission.label}
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div style={{
                    padding: '1.5rem',
                    background: '#FFFFFF',
                    borderRadius: '12px',
                    border: '2px solid #E5E7EB',
                    textAlign: 'center',
                    color: '#6B7280',
                    marginBottom: '2rem'
                  }}>
                    No parent information available.
                  </div>
                )}

                {/* Add Parent Button */}
                <div style={{ marginTop: '1rem', marginBottom: '2rem' }}>
                  <button
                    type="button"
                    onClick={handleAddParent}
                    style={{
                      padding: '0.75rem 1.5rem',
                      background: '#FF8C42',
                      color: '#FFFFFF',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '0.95rem',
                      fontWeight: '600',
                      transition: 'all 0.2s ease',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      margin: '0 auto'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = '#E67E22';
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 4px 8px rgba(255, 140, 66, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = '#FF8C42';
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                    }}
                  >
                    <span style={{ fontSize: '1.2rem' }}>➕</span>
                    Add Parent
                  </button>
                </div>

                {/* Parent Documents Display */}
                {editParentDocuments && editParentDocuments.length > 0 && (
                  <div className="form-section" style={{ marginTop: '2rem' }}>
                    <h4 style={{ color: '#FF8C42', marginBottom: '1rem', fontSize: '1.1rem', fontWeight: '600' }}>
                      Parent Documents
                    </h4>
                    <div style={{ display: 'grid', gap: '1rem' }}>
                      {editParentDocuments.map((parentDocGroup, groupIndex) => (
                        <div 
                          key={groupIndex}
                          style={{
                            padding: '1rem',
                            background: '#F9FAFB',
                            borderRadius: '8px',
                            border: '1px solid #E5E7EB',
                            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)'
                          }}
                        >
                          <h5 style={{ 
                            color: '#1F2937', 
                            marginBottom: '0.75rem', 
                            fontSize: '0.95rem', 
                            fontWeight: '600',
                            borderBottom: '1px solid #E5E7EB',
                            paddingBottom: '0.5rem'
                          }}>
                            {parentDocGroup.parent_name} ({parentDocGroup.parent_email})
                          </h5>
                          {parentDocGroup.documents && parentDocGroup.documents.length > 0 ? (
                            <div style={{ display: 'grid', gap: '0.5rem' }}>
                              {parentDocGroup.documents.map((doc, docIndex) => (
                                <div 
                                  key={doc.id || docIndex}
                                  style={{
                                    padding: '0.75rem',
                                    background: '#FFFFFF',
                                    borderRadius: '6px',
                                    border: '1px solid #E5E7EB',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    transition: 'all 0.2s ease'
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = '#FF8C42';
                                    e.currentTarget.style.background = '#FFF7ED';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = '#E5E7EB';
                                    e.currentTarget.style.background = '#FFFFFF';
                                  }}
                                >
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flex: 1 }}>
                                    <div style={{
                                      width: '32px',
                                      height: '32px',
                                      borderRadius: '6px',
                                      background: '#EFF6FF',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      fontSize: '1.1rem'
                                    }}>
                                      {doc.document_type?.toLowerCase().includes('national') || doc.document_type?.toLowerCase().includes('id') ? '🆔' :
                                       doc.document_type?.toLowerCase().includes('passport') ? '📘' :
                                       '📄'}
                                    </div>
                                    <div>
                                      <div style={{ fontWeight: '600', color: '#1F2937', fontSize: '0.9rem' }}>
                                        {doc.document_type || 'Document'}
                                      </div>
                                      <a 
                                        href={doc.document_url} 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        onClick={async (e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          const newUrl = await getValidFileUrl(doc.document_url);
                                          if (newUrl) {
                                            window.open(newUrl, '_blank');
                                          } else {
                                            alert('Unable to access document. Please try again or contact support.');
                                          }
                                        }}
                                        style={{ 
                                          color: '#1F2937', 
                                          textDecoration: 'none',
                                          fontSize: '0.85rem',
                                          fontWeight: '500'
                                        }}
                                        onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                                        onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                                      >
                                        {doc.file_name || 'View Document'} →
                                      </a>
                                    </div>
                                  </div>
                                  {doc.file_size && (
                                    <span style={{ 
                                      color: '#6B7280', 
                                      fontSize: '0.75rem',
                                      padding: '0.25rem 0.5rem',
                                      background: '#F3F4F6',
                                      borderRadius: '4px'
                                    }}>
                                      {(doc.file_size / 1024 / 1024).toFixed(2)} MB
                                    </span>
                                  )}
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div style={{
                              padding: '0.75rem',
                              textAlign: 'center',
                              color: '#6B7280',
                              fontSize: '0.85rem',
                              fontStyle: 'italic'
                            }}>
                              No documents uploaded for this parent
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              )}

              {/* Emergency Contact Tab */}
              {activeEditTab === 'emergency' && (
              <div className="form-section">
                <h4>C) Emergency Contact Information</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="editEmergencyContact">Emergency Contact *</label>
                    <input
                      type="text"
                      id="editEmergencyContact"
                      value={editForm.emergencyContact}
                      onChange={(e) => handleEditInputChange('emergencyContact', e.target.value)}
                      className={editErrors.emergencyContact ? 'error' : ''}
                      placeholder="Enter emergency contact"
                    />
                    {editErrors.emergencyContact && (
                      <span className="error-text">{editErrors.emergencyContact}</span>
                    )}
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="editEmergencyPhone">Emergency Phone *</label>
                    <div className="phone-input-wrapper">
                      <select
                        className="country-code-select"
                        value={editEmergencyPhoneCountryCode}
                        onChange={(e) => setEditEmergencyPhoneCountryCode(e.target.value)}
                      >
                        <option value="+1">🇺🇸 +1 (US/CA)</option>
                        <option value="+44">🇬🇧 +44 (UK)</option>
                        <option value="+91">🇮🇳 +91 (India)</option>
                        <option value="+92">🇵🇰 +92 (Pakistan)</option>
                        <option value="+971">🇦🇪 +971 (UAE)</option>
                        <option value="+966">🇸🇦 +966 (Saudi Arabia)</option>
                        <option value="+974">🇶🇦 +974 (Qatar)</option>
                        <option value="+965">🇰🇼 +965 (Kuwait)</option>
                        <option value="+973">🇧🇭 +973 (Bahrain)</option>
                        <option value="+968">🇴🇲 +968 (Oman)</option>
                        <option value="+961">🇱🇧 +961 (Lebanon)</option>
                        <option value="+962">🇯🇴 +962 (Jordan)</option>
                        <option value="+20">🇪🇬 +20 (Egypt)</option>
                        <option value="+27">🇿🇦 +27 (South Africa)</option>
                        <option value="+61">🇦🇺 +61 (Australia)</option>
                        <option value="+64">🇳🇿 +64 (New Zealand)</option>
                        <option value="+86">🇨🇳 +86 (China)</option>
                        <option value="+81">🇯🇵 +81 (Japan)</option>
                        <option value="+82">🇰🇷 +82 (South Korea)</option>
                        <option value="+65">🇸🇬 +65 (Singapore)</option>
                        <option value="+60">🇲🇾 +60 (Malaysia)</option>
                        <option value="+66">🇹🇭 +66 (Thailand)</option>
                        <option value="+62">🇮🇩 +62 (Indonesia)</option>
                        <option value="+63">🇵🇭 +63 (Philippines)</option>
                        <option value="+84">🇻🇳 +84 (Vietnam)</option>
                        <option value="+880">🇧🇩 +880 (Bangladesh)</option>
                        <option value="+94">🇱🇰 +94 (Sri Lanka)</option>
                        <option value="+977">🇳🇵 +977 (Nepal)</option>
                        <option value="+33">🇫🇷 +33 (France)</option>
                        <option value="+49">🇩🇪 +49 (Germany)</option>
                        <option value="+39">🇮🇹 +39 (Italy)</option>
                        <option value="+34">🇪🇸 +34 (Spain)</option>
                        <option value="+31">🇳🇱 +31 (Netherlands)</option>
                        <option value="+32">🇧🇪 +32 (Belgium)</option>
                        <option value="+41">🇨🇭 +41 (Switzerland)</option>
                        <option value="+43">🇦🇹 +43 (Austria)</option>
                        <option value="+46">🇸🇪 +46 (Sweden)</option>
                        <option value="+47">🇳🇴 +47 (Norway)</option>
                        <option value="+45">🇩🇰 +45 (Denmark)</option>
                        <option value="+358">🇫🇮 +358 (Finland)</option>
                        <option value="+7">🇷🇺 +7 (Russia)</option>
                        <option value="+90">🇹🇷 +90 (Turkey)</option>
                        <option value="+52">🇲🇽 +52 (Mexico)</option>
                        <option value="+55">🇧🇷 +55 (Brazil)</option>
                        <option value="+54">🇦🇷 +54 (Argentina)</option>
                        <option value="+57">🇨🇴 +57 (Colombia)</option>
                        <option value="+234">🇳🇬 +234 (Nigeria)</option>
                        <option value="+254">🇰🇪 +254 (Kenya)</option>
                        <option value="+212">🇲🇦 +212 (Morocco)</option>
                        <option value="+972">🇮🇱 +972 (Israel)</option>
                        <option value="+98">🇮🇷 +98 (Iran)</option>
                        <option value="+964">🇮🇶 +964 (Iraq)</option>
                        <option value="+967">🇾🇪 +967 (Yemen)</option>
                        <option value="+963">🇸🇾 +963 (Syria)</option>
                      </select>
                      <input
                        type="tel"
                        id="editEmergencyPhone"
                        value={editForm.emergencyPhone}
                        onChange={(e) => handleEditInputChange('emergencyPhone', e.target.value)}
                        className={editErrors.emergencyPhone ? 'error' : ''}
                        placeholder="e.g. 300 1234567"
                      />
                    </div>
                    {editErrors.emergencyPhone && (
                      <span className="error-text">{editErrors.emergencyPhone}</span>
                    )}
                  </div>
                </div>
              </div>
              )}

              {/* Siblings Tab */}
              {activeEditTab === 'siblings' && (
              <div className="form-section">
                <h4>Siblings</h4>
                {siblings.length > 0 ? (
                <div className="form-section">
                  <h4>Siblings ({siblings.length})</h4>
                  <div className="siblings-list">
                    {loadingSiblings ? (
                      <p>Loading siblings...</p>
                    ) : (
                      <div className="siblings-grid">
                        {siblings.map((sibling) => (
                          <div key={sibling.id} className="sibling-card">
                            <div className="sibling-header">
                              <h5>{sibling.first_name} {sibling.middle_name ? sibling.middle_name + ' ' : ''}{sibling.last_name}</h5>
                            </div>
                            <div className="sibling-details">
                              <p><strong>Email:</strong> {sibling.email || 'N/A'}</p>
                              <p><strong>Class:</strong> {sibling.classes?.class_name || 'N/A'}</p>
                              <p><strong>Section:</strong> {sibling.section_id || 'N/A'}</p>
                              <p><strong>Date of Birth:</strong> {sibling.date_of_birth ? new Date(sibling.date_of_birth).toLocaleDateString() : 'N/A'}</p>
                              <p><strong>Gender:</strong> {sibling.gender || 'N/A'}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                ) : (
                  <p className="no-siblings-text">No siblings found for this student.</p>
                )}
              </div>
              )}

              {/* Teachers Tab */}
              {activeEditTab === 'teachers' && (
              <div className="form-section">
                <h4>Class Teachers</h4>
                {editForm.classId && editForm.sectionId ? (
                <div className="form-section">
                  <h4>Class Teachers ({teachers.length})</h4>
                  <div className="teachers-list">
                    {loadingTeachers ? (
                      <p>Loading teachers...</p>
                    ) : teachers.length > 0 ? (
                      <div className="teachers-grid">
                        {teachers.map((teacher) => (
                          <div key={teacher.id} className="teacher-card">
                            <div className="teacher-header">
                              <h5>{teacher.first_name} {teacher.last_name}</h5>
                            </div>
                            <div className="teacher-details">
                              <p><strong>Email:</strong> {teacher.email || 'N/A'}</p>
                              <p><strong>Phone:</strong> {teacher.phone || 'N/A'}</p>
                              <p><strong>Qualification:</strong> {teacher.qualification || 'N/A'}</p>
                              {teacher.subjects && Array.isArray(teacher.subjects) && teacher.subjects.length > 0 && (
                                <p><strong>Subjects:</strong> {teacher.subjects.join(', ')}</p>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="no-teachers-text">No teachers assigned to this class and section.</p>
                    )}
                  </div>
                </div>
                ) : (
                  <p className="no-teachers-text">Please select a class and section to view teachers.</p>
                )}
              </div>
              )}

              {/* Medical Tab */}
              {activeEditTab === 'medical' && (
              <div className="form-section">
                <h4>E) MEDICAL RECORDS</h4>
                
                <div className="form-row">
                  <div className="form-group full-width">
                    <label htmlFor="editMedicalDetails">Medical Records</label>
                    <div className="medical-records-guidelines">
                      <p className="medical-guideline-text">Please provide the following information:</p>
                      <ol className="medical-guidelines-list">
                        <li>Any known allergies or medical conditions of the student</li>
                        <li>Information on any required medications or treatments</li>
                        <li>Emergency documents</li>
                      </ol>
                    </div>
                    <textarea
                      id="editMedicalDetails"
                      value={editForm.medicalDetails}
                      onChange={(e) => handleEditInputChange('medicalDetails', e.target.value)}
                      placeholder="Enter medical records here..."
                      rows="10"
                      style={{ minHeight: '200px' }}
                    />
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group full-width">
                    <label htmlFor="editEmergencyDocuments">Emergency Documents (PDF, DOC, DOCX, JPG, PNG)</label>
                    <input
                      type="file"
                      id="editEmergencyDocuments"
                      onChange={handleEditEmergencyDocumentsChange}
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                      className={editErrors.emergencyDocuments ? 'error' : ''}
                    />
                    {editErrors.emergencyDocuments && (
                      <span className="error-text">{editErrors.emergencyDocuments}</span>
                    )}
                    {editForm.emergencyDocuments && (
                      <div className="file-selected">
                        <span>Selected: {editForm.emergencyDocuments.name}</span>
                        <span className="file-size">({(editForm.emergencyDocuments.size / 1024 / 1024).toFixed(2)} MB)</span>
                      </div>
                    )}
                    {editForm.emergencyDocumentsUrl && !editForm.emergencyDocuments && (
                      <div className="existing-file" style={{ marginTop: '0.75rem', padding: '0.75rem', background: '#FEF3C7', borderRadius: '6px', border: '1px solid #FDE68A' }}>
                        <span style={{ fontSize: '0.9rem', color: '#92400E', marginRight: '0.5rem' }}>Current document: </span>
                        <a 
                          href={editForm.emergencyDocumentsUrl} 
                          target="_blank" 
                          rel="noopener noreferrer" 
                          onClick={async (e) => {
                            e.preventDefault();
                            const newUrl = await getValidFileUrl(editForm.emergencyDocumentsUrl);
                            if (newUrl) {
                              window.open(newUrl, '_blank');
                            } else {
                              alert('Unable to access emergency documents. Please try again.');
                            }
                          }}
                          style={{ 
                            color: '#D97706', 
                            textDecoration: 'none',
                            fontWeight: '500',
                            fontSize: '0.9rem'
                          }}
                          onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                          onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                        >
                          View Emergency Documents →
                        </a>
                      </div>
                    )}
                    <small className="form-help">
                      Upload emergency medical documents (Max 10MB). Leave empty to keep existing document.
                    </small>
                  </div>
                </div>
              </div>
              )}

              {/* Transport Tab */}
              {activeEditTab === 'transport' && (
              <div className="form-section">
                <h4>G) SCHOOL TRANSPORT SERVICE</h4>
                <div className="transport-service-toggle-container">
                  <label className="transport-service-label">
                    <span>Enable Transport Service</span>
                    <div className="toggle-switch">
                      <input
                        type="checkbox"
                        checked={editForm.transportServiceEnabled}
                        onChange={(e) => handleEditInputChange('transportServiceEnabled', e.target.checked)}
                      />
                      <span className="toggle-slider"></span>
                    </div>
                  </label>
                  <p className="transport-service-help">
                    {editForm.transportServiceEnabled 
                      ? 'Transport service is enabled for this student.' 
                      : 'Transport service is disabled for this student.'}
                  </p>
                  
                  {editForm.transportServiceEnabled && (
                    <div className="form-group" style={{ marginTop: '1.5rem' }}>
                      <label htmlFor="editPickupLocationId">
                        Select Pickup Location <span className="asterisk">*</span>
                      </label>
                      {loadingPickupLocations ? (
                        <div style={{ padding: '0.5rem', color: '#6B7280', fontSize: '0.9rem' }}>
                          Loading pickup locations...
                        </div>
                      ) : pickupLocations.length === 0 ? (
                        <div style={{ 
                          padding: '1rem', 
                          background: '#FEF3C7', 
                          borderRadius: '8px',
                          border: '1px solid #FCD34D',
                          marginTop: '0.5rem'
                        }}>
                          <p style={{ color: '#92400E', margin: 0, fontSize: '0.9rem', marginBottom: '0.5rem' }}>
                            No pickup locations available. Please add pickup locations first.
                          </p>
                          <button
                            type="button"
                            onClick={() => navigate('/school/add-pickup-location')}
                            style={{
                              background: '#FF8C42',
                              color: 'white',
                              border: 'none',
                              padding: '0.5rem 1rem',
                              borderRadius: '6px',
                              fontSize: '0.85rem',
                              cursor: 'pointer'
                            }}
                          >
                            Add Pickup Location
                          </button>
                        </div>
                      ) : (
                        <>
                          <select
                            id="editPickupLocationId"
                            value={editForm.pickupLocationId}
                            onChange={(e) => {
                              handleEditInputChange('pickupLocationId', e.target.value);
                              handleEditInputChange('transportRouteType', '');
                              handleEditInputChange('routeId', '');
                            }}
                            className={editErrors.pickupLocationId ? 'error' : ''}
                            style={{
                              width: '100%',
                              padding: '0.75rem',
                              border: editErrors.pickupLocationId ? '2px solid #EF4444' : '1px solid #D1D5DB',
                              borderRadius: '8px',
                              fontSize: '0.95rem',
                              backgroundColor: '#FFFFFF',
                              marginTop: '0.5rem'
                            }}
                            required={editForm.transportServiceEnabled}
                          >
                            <option value="">-- Select a pickup location --</option>
                            {pickupLocations.map((location) => {
                              const routesInfo = location.routes && location.routes.length > 0
                                ? location.routes.map(r => {
                                    const vehicleInfo = r.vehicle ? ` (Vehicle: ${r.vehicle.bus_number})` : '';
                                    return `${r.route_type}${vehicleInfo}`;
                                  }).join(', ')
                                : '';
                              return (
                                <option key={location.id} value={location.id}>
                                  {location.location_name} - {location.address}
                                  {routesInfo && ` [${routesInfo}]`}
                                </option>
                              );
                            })}
                          </select>
                          {editErrors.pickupLocationId && (
                            <span className="error-text" style={{ display: 'block', marginTop: '0.5rem' }}>
                              {editErrors.pickupLocationId}
                            </span>
                          )}
                          
                          {/* Display route type selection and price information when a location is selected */}
                          {(() => {
                            const selectedLocation = pickupLocations.find(
                              loc => loc.id.toString() === editForm.pickupLocationId
                            );
                            
                            if (!selectedLocation) return null;
                            
                            return (
                              <div style={{ marginTop: '1rem' }}>
                                {/* Route Type Selection */}
                                <div className="form-group" style={{ marginBottom: '1rem' }}>
                                  <label htmlFor="editTransportRouteType">
                                    Select Route Type <span className="asterisk">*</span>
                                  </label>
                                  <select
                                    id="editTransportRouteType"
                                    value={editForm.transportRouteType}
                                    onChange={(e) => {
                                      handleEditInputChange('transportRouteType', e.target.value);
                                      handleEditInputChange('routeId', '');
                                    }}
                                    className={editErrors.transportRouteType ? 'error' : ''}
                                    style={{
                                      width: '100%',
                                      padding: '0.75rem',
                                      border: editErrors.transportRouteType ? '2px solid #EF4444' : '1px solid #D1D5DB',
                                      borderRadius: '8px',
                                      fontSize: '0.95rem',
                                      backgroundColor: '#FFFFFF',
                                      marginTop: '0.5rem'
                                    }}
                                    required={editForm.transportServiceEnabled && editForm.pickupLocationId}
                                  >
                                    <option value="">-- Select route type --</option>
                                      <option value="1 Way">1 Way</option>
                                      <option value="2 Way">2 Way</option>
                                  </select>
                                  {editErrors.transportRouteType && (
                                    <span className="error-text" style={{ display: 'block', marginTop: '0.5rem' }}>
                                      {editErrors.transportRouteType}
                                    </span>
                                  )}
                                </div>
                                
                                {/* Display price information */}
                                {(selectedLocation.price_one_way || selectedLocation.price_two_way) && (
                                  <div style={{
                                    padding: '1rem',
                                    background: '#EFF6FF',
                                    borderRadius: '8px',
                                    border: '1px solid #BFDBFE'
                                  }}>
                                    <div style={{
                                      fontSize: '0.875rem',
                                      fontWeight: '600',
                                      color: '#1E40AF',
                                      marginBottom: '0.75rem'
                                    }}>
                                      Transport Pricing
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                      {selectedLocation.price_one_way && (
                                        <div style={{
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          alignItems: 'center',
                                          padding: '0.5rem',
                                          background: editForm.transportRouteType === '1 Way' ? '#DBEAFE' : 'transparent',
                                          borderRadius: '4px'
                                        }}>
                                          <span style={{ fontSize: '0.875rem', color: '#374151' }}>1 Way:</span>
                                          <span style={{ fontSize: '0.875rem', fontWeight: '600', color: '#1E40AF' }}>
                                            {selectedLocation.currency || 'PKR'} {parseFloat(selectedLocation.price_one_way).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                          </span>
                                        </div>
                                      )}
                                      {selectedLocation.price_two_way && (
                                        <div style={{
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                          alignItems: 'center',
                                          padding: '0.5rem',
                                          background: editForm.transportRouteType === '2 Way' ? '#DBEAFE' : 'transparent',
                                          borderRadius: '4px'
                                        }}>
                                          <span style={{ fontSize: '0.875rem', color: '#374151' }}>2 Way:</span>
                                          <span style={{ fontSize: '0.875rem', fontWeight: '600', color: '#1E40AF' }}>
                                            {selectedLocation.currency || 'PKR'} {parseFloat(selectedLocation.price_two_way).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                          </span>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                                
                                {/* Route Selection Dropdown */}
                                {selectedLocation && selectedLocation.routes && selectedLocation.routes.length > 0 && (
                                  <div className="form-group" style={{ marginTop: '1rem' }}>
                                    <label htmlFor="editRouteId">
                                      Select Route & Vehicle <span className="asterisk">*</span>
                                    </label>
                                    <select
                                      id="editRouteId"
                                      value={editForm.routeId}
                                      onChange={(e) => handleEditInputChange('routeId', e.target.value)}
                                      className={editErrors.routeId ? 'error' : ''}
                                      style={{
                                        width: '100%',
                                        padding: '0.75rem',
                                        border: editErrors.routeId ? '2px solid #EF4444' : '1px solid #D1D5DB',
                                        borderRadius: '8px',
                                        fontSize: '0.95rem',
                                        backgroundColor: '#FFFFFF',
                                        marginTop: '0.5rem'
                                      }}
                                      required={editForm.transportServiceEnabled && editForm.pickupLocationId}
                                    >
                                      <option value="">-- Select a route --</option>
                                      {selectedLocation.routes.map((route) => (
                                        <option key={route.id} value={route.id.toString()}>
                                          {route.route_name || `Route #${route.id}`} - {route.route_type}
                                          {route.vehicle && ` (Vehicle: ${route.vehicle.bus_number})`}
                                          {route.vehicle?.driver_name && ` - Driver: ${route.vehicle.driver_name}`}
                                        </option>
                                      ))}
                                    </select>
                                    {editErrors.routeId && (
                                      <span className="error-text" style={{ display: 'block', marginTop: '0.5rem' }}>
                                        {editErrors.routeId}
                                      </span>
                                    )}
                                  </div>
                                )}
                                
                                {/* Display routes and vehicles for this location */}
                                {selectedLocation.routes && selectedLocation.routes.length > 0 && (
                                  <div style={{
                                    marginTop: '1rem',
                                    padding: '1rem',
                                    background: '#F0FDF4',
                                    borderRadius: '8px',
                                    border: '1px solid #BBF7D0'
                                  }}>
                                    <div style={{
                                      fontSize: '0.875rem',
                                      fontWeight: '600',
                                      color: '#065F46',
                                      marginBottom: '0.75rem'
                                    }}>
                                      Available Routes & Vehicles
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                      {selectedLocation.routes.map((route, idx) => {
                                        const isSelected = editForm.routeId === route.id.toString();
                                        const matchesRouteType = 
                                          (editForm.transportRouteType === '1 Way' && (route.route_type === '1 Way Morning' || route.route_type === '1 Way Evening')) ||
                                          (editForm.transportRouteType === '2 Way' && route.route_type === '2 Way');
                                        
                                        return (
                                          <div key={route.id || idx} style={{
                                            padding: '0.75rem',
                                            background: isSelected ? '#DBEAFE' : '#FFFFFF',
                                            borderRadius: '6px',
                                            border: isSelected ? '2px solid #3B82F6' : (matchesRouteType && editForm.transportRouteType ? '1px solid #A7F3D0' : '1px solid #E5E7EB'),
                                            opacity: editForm.transportRouteType && !matchesRouteType ? 0.5 : 1,
                                            transition: 'all 0.2s'
                                          }}>
                                            <div style={{ fontSize: '0.9rem', fontWeight: '500', color: '#374151' }}>
                                              {route.route_name || `Route #${route.id}`}
                                              {isSelected && <span style={{ marginLeft: '0.5rem', color: '#3B82F6', fontWeight: '600' }}>✓ Selected</span>}
                                            </div>
                                            <div style={{ fontSize: '0.85rem', color: '#6B7280', marginTop: '0.25rem' }}>
                                              Type: {route.route_type}
                                              {route.vehicle && ` • Vehicle: ${route.vehicle.bus_number}`}
                                              {route.vehicle?.driver_name && ` (Driver: ${route.vehicle.driver_name})`}
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                )}
                              </div>
                            );
                          })()}
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
              )}

              {/* Fees & Payment Tab */}
              {activeEditTab === 'fees' && (
              <>
              {/* Payment Method Section */}
              <div className="form-section">
                <h4>Payment Method</h4>
                <div className="payment-method-section">
                  <label className="payment-method-label">Payment Method</label>
                  <div className="payment-method-options">
                    <label className="payment-option">
                      <input
                        type="radio"
                        name="editPaymentMethod"
                        value="Cash"
                        checked={editForm.paymentMethod === 'Cash'}
                        onChange={(e) => handleEditInputChange('paymentMethod', e.target.value)}
                      />
                      <span>a. Cash</span>
                    </label>
                    <label className="payment-option">
                      <input
                        type="radio"
                        name="editPaymentMethod"
                        value="Cheque"
                        checked={editForm.paymentMethod === 'Cheque'}
                        onChange={(e) => handleEditInputChange('paymentMethod', e.target.value)}
                      />
                      <span>b. Cheque</span>
                    </label>
                    <label className="payment-option">
                      <input
                        type="radio"
                        name="editPaymentMethod"
                        value="Mobile money"
                        checked={editForm.paymentMethod === 'Mobile money'}
                        onChange={(e) => handleEditInputChange('paymentMethod', e.target.value)}
                      />
                      <span>c. Any other (Mobile money)</span>
                    </label>
                  </div>
                </div>
              </div>

              {/* Fees Information Section */}
              {editForm.classId && (
                <div className="form-section">
                  <h4>Fees Information</h4>
                  <div className="fees-content">
                    {loadingFees ? (
                      <p className="loading-text">Loading fees...</p>
                    ) : classFees && classFees.length > 0 ? (
                      <div className="fees-list">
                        <div className="fees-header">
                          <h4>Fees for Selected Class</h4>
                        </div>
                        {classFees.map((fee) => {
                          // Calculate transportation fee if enabled
                          const transportFee = editForm.transportServiceEnabled && editForm.pickupLocationId && editForm.transportRouteType
                            ? (() => {
                                const selectedLocation = pickupLocations.find(loc => loc.id.toString() === editForm.pickupLocationId);
                                if (selectedLocation) {
                                  if (editForm.transportRouteType === '1 Way' && selectedLocation.price_one_way) {
                                    return parseFloat(selectedLocation.price_one_way);
                                  } else if (editForm.transportRouteType === '2 Way' && selectedLocation.price_two_way) {
                                    return parseFloat(selectedLocation.price_two_way);
                                  }
                                }
                                return 0;
                              })()
                            : 0;

                          // Calculate monthly breakdown
                          const baseAmount = parseFloat(fee.amount);
                          let monthlyTuition = 0;
                          let feeBreakdown = [];

                          switch (fee.fee_type) {
                            case 'monthly':
                              monthlyTuition = baseAmount;
                              feeBreakdown.push({
                                label: 'Monthly Tuition',
                                amount: baseAmount,
                                period: 'monthly'
                              });
                              break;
                            case 'quarterly':
                              monthlyTuition = baseAmount / 3;
                              feeBreakdown.push({
                                label: 'Quarterly Tuition',
                                amount: baseAmount,
                                period: 'quarterly'
                              });
                              feeBreakdown.push({
                                label: 'Monthly Portion (Quarterly ÷ 3)',
                                amount: monthlyTuition,
                                period: 'monthly'
                              });
                              break;
                            case 'semester':
                              monthlyTuition = baseAmount / 6;
                              feeBreakdown.push({
                                label: 'Semester Tuition',
                                amount: baseAmount,
                                period: 'semester'
                              });
                              feeBreakdown.push({
                                label: 'Monthly Portion (Semester ÷ 6)',
                                amount: monthlyTuition,
                                period: 'monthly'
                              });
                              break;
                            case 'annual':
                              monthlyTuition = baseAmount / 12;
                              feeBreakdown.push({
                                label: 'Annual Tuition',
                                amount: baseAmount,
                                period: 'annual'
                              });
                              feeBreakdown.push({
                                label: 'Monthly Portion (Annual ÷ 12)',
                                amount: monthlyTuition,
                                period: 'monthly'
                              });
                              break;
                          }

                          const totalMonthlyFee = monthlyTuition + transportFee;

                          return (
                            <div key={fee.id} className="fee-item" style={{ marginBottom: '1.5rem', padding: '1rem', border: '1px solid #E5E7EB', borderRadius: '8px', backgroundColor: '#FAFAFA' }}>
                              <div className="fee-details">
                                <p className="fee-type" style={{ marginBottom: '0.5rem' }}>
                                  <strong>{fee.fee_type.charAt(0).toUpperCase() + fee.fee_type.slice(1)} Fee:</strong>
                                </p>
                                <p className="fee-amount" style={{ fontSize: '1.1rem', fontWeight: '600', color: '#059669', marginBottom: '0.5rem' }}>
                                  {fee.currency || 'PKR'} {baseAmount.toLocaleString()}
                                </p>
                                
                                {/* Fee Breakdown */}
                                <div style={{ marginTop: '0.75rem', paddingTop: '0.75rem', borderTop: '1px solid #E5E7EB' }}>
                                  <p style={{ fontSize: '0.9rem', fontWeight: '600', color: '#374151', marginBottom: '0.5rem' }}>
                                    Monthly Breakdown:
                                  </p>
                                  {feeBreakdown.map((breakdown, idx) => (
                                    <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.25rem', fontSize: '0.85rem', color: '#6B7280' }}>
                                      <span>{breakdown.label}:</span>
                                      <span style={{ fontWeight: '500' }}>{fee.currency || 'PKR'} {breakdown.amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                    </div>
                                  ))}
                                  
                                  {/* Transportation Fee */}
                                  {transportFee > 0 && (
                                    <div style={{ 
                                      display: 'flex', 
                                      justifyContent: 'space-between', 
                                      marginTop: '0.5rem',
                                      paddingTop: '0.5rem',
                                      borderTop: '1px solid #E5E7EB'
                                    }}>
                                      <span style={{ fontSize: '0.85rem', color: '#6B7280' }}>Transportation Fee (Monthly):</span>
                                      <span style={{ fontSize: '0.85rem', fontWeight: '500', color: '#EF4444' }}>
                                        {(() => {
                                          const selectedLocation = pickupLocations.find(loc => loc.id.toString() === editForm.pickupLocationId);
                                          return selectedLocation?.currency || 'PKR';
                                        })()} {transportFee.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                      </span>
                                    </div>
                                  )}
                                  
                                  {/* Total Monthly Fee */}
                                  {totalMonthlyFee > 0 && (
                                    <div style={{ 
                                      display: 'flex', 
                                      justifyContent: 'space-between', 
                                      marginTop: '0.75rem',
                                      paddingTop: '0.75rem',
                                      borderTop: '2px solid #059669',
                                      fontSize: '1rem',
                                      fontWeight: '600',
                                      color: '#059669'
                                    }}>
                                      <span>Total Monthly Fee:</span>
                                      <span>
                                        {(() => {
                                          const selectedLocation = pickupLocations.find(loc => loc.id.toString() === editForm.pickupLocationId);
                                          return selectedLocation?.currency || fee.currency || 'PKR';
                                        })()} {totalMonthlyFee.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <p className="fees-placeholder">No fees set for this class yet.</p>
                    )}
                  </div>
                </div>
              )}
              </>
              )}

              {/* Documents Tab */}
              {activeEditTab === 'documents' && (
              <div className="form-section">
                <h4>I) DOCUMENTS</h4>
                <div className="documents-content">
                  <div className="document-upload-section">
                    <div className="document-upload-controls">
                      <label htmlFor="editDocumentTypeSelect" className="document-type-label">Document Type</label>
                      <select
                        id="editDocumentTypeSelect"
                        className="document-type-select"
                        defaultValue=""
                      >
                        <option value="">Select Document Type</option>
                        <option value="Birth Certificate">Birth Certificate</option>
                        <option value="Parent National ID">Parent National ID</option>
                        <option value="Parent Passport">Parent Passport</option>
                        <option value="Academic Transcripts">Academic Transcripts</option>
                        <option value="Previous School Certificate">Previous School Certificate</option>
                        <option value="Medical Certificate">Medical Certificate</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                    <input
                      type="file"
                      id="editDocumentFileInput"
                      className="document-file-input"
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                      style={{ display: 'none' }}
                      onChange={(e) => {
                        const file = e.target.files[0];
                        const typeSelect = document.getElementById('editDocumentTypeSelect');
                        const type = typeSelect.value;
                        if (file && type) {
                          handleEditDocumentAdd(type, file);
                          e.target.value = '';
                          typeSelect.value = '';
                        } else if (file && !type) {
                          alert('Please select a document type first');
                          e.target.value = '';
                        }
                      }}
                    />
                    <button
                      type="button"
                      className="add-document-btn"
                      onClick={() => {
                        const typeSelect = document.getElementById('editDocumentTypeSelect');
                        const type = typeSelect.value;
                        if (!type) {
                          alert('Please select a document type first');
                          return;
                        }
                        document.getElementById('editDocumentFileInput').click();
                      }}
                    >
                      + Add Document
                    </button>
                  </div>
                  
                  {/* Existing Documents */}
                  {editForm.documents && editForm.documents.length > 0 && (
                    <div className="documents-list">
                      <h4>Existing Documents ({editForm.documents.length})</h4>
                      {editForm.documents.map((doc, index) => (
                        <div key={doc.id || index} className="document-item">
                          <div className="document-info">
                            <span className="document-type-badge">{doc.document_type}</span>
                            <a 
                              href={doc.document_url} 
                              target="_blank" 
                              rel="noopener noreferrer" 
                              className="document-name"
                              onClick={async (e) => {
                                e.preventDefault();
                                console.log('Document URL before processing:', doc.document_url);
                                const newUrl = await getValidFileUrl(doc.document_url);
                                console.log('Document URL after processing:', newUrl);
                                if (newUrl) {
                                  window.open(newUrl, '_blank');
                                } else {
                                  alert('Unable to access document. Please try again or contact support.');
                                }
                              }}
                            >
                              {doc.file_name || 'View Document'} →
                            </a>
                            {doc.file_size && (
                              <span className="document-size">({(doc.file_size / 1024 / 1024).toFixed(2)} MB)</span>
                            )}
                          </div>
                          <button
                            type="button"
                            className="remove-document-btn"
                            onClick={() => handleEditDocumentRemove(index, false)}
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                  
                  {/* New Documents */}
                  {editForm.newDocuments && editForm.newDocuments.length > 0 && (
                    <div className="documents-list">
                      <h4>New Documents to Upload ({editForm.newDocuments.length})</h4>
                      {editForm.newDocuments.map((doc, index) => (
                        <div key={`new-${index}`} className="document-item">
                          <div className="document-info">
                            <select
                              value={doc.type}
                              onChange={(e) => handleEditDocumentTypeChange(index, e.target.value, true)}
                              className="document-type-edit"
                            >
                              <option value="Birth Certificate">Birth Certificate</option>
                              <option value="Parent National ID">Parent National ID</option>
                              <option value="Parent Passport">Parent Passport</option>
                              <option value="Academic Transcripts">Academic Transcripts</option>
                              <option value="Previous School Certificate">Previous School Certificate</option>
                              <option value="Medical Certificate">Medical Certificate</option>
                              <option value="Other">Other</option>
                            </select>
                            <span className="document-name">{doc.file.name}</span>
                            <span className="document-size">({(doc.file.size / 1024 / 1024).toFixed(2)} MB)</span>
                          </div>
                          <button
                            type="button"
                            className="remove-document-btn"
                            onClick={() => handleEditDocumentRemove(index, true)}
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                  
                  {(!editForm.documents || editForm.documents.length === 0) && 
                   (!editForm.newDocuments || editForm.newDocuments.length === 0) && (
                    <p className="no-documents-text">No documents uploaded yet.</p>
                  )}
                </div>
              </div>
              )}

              {/* Passwords Tab */}
              {activeEditTab === 'passwords' && (
              <div className="form-section">
                <h4>Password Changes (Optional)</h4>
                <div className="password-change-info">
                  <p>Leave password fields empty if you don't want to change them.</p>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="editStudentPassword">New Student Password</label>
                    <input
                      type="password"
                      id="editStudentPassword"
                      value={editForm.studentPassword}
                      onChange={(e) => handleEditInputChange('studentPassword', e.target.value)}
                      className={editErrors.studentPassword ? 'error' : ''}
                      placeholder="Enter new student password"
                    />
                    {editErrors.studentPassword && (
                      <span className="error-text">{editErrors.studentPassword}</span>
                    )}
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="editStudentConfirmPassword">Confirm Student Password</label>
                    <input
                      type="password"
                      id="editStudentConfirmPassword"
                      value={editForm.studentConfirmPassword}
                      onChange={(e) => handleEditInputChange('studentConfirmPassword', e.target.value)}
                      className={editErrors.studentConfirmPassword ? 'error' : ''}
                      placeholder="Confirm new student password"
                    />
                    {editErrors.studentConfirmPassword && (
                      <span className="error-text">{editErrors.studentConfirmPassword}</span>
                    )}
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="editParentPassword">New Parent Password</label>
                    <input
                      type="password"
                      id="editParentPassword"
                      value={editForm.parentPassword}
                      onChange={(e) => handleEditInputChange('parentPassword', e.target.value)}
                      className={editErrors.parentPassword ? 'error' : ''}
                      placeholder="Enter new parent password"
                    />
                    {editErrors.parentPassword && (
                      <span className="error-text">{editErrors.parentPassword}</span>
                    )}
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="editParentConfirmPassword">Confirm Parent Password</label>
                    <input
                      type="password"
                      id="editParentConfirmPassword"
                      value={editForm.parentConfirmPassword}
                      onChange={(e) => handleEditInputChange('parentConfirmPassword', e.target.value)}
                      className={editErrors.parentConfirmPassword ? 'error' : ''}
                      placeholder="Confirm new parent password"
                    />
                    {editErrors.parentConfirmPassword && (
                      <span className="error-text">{editErrors.parentConfirmPassword}</span>
                    )}
                  </div>
                </div>
              </div>
              )}

              <div className="form-actions">
                <button 
                  type="button" 
                  className="cancel-btn"
                  onClick={closeEditPopup}
                >
                  Cancel
                </button>
                <button 
                  type="submit" 
                  className="submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Updating...' : 'Update Student'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Beautiful Success Popup */}
      {showSuccessPopup && (
        <div 
          className="popup-overlay" 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            animation: 'fadeIn 0.3s ease-in'
          }}
          onClick={() => {
            setShowSuccessPopup(false);
          }}
        >
          <div 
            style={{
              background: '#FFFFFF',
              borderRadius: '20px',
              padding: '3rem',
              maxWidth: '500px',
              width: '90%',
              textAlign: 'center',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
              animation: 'slideUp 0.4s ease-out',
              position: 'relative',
              overflow: 'hidden'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Decorative circles */}
            <div style={{
              position: 'absolute',
              top: '-50px',
              right: '-50px',
              width: '150px',
              height: '150px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.1) 100%)',
              zIndex: 0
            }}></div>
            <div style={{
              position: 'absolute',
              bottom: '-30px',
              left: '-30px',
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.1) 100%)',
              zIndex: 0
            }}></div>

            {/* Success Icon */}
            <div style={{
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 1.5rem',
              boxShadow: '0 10px 25px rgba(16, 185, 129, 0.4)',
              position: 'relative',
              zIndex: 1,
              animation: 'scaleIn 0.5s ease-out'
            }}>
              <span style={{ 
                fontSize: '4rem', 
                color: '#FFFFFF',
                fontWeight: 'bold',
                lineHeight: 1
              }}>✓</span>
            </div>

            {/* Title */}
            <h2 style={{
              color: '#1F2937',
              fontSize: '2rem',
              fontWeight: '700',
              marginBottom: '0.5rem',
              position: 'relative',
              zIndex: 1
            }}>
              Student Updated Successfully! 🎉
            </h2>

            {/* Subtitle */}
            <p style={{
              color: '#6B7280',
              fontSize: '1rem',
              marginBottom: '2rem',
              position: 'relative',
              zIndex: 1,
              lineHeight: '1.6'
            }}>
              {updatedStudentName && (
                <>
                  <strong style={{ color: '#1F2937', fontSize: '1.1rem' }}>{updatedStudentName}</strong>'s details have been successfully updated.
                </>
              )}
              {!updatedStudentName && (
                <>Student details have been successfully updated.</>
              )}
            </p>

            {/* Close Button */}
            <button
              onClick={() => setShowSuccessPopup(false)}
              style={{
                background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                color: '#FFFFFF',
                border: 'none',
                borderRadius: '12px',
                padding: '0.75rem 2rem',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
                position: 'relative',
                zIndex: 1
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 16px rgba(16, 185, 129, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.3)';
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* CSS Animations */}
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        
        @keyframes slideUp {
          from {
            transform: translateY(30px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        
        @keyframes scaleIn {
          from {
            transform: scale(0);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }
        
      `}</style>

      {/* Archive Confirmation Popup */}
      {showArchiveConfirmPopup && studentToArchive && (
        <div 
          className="popup-overlay" 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            animation: 'fadeIn 0.3s ease-in'
          }}
          onClick={cancelArchiveStudent}
        >
          <div 
            style={{
              background: '#FFFFFF',
              borderRadius: '20px',
              padding: '3rem',
              maxWidth: '500px',
              width: '90%',
              textAlign: 'center',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
              animation: 'slideUp 0.4s ease-out',
              position: 'relative',
              overflow: 'hidden'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Decorative circles */}
            <div style={{
              position: 'absolute',
              top: '-50px',
              right: '-50px',
              width: '150px',
              height: '150px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(124, 58, 237, 0.1) 100%)',
              zIndex: 0
            }}></div>
            <div style={{
              position: 'absolute',
              bottom: '-30px',
              left: '-30px',
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(124, 58, 237, 0.1) 100%)',
              zIndex: 0
            }}></div>

            {/* Archive Icon */}
            <div style={{
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 1.5rem',
              boxShadow: '0 10px 25px rgba(139, 92, 246, 0.4)',
              position: 'relative',
              zIndex: 1,
              animation: 'scaleIn 0.5s ease-out'
            }}>
              <span style={{ 
                fontSize: '4rem', 
                color: '#FFFFFF',
                fontWeight: 'bold',
                lineHeight: 1
              }}>📦</span>
            </div>

            {/* Title */}
            <h2 style={{
              color: '#1F2937',
              fontSize: '2rem',
              fontWeight: '700',
              marginBottom: '0.5rem',
              position: 'relative',
              zIndex: 1
            }}>
              Archive Student?
            </h2>

            {/* Message */}
            <p style={{
              color: '#6B7280',
              fontSize: '1rem',
              marginBottom: '1.5rem',
              lineHeight: '1.6',
              position: 'relative',
              zIndex: 1
            }}>
              Are you sure you want to archive <strong>{studentToArchive.first_name} {studentToArchive.last_name}</strong>?
              <br /><br />
              The student will be marked as inactive and hidden from the active students list. You can restore them later if needed.
            </p>

            {/* Buttons */}
            <div style={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'center',
              position: 'relative',
              zIndex: 1
            }}>
              <button
                onClick={cancelArchiveStudent}
                disabled={isSubmitting}
                style={{
                  padding: '0.75rem 2rem',
                  borderRadius: '12px',
                  border: '2px solid #E5E7EB',
                  background: '#FFFFFF',
                  color: '#6B7280',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  opacity: isSubmitting ? 0.5 : 1
                }}
                onMouseEnter={(e) => {
                  if (!isSubmitting) {
                    e.target.style.background = '#F9FAFB';
                    e.target.style.borderColor = '#D1D5DB';
                  }
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = '#FFFFFF';
                  e.target.style.borderColor = '#E5E7EB';
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmArchiveStudent}
                disabled={isSubmitting}
                style={{
                  padding: '0.75rem 2rem',
                  borderRadius: '12px',
                  border: 'none',
                  background: 'linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%)',
                  color: '#FFFFFF',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  opacity: isSubmitting ? 0.5 : 1,
                  boxShadow: '0 4px 12px rgba(139, 92, 246, 0.4)'
                }}
                onMouseEnter={(e) => {
                  if (!isSubmitting) {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 16px rgba(139, 92, 246, 0.5)';
                  }
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 12px rgba(139, 92, 246, 0.4)';
                }}
              >
                {isSubmitting ? 'Archiving...' : 'Archive Student'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Archive Success Popup */}
      {showArchiveSuccessPopup && (
        <div 
          className="popup-overlay" 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            animation: 'fadeIn 0.3s ease-in'
          }}
          onClick={() => setShowArchiveSuccessPopup(false)}
        >
          <div 
            style={{
              background: '#FFFFFF',
              borderRadius: '20px',
              padding: '3rem',
              maxWidth: '500px',
              width: '90%',
              textAlign: 'center',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
              animation: 'slideUp 0.4s ease-out',
              position: 'relative',
              overflow: 'hidden'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Decorative circles */}
            <div style={{
              position: 'absolute',
              top: '-50px',
              right: '-50px',
              width: '150px',
              height: '150px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.1) 100%)',
              zIndex: 0
            }}></div>
            <div style={{
              position: 'absolute',
              bottom: '-30px',
              left: '-30px',
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.1) 100%)',
              zIndex: 0
            }}></div>

            {/* Success Icon */}
            <div style={{
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 1.5rem',
              boxShadow: '0 10px 25px rgba(16, 185, 129, 0.4)',
              position: 'relative',
              zIndex: 1,
              animation: 'scaleIn 0.5s ease-out'
            }}>
              <span style={{ 
                fontSize: '4rem', 
                color: '#FFFFFF',
                fontWeight: 'bold',
                lineHeight: 1
              }}>✓</span>
            </div>

            {/* Title */}
            <h2 style={{
              color: '#1F2937',
              fontSize: '2rem',
              fontWeight: '700',
              marginBottom: '0.5rem',
              position: 'relative',
              zIndex: 1
            }}>
              Student Archived Successfully! 🎉
            </h2>

            {/* Message */}
            <p style={{
              color: '#6B7280',
              fontSize: '1rem',
              marginBottom: '2rem',
              lineHeight: '1.6',
              position: 'relative',
              zIndex: 1
            }}>
              <strong>{archivedStudentName}</strong> has been archived successfully.
              <br />
              The student is now marked as inactive.
            </p>

            {/* Button */}
            <button
              onClick={() => setShowArchiveSuccessPopup(false)}
              style={{
                padding: '0.75rem 2rem',
                borderRadius: '12px',
                border: 'none',
                background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                color: '#FFFFFF',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 12px rgba(16, 185, 129, 0.4)'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 16px rgba(16, 185, 129, 0.5)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.4)';
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {/* Restore Confirmation Popup */}
      {showRestoreConfirmPopup && studentToRestore && (
        <div 
          className="popup-overlay" 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            animation: 'fadeIn 0.3s ease-in'
          }}
          onClick={cancelRestoreStudent}
        >
          <div 
            style={{
              background: '#FFFFFF',
              borderRadius: '20px',
              padding: '3rem',
              maxWidth: '500px',
              width: '90%',
              textAlign: 'center',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
              animation: 'slideUp 0.4s ease-out',
              position: 'relative',
              overflow: 'hidden'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Decorative circles */}
            <div style={{
              position: 'absolute',
              top: '-50px',
              right: '-50px',
              width: '150px',
              height: '150px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.1) 100%)',
              zIndex: 0
            }}></div>
            <div style={{
              position: 'absolute',
              bottom: '-30px',
              left: '-30px',
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.1) 100%)',
              zIndex: 0
            }}></div>

            {/* Restore Icon */}
            <div style={{
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 1.5rem',
              boxShadow: '0 10px 25px rgba(16, 185, 129, 0.4)',
              position: 'relative',
              zIndex: 1,
              animation: 'scaleIn 0.5s ease-out'
            }}>
              <span style={{ 
                fontSize: '4rem', 
                color: '#FFFFFF',
                fontWeight: 'bold',
                lineHeight: 1
              }}>♻️</span>
            </div>

            {/* Title */}
            <h2 style={{
              color: '#1F2937',
              fontSize: '2rem',
              fontWeight: '700',
              marginBottom: '0.5rem',
              position: 'relative',
              zIndex: 1
            }}>
              Restore Student?
            </h2>

            {/* Message */}
            <p style={{
              color: '#6B7280',
              fontSize: '1rem',
              marginBottom: '1.5rem',
              lineHeight: '1.6',
              position: 'relative',
              zIndex: 1
            }}>
              Are you sure you want to restore <strong>{studentToRestore.first_name} {studentToRestore.last_name}</strong>?
              <br /><br />
              The student will be marked as active and will appear in the active students list.
            </p>

            {/* Buttons */}
            <div style={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'center',
              position: 'relative',
              zIndex: 1
            }}>
              <button
                onClick={cancelRestoreStudent}
                disabled={isSubmitting}
                style={{
                  padding: '0.75rem 2rem',
                  borderRadius: '12px',
                  border: '2px solid #E5E7EB',
                  background: '#FFFFFF',
                  color: '#6B7280',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  opacity: isSubmitting ? 0.5 : 1
                }}
                onMouseEnter={(e) => {
                  if (!isSubmitting) {
                    e.target.style.background = '#F9FAFB';
                    e.target.style.borderColor = '#D1D5DB';
                  }
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = '#FFFFFF';
                  e.target.style.borderColor = '#E5E7EB';
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmRestoreStudent}
                disabled={isSubmitting}
                style={{
                  padding: '0.75rem 2rem',
                  borderRadius: '12px',
                  border: 'none',
                  background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                  color: '#FFFFFF',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  opacity: isSubmitting ? 0.5 : 1,
                  boxShadow: '0 4px 12px rgba(16, 185, 129, 0.4)'
                }}
                onMouseEnter={(e) => {
                  if (!isSubmitting) {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 16px rgba(16, 185, 129, 0.5)';
                  }
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.4)';
                }}
              >
                {isSubmitting ? 'Restoring...' : 'Restore Student'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Restore Success Popup */}
      {showRestoreSuccessPopup && (
        <div 
          className="popup-overlay" 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            animation: 'fadeIn 0.3s ease-in'
          }}
          onClick={() => setShowRestoreSuccessPopup(false)}
        >
          <div 
            style={{
              background: '#FFFFFF',
              borderRadius: '20px',
              padding: '3rem',
              maxWidth: '500px',
              width: '90%',
              textAlign: 'center',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
              animation: 'slideUp 0.4s ease-out',
              position: 'relative',
              overflow: 'hidden'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Decorative circles */}
            <div style={{
              position: 'absolute',
              top: '-50px',
              right: '-50px',
              width: '150px',
              height: '150px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.1) 100%)',
              zIndex: 0
            }}></div>
            <div style={{
              position: 'absolute',
              bottom: '-30px',
              left: '-30px',
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.1) 100%)',
              zIndex: 0
            }}></div>

            {/* Success Icon */}
            <div style={{
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 1.5rem',
              boxShadow: '0 10px 25px rgba(16, 185, 129, 0.4)',
              position: 'relative',
              zIndex: 1,
              animation: 'scaleIn 0.5s ease-out'
            }}>
              <span style={{ 
                fontSize: '4rem', 
                color: '#FFFFFF',
                fontWeight: 'bold',
                lineHeight: 1
              }}>✓</span>
            </div>

            {/* Title */}
            <h2 style={{
              color: '#1F2937',
              fontSize: '2rem',
              fontWeight: '700',
              marginBottom: '0.5rem',
              position: 'relative',
              zIndex: 1
            }}>
              Student Restored Successfully! 🎉
            </h2>

            {/* Message */}
            <p style={{
              color: '#6B7280',
              fontSize: '1rem',
              marginBottom: '2rem',
              lineHeight: '1.6',
              position: 'relative',
              zIndex: 1
            }}>
              <strong>{restoredStudentName}</strong> has been restored successfully.
              <br />
              The student is now marked as active.
            </p>

            {/* Button */}
            <button
              onClick={() => setShowRestoreSuccessPopup(false)}
              style={{
                padding: '0.75rem 2rem',
                borderRadius: '12px',
                border: 'none',
                background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                color: '#FFFFFF',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 12px rgba(16, 185, 129, 0.4)'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 16px rgba(16, 185, 129, 0.5)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.4)';
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {/* Delete Confirmation Popup */}
      {showDeleteConfirmPopup && studentToDelete && (
        <div 
          className="popup-overlay" 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            animation: 'fadeIn 0.3s ease-in'
          }}
          onClick={cancelDeleteStudent}
        >
          <div 
            style={{
              background: '#FFFFFF',
              borderRadius: '20px',
              padding: '3rem',
              maxWidth: '500px',
              width: '90%',
              textAlign: 'center',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
              animation: 'slideUp 0.4s ease-out',
              position: 'relative',
              overflow: 'hidden'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Decorative circles */}
            <div style={{
              position: 'absolute',
              top: '-50px',
              right: '-50px',
              width: '150px',
              height: '150px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(220, 38, 38, 0.1) 100%)',
              zIndex: 0
            }}></div>
            <div style={{
              position: 'absolute',
              bottom: '-30px',
              left: '-30px',
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(220, 38, 38, 0.1) 100%)',
              zIndex: 0
            }}></div>

            {/* Delete Icon */}
            <div style={{
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #EF4444 0%, #DC2626 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 1.5rem',
              boxShadow: '0 10px 25px rgba(239, 68, 68, 0.4)',
              position: 'relative',
              zIndex: 1,
              animation: 'scaleIn 0.5s ease-out'
            }}>
              <span style={{ 
                fontSize: '4rem', 
                color: '#FFFFFF',
                fontWeight: 'bold',
                lineHeight: 1
              }}>🗑️</span>
            </div>

            {/* Title */}
            <h2 style={{
              color: '#1F2937',
              fontSize: '2rem',
              fontWeight: '700',
              marginBottom: '0.5rem',
              position: 'relative',
              zIndex: 1
            }}>
              Delete Student?
            </h2>

            {/* Message */}
            <p style={{
              color: '#6B7280',
              fontSize: '1rem',
              marginBottom: '1.5rem',
              lineHeight: '1.6',
              position: 'relative',
              zIndex: 1
            }}>
              Are you sure you want to <strong style={{ color: '#EF4444' }}>PERMANENTLY DELETE</strong> <strong>{studentToDelete.first_name} {studentToDelete.last_name}</strong>?
              <br /><br />
              This will:
              <br />
              • Remove the student from the database completely
              <br />
              • Delete their login account (if exists)
              <br />
              <strong style={{ color: '#EF4444' }}>This action CANNOT be undone!</strong>
            </p>

            {/* Buttons */}
            <div style={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'center',
              position: 'relative',
              zIndex: 1
            }}>
              <button
                onClick={cancelDeleteStudent}
                disabled={isSubmitting}
                style={{
                  padding: '0.75rem 2rem',
                  borderRadius: '12px',
                  border: '2px solid #E5E7EB',
                  background: '#FFFFFF',
                  color: '#6B7280',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  opacity: isSubmitting ? 0.5 : 1
                }}
                onMouseEnter={(e) => {
                  if (!isSubmitting) {
                    e.target.style.background = '#F9FAFB';
                    e.target.style.borderColor = '#D1D5DB';
                  }
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = '#FFFFFF';
                  e.target.style.borderColor = '#E5E7EB';
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmDeleteStudent}
                disabled={isSubmitting}
                style={{
                  padding: '0.75rem 2rem',
                  borderRadius: '12px',
                  border: 'none',
                  background: 'linear-gradient(135deg, #EF4444 0%, #DC2626 100%)',
                  color: '#FFFFFF',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  opacity: isSubmitting ? 0.5 : 1,
                  boxShadow: '0 4px 12px rgba(239, 68, 68, 0.4)'
                }}
                onMouseEnter={(e) => {
                  if (!isSubmitting) {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 16px rgba(239, 68, 68, 0.5)';
                  }
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 12px rgba(239, 68, 68, 0.4)';
                }}
              >
                {isSubmitting ? 'Deleting...' : 'Delete Permanently'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Success Popup */}
      {showDeleteSuccessPopup && (
        <div 
          className="popup-overlay" 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            animation: 'fadeIn 0.3s ease-in'
          }}
          onClick={() => setShowDeleteSuccessPopup(false)}
        >
          <div 
            style={{
              background: '#FFFFFF',
              borderRadius: '20px',
              padding: '3rem',
              maxWidth: '500px',
              width: '90%',
              textAlign: 'center',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
              animation: 'slideUp 0.4s ease-out',
              position: 'relative',
              overflow: 'hidden'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Decorative circles */}
            <div style={{
              position: 'absolute',
              top: '-50px',
              right: '-50px',
              width: '150px',
              height: '150px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.1) 100%)',
              zIndex: 0
            }}></div>
            <div style={{
              position: 'absolute',
              bottom: '-30px',
              left: '-30px',
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.1) 100%)',
              zIndex: 0
            }}></div>

            {/* Success Icon */}
            <div style={{
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 1.5rem',
              boxShadow: '0 10px 25px rgba(16, 185, 129, 0.4)',
              position: 'relative',
              zIndex: 1,
              animation: 'scaleIn 0.5s ease-out'
            }}>
              <span style={{ 
                fontSize: '4rem', 
                color: '#FFFFFF',
                fontWeight: 'bold',
                lineHeight: 1
              }}>✓</span>
            </div>

            {/* Title */}
            <h2 style={{
              color: '#1F2937',
              fontSize: '2rem',
              fontWeight: '700',
              marginBottom: '0.5rem',
              position: 'relative',
              zIndex: 1
            }}>
              Student Deleted Successfully! 🎉
            </h2>

            {/* Message */}
            <p style={{
              color: '#6B7280',
              fontSize: '1rem',
              marginBottom: '2rem',
              lineHeight: '1.6',
              position: 'relative',
              zIndex: 1
            }}>
              <strong>{deletedStudentName}</strong> has been permanently deleted from the database.
            </p>

            {/* Button */}
            <button
              onClick={() => setShowDeleteSuccessPopup(false)}
              style={{
                padding: '0.75rem 2rem',
                borderRadius: '12px',
                border: 'none',
                background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
                color: '#FFFFFF',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 12px rgba(16, 185, 129, 0.4)'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 16px rgba(16, 185, 129, 0.5)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.4)';
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Students;
